<template>
    <div class="container">
      <div>
        <div>
          <div class="queryForm">
            <div class="search-box common-law-limit-box">
              <div class="search-list">
                <span class="law-limit-left">商品目录：</span>
                <div
                  class="active law-limit-con1"
                  :class="{ cate_expand: isOpened }"
                >
                  <a
                    class="common-law-limit law-limit-fixed law-limit-float"
                    v-for="(item, index) in catesList"
                    :key="index"
                    @click="querSelectedIndex(item.id, index)"
                    :class="{ active: item.id == queryParam.categoryPid }"
                  >
                    <div class="law-limit-cover">
                      <el-image class="img28" :src="item.prcUrl" lazy></el-image>
                    </div>
                    <em class="law-limit-txt">{{ item.categoryName }}</em>
                    <!-- <b class="annive-icon">目录</b> -->
                  </a>
                </div>
  
                <template v-if="childrenList.length > 0">
                  <div style="margin-top: 10px">
                    <span class="law-limit-left">商品分类：</span>
                    <div
                      class="active law-limit-con2"
                      :class="{ cate_expand: isOpened }"
                    >
                      <a
                        class="common-law-limit law-limit-fixed law-limit-float"
                        v-for="(value, index) in childrenList"
                        :key="index"
                        @click="toProductList(value.id, index)"
                        :class="{ active: value.id == queryParam.categoryId }"
                      >
                        <div class="law-limit-cover">
                          <el-image
                            class="img28"
                            :src="value.prcUrl"
                            lazy
                          ></el-image>
                        </div>
                        <em class="law-limit-txt">{{ value.categoryName }}</em>
                      </a>
                    </div>
                  </div>
                </template>
  
                <!-- 无 active 类显示收起,有 active 类显示展开 -->
                <div class="hot-sel active" @click="toggleOpenClose">
                  {{ isOpened ? "收起" : "全部" }}
                  <span class="search-sprites search-sprites-arrow"></span>
                </div>
              </div>
  
              <!-- 筛选项 -->
              <div class="search-list">
                <span class="title">商品名称：</span>
                <div class="game-search con">
                  <div class="se-election">
                    <div class="se-election-game">
                      <a-input-search
                        v-model="queryParam.searchKeyword"
                        placeholder="请输入商品名称"
                        enter-button
                        @search="handleQueryByName"
                      />
                    </div>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </div>
  
          <!--  -->
          <div class="zhw-goods">
            <div class="orderby-search clearfix">
              <div class="orderby-list">
                <ul class="clearfix">
                  <li
                    :class="queryParam.orderType === undefined ? 'cur' : ''"
                    @click="handleQuery(undefined)"
                  >
                    综合排序
                  </li>
                  <li
                    :class="queryParam.orderType === 1 ? 'cur' : ''"
                    @click="handleQuery(1)"
                  >
                    销量排序
                  </li>
                  <li
                    :class="queryParam.orderType === 2 ? 'cur' : ''"
                    @click="handleQuery(2)"
                  >
                    价格排序
                  </li>
                </ul>
              </div>
            </div>
  
            <a-spin :spinning="loadingState">
              <div
                class="goods-wrap goods-wrap202306"
                style="min-height: 400px; background-color: #ffffff"
              >
                <div class="goods-box">
                  <div class="goods-list">
                    <ul>
                      <li
                        v-for="(item, k, i) in goodsList"
                        :key="i"
                        @click="toProductDetails(item)"
                      >
                        <a class="game-item202306">
                          <div class="goods-img">
                            <div class="list-img">
                              <img class="table-img" :src="item.picUrl" alt="" />
                              <i class="goods-img-num">+1</i>
                            </div>
                            <div class="gamename">
                              <span class="gamenameA"></span>
                            </div>
                          </div>
                          <div class="goods-info-price">
                            <div class="goods-info">
                              <div class="goods-fix-height">
                                <div class="goods-title">
                                  <span class="goods-title-con">{{
                                    item.productName
                                  }}</span>
                                </div>
                                <div class="goods-game-info">
                                  商品编号：<span class="area">{{
                                    item.id
                                  }}</span>
                                  <!-- <span class="hidden_hot">待用 </span> -->
                                </div>
                              </div>
                              <div class="goods-flags clearfix">
                                <div
                                  class="flag flag-szq"
                                  v-if="item.inventoryQuantity"
                                >
                                  <i class="icon"></i>库存：{{
                                    item.inventoryQuantity
                                  }}
                                </div>
  
                                <div class="flag flag-szq" v-if="item.salsCount">
                                  <i class="icon"></i>销量：{{ item.salsCount }}
                                </div>
                              </div>
                            </div>
                            <div class="goods-price">
                              <div class="goods-price-nei">
                                <div class="price-rent">
                                  {{ item.price }}
                                  <span class="price-symbol"> 元</span>
                                </div>
                                <div class="price-vip-new" v-if="item.parValue">
                                  {{ item.parValue }}元
                                  <span class="product_yuanjia">原价</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="goods-control">
                            <button
                              class="btn-all"
                              style="background-color: #ffffff"
                            >
                              立即购买
                            </button>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
  
                <!-- 加载更多 -->
                <div style="text-align: center; padding: 20px 0px">
                  <template v-if="!finished">
                    <a-button type="primary" @click="loadMore">
                      加载更多...
                    </a-button>
                  </template>
  
                  <template v-else>
                    <span style="color: #777; font-size: 14px"> 没有更多了 </span>
                  </template>
                </div>
              </div>
            </a-spin>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { mapGetters, mapState } from "vuex";
  import { queryProducCategorytList } from "@/api/index";
  
  export default {
    data() {
      return {
        productClassType: 1,
  
        childrenList: [],
  
        catesList: [],
        goodsLabelList: [],
        goodsList: [],
        queryParam: {
          goodsId: undefined,
          orderType: undefined,
          categoryId: undefined,
          categoryPid: undefined,
          pageNum: 1,
          pageSize: 10,
          searchKeyword: undefined,
        },
  
        loadingState: false,
        finished: false,
  
        isFetching: false, // 是否有正在进行中的请求
  
        isOpened: false,
      };
    },
    components: {
      // Header,
    },
    computed: {
      ...mapGetters({}),
      ...mapState({
        productList: (state) => state.index.productList,
        producCategorytList: (state) => state.index.producCategorytList,
      }),
    },
    created() {
      document.title = "商品列表";
  
      this.queryParam.categoryPid = this.$route.query.categoryPid;
      this.queryParam.categoryId = this.$route.query.categoryId;
  
      //查询一级分类
      this.queryCategorytList();
  
      this.getProductList();
    },
  
    methods: {
      /**
       * 加载更多
       */
      loadMore() {
        if (this.isFetching) {
          // 如果有正在进行中的请求，则不继续发起新的请求
          return;
        }
        this.queryParam.pageNum = this.queryParam.pageNum + 1;
        this.loadingState = true;
        this.getProductList();
      },
  
      //查询商品列表
      getProductList() {
        this.isFetching = true;
  
        // this.queryParam.searchKeyword = this.$route.query.goodsName,
  
        this.$store
          .dispatch("index/queryProductList", this.queryParam)
          .then(() => {
            this.goodsList = this.goodsList.concat(this.productList.productList);
            if (this.productList.productList.length == 0) {
              this.finished = true;
            }
            this.loadingState = false;
            this.isFetching = false;
          });
      },
  
      /**
       * 条件排序查询
       */
      handleQuery(val) {
        this.queryParam.orderType = val;
  
        this.queryParam.pageNum = 1;
  
        this.goodsList = [];
        this.finished = false;
  
        this.loadingState = true;
  
        this.getProductList();
      },
  
      /**
       * 根据名称条件查询
       */
      handleQueryByName() {
        this.queryParam.pageNum = 1;
  
        this.queryParam.goodsId = undefined;
        this.queryParam.orderType = undefined;
        this.queryParam.categoryId = undefined;
        this.queryParam.categoryPid = undefined;
  
        this.goodsList = [];
  
        this.getProductList();
      },
  
      /**
       * 点击一级目录
       */
      querSelectedIndex(categoryId, index) {
        if (this.catesList[index].children) {
          this.childrenList = this.catesList[index].children;
        }
  
        this.queryParam.categoryPid = categoryId;
        this.queryParam.categoryId = undefined;
  
        this.goodsList = [];
        this.queryParam.pageNum = 1;
        this.finished = false;
  
        this.loadingState = true;
        this.getProductList();
      },
  
      /**
       * 点击二级目录
       */
      toProductList(id) {
        this.queryParam.categoryPid = undefined;
        this.queryParam.categoryId = id;
  
        this.goodsList = [];
        this.queryParam.pageNum = 1;
        this.finished = false;
  
        this.loadingState = true;
        this.getProductList();
      },
  
      /**
       * 查询商品分类
       */
      queryCategorytList() {
        queryProducCategorytList({})
          .then((res) => {
            this.catesList = res.result.list;
  
            this.childrenList = this.catesList[0].children;
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            //查询二级分类
            this.queryTwoCategoryList();
          });
      },
  
      /**
       * 查询二级分类
       */
      queryTwoCategoryList() {
        for (let item of this.catesList) {
          if (item.id == this.queryParam.categoryPid) {
            console.log(item);
            this.childrenList = item.children;
            break;
          }
        }
      },
  
      /**
       * 一级分类展开
       */
      toggleOpenClose() {
        this.isOpened = !this.isOpened;
      },
  
      //跳转商品详情界面
      toProductDetails(v) {
        this.$router.push(`/pgoodsDetail/${v.id}`);
      },
    },
  };
  </script>
  <style scoped>
  .zhw-main {
    position: relative;
    margin-top: 24px;
  }
  
  .zhw-main-box {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    z-index: 2;
  }
  
  .tiyan-banner {
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  
  .tiyan-banner img {
    width: 100%;
    display: block;
  }
  
  .xinrenli {
    width: 120px;
    height: 140px;
    position: absolute;
    top: 20px;
    right: -120px;
    z-index: 10;
    overflow: hidden;
    cursor: pointer;
  }
  
  .xinrenli a {
    display: block;
    height: 100%;
    width: 100%;
  }
  
  .xinrenli a:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
  
  .xinrenli iframe {
    position: relative;
    z-index: 1;
    display: block;
    width: 100%;
    height: 100%;
  }
  
  .dnf-mobile-box {
    display: none;
    position: fixed;
    top: 300px;
    z-index: 999;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .dnf-mobile-box,
  .dnf-mobile-box img {
    width: 230px;
    height: 317px;
  }
  
  .dnf-mobile-box i.close {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    position: absolute;
    left: 105px;
    bottom: 10px;
    cursor: pointer;
  }
  
  .queryForm {
    background: #fff;
    margin-top: 10px;
    border-radius: 8px;
  }
  
  .queryForm .select-box {
    min-height: 48px;
    line-height: 48px;
    font-size: 12px;
    border-bottom: 1px solid #f5f5f5;
    display: none;
  }
  
  .queryForm .select-title {
    float: left;
    width: 88px;
    padding-right: 15px;
    text-align: right;
    font-size: 14px;
    color: #888;
  }
  
  .queryForm .select-params {
    float: left;
    min-width: 800px;
    max-width: 960px;
    padding-top: 12px;
  }
  
  .queryForm .select-params span {
    float: left;
    height: 24px;
    line-height: 24px;
    margin-right: 10px;
    border: 1px solid #ccd2de;
    background: #f3f6fc;
    border-radius: 4px;
    padding: 0 26px 0 12px;
    font-weight: 400;
    color: #262626;
    position: relative;
    margin-bottom: 12px;
  }
  
  .queryForm .select-params span:hover {
    color: #fc3737;
    border-color: #fc3737;
    background: #fff;
  }
  
  .queryForm .select-params span i {
    width: 14px;
    height: 14px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAQxJREFUOE+tksFqwkAQhv/ZHgQv0mPRF/JaKFgQhGoCQjXeGn2Amt6MCkKighCoIHjtC1l6LF4ED92RqUQ2iT1UnNOy83//zuwM4cKgCzkkwHKrlfsYjfbnzGzbKwSBu41zJ1ASnMcXg6rTwcvahC3Hs0DwNz+ft7Fx4kURMPFYMaqB310JXO/0nwiYAOrRNMz0eBTShDRqGjpHSgWK+WSUKdUsrd5+rQkgd2IQDt1luu+zv2q1vQorLETMWtuzYe/3bEYGtJ3+gyaKBFBQezFgcHM26M7/BBudt3uA303h0QgRMT2HvhtmepQZlm6K32A4pkCEYkjgiHa4i2eZKDU9ZLO09HJcZ+X+s7cHm9dwD1QtFjcAAAAASUVORK5CYII=)
      no-repeat;
    background-size: 100% 100%;
    top: 5px;
  }
  
  .queryForm .select-params i,
  .queryForm .select-params label {
    display: inline-block;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    cursor: pointer;
    position: absolute;
    right: 5px;
    top: 3px;
  }
  
  .queryForm .select-clear {
    float: right;
    padding-right: 20px;
    cursor: pointer;
  }
  
  .queryForm .select-clear:hover {
    color: #fc3737;
  }
  
  .queryForm .select-clear:hover .search-sprite-del {
    background-position: -29px -7px;
  }
  
  .queryForm .search-sprite-del {
    width: 13px;
    height: 16px;
    background-position: -12px -7px;
    vertical-align: middle;
    margin-right: 11px;
    position: relative;
    top: -2px;
  }
  
  .queryForm .search-box {
    padding-top: 16px;
    border-radius: 8px;
  }
  
  .queryForm .search-box .search-list .law-limit-con1 {
    margin-top: 0;
  }
  
  .queryForm .search-box .senior-search,
  .queryForm .search-list {
    border-bottom: 1px solid #f5f5f5;
  }
  
  .queryForm .search-list {
    background: #fff;
    position: relative;
  }
  
  .queryForm .search-list .title {
    float: left;
    display: block;
    width: 88px;
    height: 60px;
    line-height: 60px;
    /* padding-right: 15px; */
    text-align: right;
    color: #888;
  }
  
  .queryForm .search-list .title.advance-title {
    position: relative;
    top: 10px;
  }
  
  .queryForm .search-list .con {
    float: left;
    max-width: 1090px;
  }
  
  .queryForm .search-list .con.con-img {
    margin-top: 14px;
    max-height: 156px;
    overflow: hidden;
  }
  
  .queryForm .search-list .con.game-search {
    position: relative;
    padding-top: 15px;
    padding-bottom: 10px;
  }
  
  .queryForm .search-list .con-img a {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    position: relative;
    float: left;
    width: 106px;
    height: 60px;
    text-align: center;
    line-height: 58px;
    margin-right: 20px;
    margin-bottom: 18px;
    background-color: #fff;
    border: 1px solid #eee;
    overflow: hidden;
  }
  
  .queryForm .search-list .con-img a.active {
    border: 2px solid #fc3737;
    line-height: 58px;
  }
  
  .queryForm .search-list .con-img a.active span {
    top: 0;
    left: 0;
    display: block;
  }
  
  .queryForm .search-list .con-img a:hover {
    border-color: #fc3737;
  }
  
  .queryForm .search-list .con-img a img {
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
    margin-top: -3px;
  }
  
  .queryForm .search-list .con-img a span {
    display: block;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 5px;
    width: 100%;
    height: 100%;
    font-weight: 700;
    color: #fc3737;
    background-color: hsla(0, 0%, 100%, 0.92);
    text-align: center;
    line-height: 100%;
    line-height: 60px;
    position: absolute;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  
  .queryForm .search-list .hot-sel {
    width: 46px;
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 20px;
    font-size: 12px;
  }
  
  .queryForm .search-list .hot-sel.active .txt1 {
    display: none;
  }
  
  .queryForm .search-list .hot-sel.active .txt2 {
    display: inline-block;
  }
  
  .queryForm .search-list .hot-sel.active .search-sprites-arrow {
    background-position: -51px -12px;
  }
  
  .queryForm .search-list .hot-sel .txt1 {
    display: inline-block;
    color: #878787;
  }
  
  .queryForm .search-list .hot-sel .txt2 {
    display: none;
    color: #878787;
  }
  
  .queryForm .search-list .hot-sel .search-sprites-arrow {
    width: 12px;
    height: 8px;
    margin-left: 5px;
    background-position: -71px -12px;
    position: relative;
    top: -1px;
  }
  
  .queryForm .search-list .hot-game {
    display: none;
    margin-left: 104px;
    max-height: 0;
    overflow: hidden;
    -webkit-transition: max-height 0.5s;
    -moz-transition: max-height 0.5s;
    transition: max-height 0.5s;
  }
  
  .queryForm .search-list .hot-game.active {
    max-height: 66px;
  }
  
  .queryForm .search-list .hot-game li {
    float: left;
    margin-right: 48px;
    margin-bottom: 14px;
  }
  
  .queryForm .search-list .hot-game li a {
    display: block;
    color: #828282;
  }
  
  .queryForm .search-list .hot-game li a.active,
  .queryForm .search-list .hot-game li a:hover {
    color: #fc3737;
  }
  
  .queryForm .search-list .law-limit-con1 .annive-icon {
    right: 0;
    top: 0;
    padding: 0 2px;
    line-height: 14px;
    border-radius: 0 1px 0 6px;
    font-size: 10px;
    position: absolute;
    background: -webkit-gradient(
      linear,
      right top,
      left top,
      from(#fc1d60),
      to(#fd7b61)
    );
    background: -webkit-linear-gradient(right, #fc1d60, #fd7b61);
    background: -moz-linear-gradient(right, #fc1d60 0, #fd7b61 100%);
    background: linear-gradient(270deg, #fc1d60, #fd7b61);
    color: #fff;
    font-weight: 400;
  }
  
  .queryForm .game-search-list {
    border-bottom: 0;
  }
  
  .queryForm .game-search-list .conphone {
    padding-top: 15px;
  }
  
  .queryForm .game-search-list .conphone .label-item {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #4d4d4d;
    margin-right: 30px;
    cursor: pointer;
  }
  
  .queryForm .game-search-list .conphone .active,
  .queryForm .game-search-list .conphone .select {
    font-weight: 700;
    color: #ff2828;
  }
  
  .queryForm .price-search-list .conphone .price-ipt-box {
    margin-top: -2px;
  }
  
  .queryForm .price-search-list .conphone .price-ipt-box em {
    margin: 0 8px 0 10px;
  }
  
  .queryForm .price-search-list .conphone .price-ipt-box .price-input {
    width: 100px;
    height: 32px;
    background: #fff;
    border: 1px solid #ddd;
    text-align: center;
    vertical-align: -1px;
    border-radius: 4px;
  }
  
  .queryForm .price-search-list .conphone .price-ipt-box .price-input-search {
    width: 58px;
    height: 32px;
    background: #ff2828;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    color: #fff;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-left: 10px;
  }
  
  .queryForm .search_bar_in {
    text-align: center;
    line-height: 30px;
    float: left;
    display: inline;
    margin: 0 15px 0 0;
  }
  
  .queryForm .search_bar_in p {
    cursor: pointer;
    font-size: 14px;
    line-height: 32px;
    color: #a8a8a8;
    text-align: left;
    height: 32px;
    border: 1px solid #d0d0d0;
    padding-right: 14px;
  }
  
  .queryForm .search_bar_in p.active {
    border-color: #aeaeae;
  }
  
  .queryForm .search_bar_in p.active > span {
    color: #555;
  }
  
  .queryForm .search_bar_in p > span {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    max-width: 150px;
    padding-left: 14px;
    color: #a8a8a8;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  
  .queryForm .search_bar_in p.active .set-triangle {
    background-position: -31px -53px;
  }
  
  .queryForm .set-triangle {
    width: 6px;
    height: 5px;
    display: inline-block;
    margin-left: 8px;
    position: relative;
    top: -13px;
    background-position: -21px -53px;
  }
  
  .queryForm .conphone {
    height: 46px;
    line-height: 30px;
    padding-top: 17px;
  }
  
  .queryForm .conphone img.ser_a,
  .queryForm .conphone img.ser_p {
    display: inline-block;
  }
  
  .queryForm .conphone .active img.ser_a,
  .queryForm .conphone .active img.ser_p,
  .queryForm .conphone img.ser_a1,
  .queryForm .conphone img.ser_p1 {
    display: none;
  }
  
  .queryForm .conphone .active img.ser_a1,
  .queryForm .conphone .active img.ser_p1 {
    display: inline-block;
  }
  
  .queryForm .phoneBox {
    margin-right: 10px;
    position: relative;
    float: left;
    width: 85px;
    height: 25px;
    z-index: 1;
    line-height: 25px;
  }
  
  .queryForm .phoneBox label {
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 25px;
    z-index: 3;
    display: block;
    line-height: 25px;
    cursor: pointer;
  }
  
  .queryForm .phoneBox input {
    display: inline-block;
    vertical-align: middle;
    height: 30px;
    line-height: 30px;
    margin: 0;
  }
  
  .queryForm .phoneBox .btn {
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    width: 85px;
    height: 25px;
    z-index: 2;
    display: block;
    line-height: 25px;
    color: #666;
  }
  
  .queryForm .phoneBox .btn i {
    display: inline-block;
    width: 22px;
    height: 26px;
    margin-right: 7px;
    background: no-repeat 0 0;
    vertical-align: middle;
  }
  
  .queryForm .phoneBox.android i {
    background-image: url(data:image/png;base64,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);
  }
  
  .queryForm .phoneBox.ios i {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxNUQwRkI0MzE5RTMxMUU3OUJGMjhDNkYzMzVERjY1NSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxNUQwRkI0NDE5RTMxMUU3OUJGMjhDNkYzMzVERjY1NSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjE1RDBGQjQxMTlFMzExRTc5QkYyOEM2RjMzNURGNjU1IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjE1RDBGQjQyMTlFMzExRTc5QkYyOEM2RjMzNURGNjU1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+9TdKzQAAAYBJREFUeNqs1c8rBGEcx/H9VQrl4OLgIP+AH8mBm4tSJITCQeLiSqMc5OCiJEIO5LCUlIsD7UFSykHKave0KaWoLaUIkR/vp75TT08zmfHst15tM/PMZ5555nmejTqOEwlRpejACPaxZjZIhAgrxzp65Djl1SgWMCyORS3sBts2gc0Y0o5Xce/VMOgrj8lvDstY8WsYNPAIWSzhFS0owbO8/p1fYBPaUYU3nOMQO3J9FP1oRLEWeCAPe9ID52WcKrRzw7iSm6pRZ3SgDPWiT92fkC84g0mf160Vf9U3ojF56nTErpIyrpeqh4Mhpo9X5WW48u48bLDs3S4y+sSutAzMmCvlxzIwbgbeWga2moE5y8BO9OqBxxH7WkCbG3giS8im1Ifdw5QKfMRGAXqpNosJFfiFTXwUIHTWXSFZme02dY0tfcnNyVb1n/rEOF70wHfZrlLGuQvZ8v1mg/qg3Tjz2mDVAh+Q/xA1yGk8yC5dhBp0yWRW109lyqTdgF8BBgCdsku7TAdoHgAAAABJRU5ErkJggg==);
  }
  
  .queryForm .phoneBox.active span,
  .queryForm .phoneBox:hover span {
    color: #fc3737;
  }
  
  .queryForm .phoneBox.active.android i,
  .queryForm .phoneBox:hover.android i {
    background-image: url(data:image/png;base64,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);
  }
  
  .queryForm .phoneBox.active.ios i,
  .queryForm .phoneBox:hover.ios i {
    background-image: url(data:image/png;base64,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);
  }
  
  .queryForm .hot-recommend {
    display: inline-block;
  }
  
  .queryForm .hot-recommend ul {
    width: 1096px;
    max-width: 1200px;
    position: relative;
    float: left;
    padding: 18px 0 10px;
  }
  
  .queryForm .hot-recommend li {
    width: auto;
    height: 24px;
    padding: 0 16px;
    margin: 0 16px 10px 0;
    line-height: 24px;
    color: #555;
    display: inline-block;
    font-size: 14px;
    background-color: #f5f5f5;
    cursor: pointer;
    border-radius: 2px;
    -webkit-transition: background-color 0.3s, color 0.3s;
    -moz-transition: background-color 0.3s, color 0.3s;
    transition: background-color 0.3s, color 0.3s;
  }
  
  .queryForm .hot-recommend li.active,
  .queryForm .hot-recommend li:hover {
    background-color: #fc3737;
    color: #fff;
  }
  
  .waiter-title {
    color: #fff;
    font-size: 15px;
    line-height: 40px;
    padding: 0 30px;
    border-radius: 5px;
    text-align: center;
    background-color: #fa6458;
    -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    z-index: 10000;
  }
  
  .new-waiter-title {
    line-height: 1.8;
    min-height: 40px;
  }
  
  .new-waiter-title.waiter-title .web_label {
    top: 0;
  }
  
  .waiter-title-1 {
    display: none;
    -webkit-animation: postionanimationL 0.6s ease-in-out;
    -moz-animation: postionanimationL 0.6s ease-in-out;
    animation: postionanimationL 0.6s ease-in-out;
    position: absolute;
    left: -180px;
    top: 150px;
  }
  
  .waiter-title-2 {
    display: none;
    position: absolute;
    top: 58px;
    left: -290px;
  }
  
  .waiter-title:before {
    content: "";
    display: block;
    width: 15px;
    height: 15px;
    position: absolute;
    right: -5px;
    top: 13px;
    background-color: #fa6458;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  
  .waiter-title span {
    color: #fef58c;
    font-size: 15px;
  }
  
  .waiter-title .web_label {
    position: absolute;
    top: -10px;
    right: 5px;
    font-size: 13px;
    cursor: pointer;
  }
  
  .game-search {
    width: 1096px;
    max-width: 1200px;
    position: relative;
  }
  
  .game-search .se-election-game .game_text,
  .game-search .se-election-region .game_text,
  .game-search .se-election-server .game_text {
    border: 1px solid #d0d0d0;
    padding-right: 14px;
    padding-left: 14px;
    height: 32px;
    cursor: pointer;
    line-height: 32px;
    font-size: 14px;
    color: #a8a8a8;
    border-radius: 4px;
  }
  
  .game-search .se-election-game .game_text span,
  .game-search .se-election-region .game_text span,
  .game-search .se-election-server .game_text span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 150px;
    float: left;
  }
  
  .game-search .se-election-game .game_text.active,
  .game-search .se-election-region .game_text.active,
  .game-search .se-election-server .game_text.active {
    border-color: #aeaeae;
    color: #666;
  }
  
  .game-search .se-election-region,
  .game-search .se-election-server {
    float: left;
    max-width: 135px;
    text-align: right;
    margin-left: 15px;
  }
  
  .game-search .se-election-region .game_text span,
  .game-search .se-election-server .game_text span {
    max-width: 84px;
  }
  
  .game-search .se-election .game_text.game_text_onsel {
    border-color: #ff5b5b;
  }
  
  .game-search .se-election .game_text.game_text_onsel span {
    color: #ff5b5b;
  }
  
  .game-search .zhw-search-game {
    float: left;
    max-width: 156px;
    text-align: right;
  }
  
  .game-search .zhw-search-region {
    float: left;
    max-width: 92px;
    text-align: right;
  }
  
  .game-search .fr.act_color .zhw-search-game,
  .game-search .fr.act_color .zhw-search-region,
  .game-search .fr.act_color .zhw-search-server {
    color: #606060;
  }
  
  .game-search .zhw-se-val::-webkit-input-placeholder {
    color: #aaa;
  }
  
  .game-search .zhw-se-val {
    border: none;
    margin: 5px 14px;
    width: 300px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    height: 32px;
    padding-left: 4px;
    font-size: 12px;
    font-weight: 400;
  }
  
  .game-search .zhw-se-btn {
    width: 102px;
    height: 46px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    line-height: 17px;
    background-color: #fc3737;
    border: none;
    cursor: pointer;
    letter-spacing: 4px;
  }
  
  .game-search .se-focus-toggle {
    width: 432px;
    min-height: 216px;
    padding-bottom: 20px;
    border: 1px solid #fc3737;
    position: absolute;
    left: -2px;
    top: 50px;
    z-index: 99;
    background-color: #fff;
    display: none;
    height: auto !important;
  }
  
  .game-search .se-focus-flex {
    width: 50%;
  }
  
  .game-search .se-focus-title {
    padding: 20px 20px 0;
    font-size: 14px;
    font-weight: 700;
    position: relative;
    color: grey;
  }
  
  .game-search .history-item-box,
  .game-search .hot-item-box {
    padding-left: 20px;
  }
  
  .game-search .hot-item {
    color: #fc9191;
    font-size: 12px;
    margin-top: 24px;
    margin-right: 32px;
    float: left;
  }
  
  .game-search .hot-item:hover {
    color: #fc3737;
    font-weight: 700;
  }
  
  .game-search .history-del-icon:hover {
    background-position: -94px -49px;
  }
  
  .game-search .se-flex-line {
    width: 1px;
    height: 160px;
    background: #f0f0f0;
    position: absolute;
    left: 50%;
    top: 42px;
  }
  
  .game-search .se-election-box {
    position: absolute;
    top: 50px;
    left: -2px;
    width: 690px;
    display: none;
    min-height: 224px;
    overflow: hidden;
    white-space: nowrap;
    z-index: 100;
  }
  
  .game-search .se-election-drawer {
    border: 1px solid #df3234;
    padding-bottom: 64px;
    min-height: 224px;
    background-color: #fff;
    max-height: 450px;
    overflow-y: auto;
  }
  
  .game-search .se-election-letter {
    padding: 10px 0;
  }
  
  .game-search .se-election-letter ul li {
    float: left;
    font-size: 12px;
    margin: 0 3px;
    width: 17px;
    height: 17px;
    cursor: pointer;
    text-align: center;
    line-height: 17px;
    color: #8f8f8f;
    border-radius: 2px;
  }
  
  .game-search .se-election-letter ul .se-election-hot {
    width: 25px;
    border-right: 1px solid #dbdbdb;
    padding: 0 15px;
    margin: 0 13px 0 8px;
    color: #8f8f8f;
  }
  
  .game-search .se-election-letter ul li:hover {
    color: #fc3737;
    background-color: #ffe5e5;
  }
  
  .game-search .se-election-letter ul .active {
    background: #fc3737;
    border-radius: 2px;
    color: #fff;
  }
  
  .game-search .se-election-letter ul .se-election-hot.active {
    background: none;
    color: #fc3737;
  }
  
  .game-search .se-election-letter ul .active:hover {
    background: #fc3737;
    border-radius: 2px;
    color: #fff;
  }
  
  .game-search .se-election-letter ul .se-election-hot:hover {
    color: #fc3737;
    background-color: #fff;
  }
  
  .game-search .lastaccount:hover {
    color: #fc3737;
  }
  
  .game-search .election-drawer-data {
    margin-left: 16px;
    margin-top: 16px;
  }
  
  .game-search .election-drawer-data ul li {
    width: 134px;
    float: left;
    font-size: 12px;
    margin-bottom: 15px;
    color: #656565;
    cursor: pointer;
    line-height: 16px;
    text-align: left;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-right: 16px;
  }
  
  .game-search .election-drawer-data ul .election-drawer-hot,
  .game-search .election-drawer-data ul li:hover {
    color: #fc3737;
  }
  
  .game-search .drawer-new-icon {
    background: url(data:image/gif;base64,R0lGODlhFQANAPQAAP///1a3AGa8AHTIAE6lAGvAAHDFAGm+AHLGAG7CAFGqAFSxAFa1AFeuAIC+SEyhAFWzAFOvAFKsAE2jAE+oAILKQlWrAGO6AEufAP///wAAAAAAAAAAAAAAAAAAAAAAACH5BAUyABkAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAFQANAAAFZmAmjmRpVkGqruxaMUMsz/TMQAiA7Drg+7mgDrIw+AzGJBIJSDYXkQRASv35qtSIpAAocLtdrxfMLUgUB8Bhrbaq0/CDgiKo2+/4O8VB6DcuDX2Cg4MOJBMWEyaLJQ8PjJAiGJEmIQAh+QQJFAAZACwAAAkAFQAEAAAFDGAmjmRpnmiqrqwZAgAh+QQJFAAZACwAAAAAFQANAAAFZWAVjGRplhUzrGzrtgyEAEhNAzg+7zS0GDgDcCgUAobHRSQBYDpzuKczIikACtbrFYvVWgsSxQFwKJOh5LH6oKAI3vC4PE5xEO6NS+PO7/cdGYEZExYTgoeIiQ8PiY2JGI6RkpIhACH5BAkUABkALAAAAAAVAA0AAAVmYCaOZGlWQaqu7FoxQyzP9MxACIDsOuD7uaAOsjD4DMYkEglINheRBEBK/fmq1IikAChwu12vF8wtSBQHwGGttqrT8IOCIqjb7/g7xUHoNy4NfYKDgw4kExYTJoslDw+MkCIYkSYhACH5BAUUABkALAAAAAAVAA0AAAVlYBWMZGmWFTOsbOu2DIQASE0DOD7vNLQYOANwKBQChsdFJAFgOnO4pzMiKQAK1usVi9VaCxLFAXAok6HksfqgoAje8Lg8TnEQ7o1L487v9x0ZgRkTFhOCh4iJDw+JjYkYjpGSkiEAOw==)
      no-repeat 0 0;
    display: inline-block;
    width: 21px;
    height: 13px;
  }
  
  .game-search .se-election-type {
    height: 35px;
    line-height: 35px;
    padding: 0 12px;
    background: #fafafa;
  }
  
  .game-search .se-election-type li {
    cursor: pointer;
    height: 35px;
    line-height: 35px;
    font-size: 12px;
    color: #717171;
    float: left;
    margin-right: 34px;
  }
  
  .game-search .se-election-type li.active {
    color: #fc3737;
    font-weight: 700;
  }
  
  .game-search .se-election-type li:first-child {
    margin-right: 40px;
  }
  
  .game-search .election-drawer-search {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  
  .game-search .election-drawer-search .lastaccount {
    font-size: 12px;
    font-weight: 400;
    color: #bfbfbf;
    line-height: 1;
    position: absolute;
    cursor: pointer;
    left: 28px;
    bottom: 26px;
  }
  
  .game-search .election-drawer-search .allGame {
    position: absolute;
    cursor: pointer;
    right: 28px;
    bottom: 18px;
  }
  
  .game-search .election-drawer-search .allGameIpt {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 167px;
    height: 28px;
    padding: 0 10px;
    border: 1px solid #dedede;
    border-right: none;
    float: left;
  }
  
  .game-search .election-drawer-search .allGameIpt:focus {
    border-color: #fc3737;
  }
  
  .game-search .election-drawer-search .allGameIpt:focus ~ .allGameBtn {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABi0lEQVRIie2Wv0sCYRiAn/czU/fDqUZ1ESRBInCWJpcQFGcdFBoSHPoH+gv0D2mMhramEBylUEgXcWjKX3lf3N2QUnEXHEJwLxwH937wfO97z/dDPk5PNXsMtU8YATAA/gvggdeBcnKCVKtIJgOHh+iXF/Ttrf1gmp6Bnha+VCqoy0tYrdBPTzCfO2DDQD8+YrbbsF57ArpWaFVmwfRggHl9DZOJk4hGUVdXSLGIqtcxOx1PQNd/aLWR5RKz1fqCWbFYYN7coPt9pFSCSMQnYCaD7vVgNvue1Bp9d2dXK8mkP0B75u/vv+fnc+cdCvkD1M/PjiDh8I95yeVsS/Vo5BPQ0t4wUM0miOzCzs6QQsE2lbc3T0BXS+21ls8j5TIqlULf39vCSDaLnJ+DUkgiAcfH8PrqCvR2AIfDqFrNsTEWc75ZbXx4QNJpiMdhOmVjdcEF+rcTPxJxbIxG0cOhY+7REaFu1zPUnyvGNnQyYXNx8etQfzbv8ZhNo2FXprc3hx8iuEQFwAC4G8AnnfuS7mMEbLEAAAAASUVORK5CYII=);
  }
  
  .game-search .election-drawer-search .allGameBtn {
    width: 28px;
    height: 28px;
    z-index: 999;
    border: 0;
    background: #e0e0e0
      url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABPklEQVRIie2VyYqEQAyG4yjuuwd9/yfzIogiHtw3bP4CG2m622pGmhkwl8JY5Kv8SaWEOI5X+qL9fBNGF/AC/gugxLtRVVWybZsURSFBEGiaJqqqiuq6Ph8IkOd5tK4r9X3PVoCDICBd1ynPc+Y7BYjMABvHkQWe55n5kaXv+2SaJrmuS2VZcgEPa4jscPosy+4wGHxFUdAwDGRZFjvAKUBIBxmXZXn6v2kaBpNl+Rwggr2rD2/tuIGo3daZzww1hu3l/hUQbS+KImuMR9M0jQzDoK7rXkr+aIddCiBaH82DOrVte78W6FAY/JIkcWXJ9QBDTsdxGHQvLeAAQwFkmKbpIfSjF3/rxm3SAILMoijihn40SyEl7t3+miA4IPgGNAzDtzFOGd4bFOuRpNzDmweaJMnhvuvFv4B/HEhENxb4rPMJ/UczAAAAAElFTkSuQmCC)
      50% no-repeat;
    float: left;
    cursor: pointer;
  }
  
  .game-search .election-drawer-search .allGameBtn:hover {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABi0lEQVRIie2Wv0sCYRiAn/czU/fDqUZ1ESRBInCWJpcQFGcdFBoSHPoH+gv0D2mMhramEBylUEgXcWjKX3lf3N2QUnEXHEJwLxwH937wfO97z/dDPk5PNXsMtU8YATAA/gvggdeBcnKCVKtIJgOHh+iXF/Ttrf1gmp6Bnha+VCqoy0tYrdBPTzCfO2DDQD8+YrbbsF57ArpWaFVmwfRggHl9DZOJk4hGUVdXSLGIqtcxOx1PQNd/aLWR5RKz1fqCWbFYYN7coPt9pFSCSMQnYCaD7vVgNvue1Bp9d2dXK8mkP0B75u/vv+fnc+cdCvkD1M/PjiDh8I95yeVsS/Vo5BPQ0t4wUM0miOzCzs6QQsE2lbc3T0BXS+21ls8j5TIqlULf39vCSDaLnJ+DUkgiAcfH8PrqCvR2AIfDqFrNsTEWc75ZbXx4QNJpiMdhOmVjdcEF+rcTPxJxbIxG0cOhY+7REaFu1zPUnyvGNnQyYXNx8etQfzbv8ZhNo2FXprc3hx8iuEQFwAC4G8AnnfuS7mMEbLEAAAAASUVORK5CYII=);
  }
  
  .game-search .empty-data {
    width: 100% !important;
    text-align: center !important;
    pointer-events: none;
    cursor: default !important;
  }
  
  .select_template {
    width: 134px;
    border: 1px solid #d0d0d0;
    padding: 9px 0 9px 14px;
    cursor: pointer;
  }
  
  .select_template.active {
    border-color: #aeaeae;
  }
  
  .select_template_name {
    width: 96px;
    text-overflow: ellipsis;
    line-height: 14px;
    color: #a8a8a8;
    overflow: hidden;
    white-space: nowrap;
  }
  
  .select_template.active .select_template_name {
    color: #555;
  }
  
  .select_template .triangle {
    border: solid transparent;
    border-top: 5px solid #aeaeae;
    position: absolute;
    top: 14px;
    right: 17px;
  }
  
  .select_template.active .triangle {
    border-top-color: #555;
  }
  
  .template_box {
    display: none;
    position: absolute;
    top: 31px;
    left: 0;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
  }
  
  .template_con {
    margin-top: 9px;
    padding: 18px 14px 4px;
    border: 1px solid #efefef;
    background: #fff;
    font-size: 12px;
    color: #a8a8a8;
    line-height: 20px;
  }
  
  .template_item {
    margin-bottom: 5px;
    cursor: pointer;
  }
  
  .template_name {
    width: 100px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .template_item.active,
  .template_item:hover {
    color: #555;
  }
  
  .close_template {
    float: right;
    padding: 4px;
    line-height: 13px;
  }
  
  .close_template i {
    width: 7px;
    height: 7px;
    margin-top: 3px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAPCAYAAAC1DNw2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAJaSURBVEhLxZY9TypBFIb36o2dHzExsTdidRtjY3IpLAxYsAQWChITYyKllRYWmDXaislWQEUC4Tvhb1h57/0VwK8A3zP3uBnYnWUWv97kzcCZd2d4MofNGK1W6wk2HcdZMaB6vb7dbrdv4Ef6LiubzT5ZlmXGYjGRTaVS25lM5gb2ZCuVSqJcLg8wTmRzLcExbY2NvcTY2B1MjMhENtVojmNqAfIULsKHjUZjo9PpXDD8b464AtApXATsYS6X2wD4BcN7sgQ0HA4ns6IaQAcc05aAfPnLq0hCjeY4phZOcBVQJnwPX8G3vV7vV6FQ+MERV/F4fJVOFL6HrwB9i9E3S6enEs1xTFviBFXCHMeC1e/3N9GqD/AzQI9t217mKY+SyeQmAB9wks+API5Go75ZgqnValNtq2NVawvQnehU2+rYbe1qtbrebDYtQN5hvETr2t1udx/jEu/hCpDrgLTgO0BewjaA9/Ff9WTpR/u17jypWlv8cL/Wnae31gbQOb144ANssIYTPYMdQB/xHq4Adg7IR4AdYFwD5Bns4LMnS6CLip7lZVwJ0EWFZ+llVATkCVrmJy2IdttC7ZrqYgdJACqm0+mTfD4vsgDeQu2a6iIgKSyonP8QUDlPoJ+lMKCz2XeDzma/ElQF7lfXAlWB+9W/EpQUBp6XcaUCmFIAPC/z8QqCkEc/aYOS3uqqedJ3gJKC5kihQElBc6TvAp2n0KDz9JmgdMMZjUa8k75UFwZx1/3zj1MhpHsXXlSlUsnk65w4IV3TM/QsL+NqbERMAUsnG8L/r4AR8xUInm5P8Z2I+QAAAABJRU5ErkJggg==)
      no-repeat;
    display: inline-block;
  }
  
  .close_template.active i,
  .close_template i:hover {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAPCAYAAAC1DNw2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAJaSURBVEhLxZY9TypBFIb36o2dHzExsTdidRtjY3IpLAxYsAQWChITYyKllRYWmDXaislWQEUC4Tvhb1h57/0VwK8A3zP3uBnYnWUWv97kzcCZd2d4MofNGK1W6wk2HcdZMaB6vb7dbrdv4Ef6LiubzT5ZlmXGYjGRTaVS25lM5gb2ZCuVSqJcLg8wTmRzLcExbY2NvcTY2B1MjMhENtVojmNqAfIULsKHjUZjo9PpXDD8b464AtApXATsYS6X2wD4BcN7sgQ0HA4ns6IaQAcc05aAfPnLq0hCjeY4phZOcBVQJnwPX8G3vV7vV6FQ+MERV/F4fJVOFL6HrwB9i9E3S6enEs1xTFviBFXCHMeC1e/3N9GqD/AzQI9t217mKY+SyeQmAB9wks+API5Go75ZgqnValNtq2NVawvQnehU2+rYbe1qtbrebDYtQN5hvETr2t1udx/jEu/hCpDrgLTgO0BewjaA9/Ff9WTpR/u17jypWlv8cL/Wnae31gbQOb144ANssIYTPYMdQB/xHq4Adg7IR4AdYFwD5Bns4LMnS6CLip7lZVwJ0EWFZ+llVATkCVrmJy2IdttC7ZrqYgdJACqm0+mTfD4vsgDeQu2a6iIgKSyonP8QUDlPoJ+lMKCz2XeDzma/ElQF7lfXAlWB+9W/EpQUBp6XcaUCmFIAPC/z8QqCkEc/aYOS3uqqedJ3gJKC5kihQElBc6TvAp2n0KDz9JmgdMMZjUa8k75UFwZx1/3zj1MhpHsXXlSlUsnk65w4IV3TM/QsL+NqbERMAUsnG8L/r4AR8xUInm5P8Z2I+QAAAABJRU5ErkJggg==)
      no-repeat -11px 0;
  }
  
  .template_hint {
    display: none;
    position: absolute;
    top: -45px;
    left: -70px;
    width: 290px;
    color: #888;
    font-size: 12px;
    line-height: 12px;
    background: #fff;
    padding: 13px 0;
    text-align: center;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 10px 0 #ccc;
    box-shadow: 0 1px 10px 0 #ccc;
  }
  
  .template_hint .triangle {
    position: absolute;
    bottom: -12px;
    left: 139px;
    border: 6px solid transparent;
    border-top-color: #fff;
  }
  
  .close_hint {
    display: none;
    position: absolute;
    margin: -18px 0 0 146px;
    width: 82px;
    color: #888;
    font-size: 12px;
    line-height: 19px;
    background: #fff;
    text-align: center;
    border-radius: 2px;
    -webkit-box-shadow: -2px 1px 16px -1px #ccc;
    box-shadow: -2px 1px 16px -1px #ccc;
  }
  
  .close_template:hover + .close_hint {
    display: block;
  }
  
  .close_hint .triangle {
    position: absolute;
    margin: 5px 0 0 -14px;
    border: 4px solid transparent;
    border-right: 6px solid #fff;
  }
  
  .save_template {
    display: inline-block;
    line-height: 32px;
    padding-left: 24px;
    margin-left: 15px;
    font-weight: 600;
    font-size: 12px;
    color: #666;
    cursor: pointer;
  }
  
  .save_img {
    display: inline-block;
    width: 16px;
    height: 15px;
    margin-left: -24px;
    margin-right: 8px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAPCAYAAAC1DNw2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAJaSURBVEhLxZY9TypBFIb36o2dHzExsTdidRtjY3IpLAxYsAQWChITYyKllRYWmDXaislWQEUC4Tvhb1h57/0VwK8A3zP3uBnYnWUWv97kzcCZd2d4MofNGK1W6wk2HcdZMaB6vb7dbrdv4Ef6LiubzT5ZlmXGYjGRTaVS25lM5gb2ZCuVSqJcLg8wTmRzLcExbY2NvcTY2B1MjMhENtVojmNqAfIULsKHjUZjo9PpXDD8b464AtApXATsYS6X2wD4BcN7sgQ0HA4ns6IaQAcc05aAfPnLq0hCjeY4phZOcBVQJnwPX8G3vV7vV6FQ+MERV/F4fJVOFL6HrwB9i9E3S6enEs1xTFviBFXCHMeC1e/3N9GqD/AzQI9t217mKY+SyeQmAB9wks+API5Go75ZgqnValNtq2NVawvQnehU2+rYbe1qtbrebDYtQN5hvETr2t1udx/jEu/hCpDrgLTgO0BewjaA9/Ff9WTpR/u17jypWlv8cL/Wnae31gbQOb144ANssIYTPYMdQB/xHq4Adg7IR4AdYFwD5Bns4LMnS6CLip7lZVwJ0EWFZ+llVATkCVrmJy2IdttC7ZrqYgdJACqm0+mTfD4vsgDeQu2a6iIgKSyonP8QUDlPoJ+lMKCz2XeDzma/ElQF7lfXAlWB+9W/EpQUBp6XcaUCmFIAPC/z8QqCkEc/aYOS3uqqedJ3gJKC5kihQElBc6TvAp2n0KDz9JmgdMMZjUa8k75UFwZx1/3zj1MhpHsXXlSlUsnk65w4IV3TM/QsL+NqbERMAUsnG8L/r4AR8xUInm5P8Z2I+QAAAABJRU5ErkJggg==)
      no-repeat -22px 0;
    vertical-align: text-top;
  }
  
  .save_template:hover {
    color: #fc3737;
  }
  
  .save_template:hover .save_img {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAPCAYAAAC1DNw2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAJaSURBVEhLxZY9TypBFIb36o2dHzExsTdidRtjY3IpLAxYsAQWChITYyKllRYWmDXaislWQEUC4Tvhb1h57/0VwK8A3zP3uBnYnWUWv97kzcCZd2d4MofNGK1W6wk2HcdZMaB6vb7dbrdv4Ef6LiubzT5ZlmXGYjGRTaVS25lM5gb2ZCuVSqJcLg8wTmRzLcExbY2NvcTY2B1MjMhENtVojmNqAfIULsKHjUZjo9PpXDD8b464AtApXATsYS6X2wD4BcN7sgQ0HA4ns6IaQAcc05aAfPnLq0hCjeY4phZOcBVQJnwPX8G3vV7vV6FQ+MERV/F4fJVOFL6HrwB9i9E3S6enEs1xTFviBFXCHMeC1e/3N9GqD/AzQI9t217mKY+SyeQmAB9wks+API5Go75ZgqnValNtq2NVawvQnehU2+rYbe1qtbrebDYtQN5hvETr2t1udx/jEu/hCpDrgLTgO0BewjaA9/Ff9WTpR/u17jypWlv8cL/Wnae31gbQOb144ANssIYTPYMdQB/xHq4Adg7IR4AdYFwD5Bns4LMnS6CLip7lZVwJ0EWFZ+llVATkCVrmJy2IdttC7ZrqYgdJACqm0+mTfD4vsgDeQu2a6iIgKSyonP8QUDlPoJ+lMKCz2XeDzma/ElQF7lfXAlWB+9W/EpQUBp6XcaUCmFIAPC/z8QqCkEc/aYOS3uqqedJ3gJKC5kihQElBc6TvAp2n0KDz9JmgdMMZjUa8k75UFwZx1/3zj1MhpHsXXlSlUsnk65w4IV3TM/QsL+NqbERMAUsnG8L/r4AR8xUInm5P8Z2I+QAAAABJRU5ErkJggg==)
      no-repeat -42px 0;
  }
  
  .search_bar_in_txt {
    width: 291px;
    float: right;
    margin-right: 20px;
    position: relative;
  }
  
  .in_txt {
    width: 375px;
    height: 30px;
    float: left;
    padding-left: 20px;
    margin-left: 30px;
    line-height: 30px;
  }
  
  .search_content {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    width: 215px;
    height: 32px;
    padding-left: 9px;
    padding-right: 9px;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    font-weight: 400;
    border: 1px solid #d7d7d7;
    border-right: none;
    float: left;
  }
  
  .search_bar_in_txt .se-focus-toggle {
    width: 213px;
    top: 32px;
    border: 1px solid #eee;
    border-top: none;
    left: 0;
  }
  
  .search_bar_in_txt .history-item-box {
    padding-left: 0;
  }
  
  .search_bar_in_txt .history-item {
    margin-right: 0;
    margin-top: 4px;
    display: block;
    float: none;
    line-height: 25px;
    padding: 0 10px;
    position: relative;
    height: 25px;
    font-size: 12px;
    color: #a8a8a8;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  
  .search_bar_in_txt .history-item.current {
    background: #f1f1f1;
    font-weight: 700;
    color: #656565;
  }
  
  .search_bar_in_txt .history-item:hover {
    background: #f1f1f1;
    font-weight: 700;
  }
  
  .search_bar_in_txt .history-item:hover i {
    display: block;
  }
  
  .search_bar_in_txt .history-item i {
    display: none;
    top: 4px;
  }
  
  .search_bar_in_txt .history-item b {
    font-weight: 700;
    color: #fc3737;
  }
  
  .search_button {
    color: #fff;
    background: #fc3737;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-family: 微软雅黑;
    margin: 0 auto 0 6px;
  }
  
  .search_button2 {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    width: 76px;
    height: 32px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    line-height: 30px;
    background-color: #fc3737;
    border: 1px solid #fc3737;
    float: left;
    cursor: pointer;
  }
  
  .search_button {
    width: 180px;
    display: block;
    margin: 20px auto;
  }
  
  .in_txt a {
    width: 70px;
    display: block;
    height: 36px;
    line-height: 36px;
    color: #fff;
    background: #f03d40;
    border: none;
    cursor: pointer;
    float: left;
    margin-left: 10px;
  }
  
  .search-hot-history {
    position: absolute;
    left: 0;
    width: 215px;
    top: 32px;
    z-index: 3;
    display: none;
    border: 1px solid #eee;
    border-top: none;
    background: #fff;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .search-hot-history p {
    height: 30px;
    line-height: 30px;
    margin: 0 auto;
    font-size: 13px;
    color: #a1a1a1;
    padding-left: 10px;
    font-weight: 700;
  }
  
  .search-hot-history .history-item,
  .search-hot-history .null_history {
    height: 24px;
    line-height: 24px;
    padding-left: 5px;
    margin-left: 5px;
    color: #848484;
    padding-right: 5px;
  }
  
  .search-hot-history .history-item {
    display: block;
    float: none;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: auto;
    font-size: 12px;
    background: #fff;
  }
  
  .search-hot-history .history-item:hover {
    color: #656565;
  }
  
  .queryForm .senior-search {
    border-bottom: 0;
    position: relative;
  }
  
  .queryForm .senior-search .con {
    margin-top: 16px;
  }
  
  .queryForm .es-con-list > li {
    float: left;
    margin-right: 12px;
    margin-bottom: 14px;
  }
  
  .queryForm .es-con-list > li.active .es-title {
    color: #fc3737;
    border-color: #fc3737;
  }
  
  .queryForm .es-con-list > li.hover .es-title {
    color: #fc3737;
    border-color: #fc3737;
    text-decoration: none;
    position: relative;
    z-index: 2;
  }
  
  .queryForm .es-con-list > li.hover .arrow {
    background-position: -71px -12px;
  }
  
  .queryForm .es-con-list > li.hover .es-list {
    display: block;
  }
  
  .queryForm .es-con-list > li .esListArrow {
    position: absolute;
    top: -14px;
    display: inline-block;
    border: 7px solid transparent;
    border-bottom-color: #dcdee3;
  }
  
  .queryForm .es-con-list > li .esListArrow span {
    position: absolute;
    top: -5px;
    left: -6px;
    display: inline-block;
    border: 6px solid transparent;
    border-bottom-color: #fff;
  }
  
  .queryForm .es-con-list .letterSearch {
    font-size: 0;
    margin-top: 25px;
  }
  
  .queryForm .es-con-list .letterSearch div {
    position: relative;
    display: inline-block;
    font-size: 12px;
    color: #666;
    width: 16px;
    margin-right: 8px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
  }
  
  .queryForm .es-con-list .letterSearch div.active,
  .queryForm .es-con-list .letterSearch div:hover {
    color: #333;
    font-weight: 700;
  }
  
  .queryForm .es-con-list .letterSearch div span {
    position: absolute;
    top: 18px;
    left: 0;
    width: 100%;
    height: 2px;
    background: #fff;
  }
  
  .queryForm .es-con-list .letterSearch div.active span,
  .queryForm .es-con-list .letterSearch div:hover span {
    background: #fc3737;
  }
  
  .queryForm .es-con-list .pf_title_tab {
    font-size: 0;
    margin-top: 25px;
    margin-bottom: 40px;
  }
  
  .queryForm .es-con-list .pf_title_tab .itemTitle {
    display: inline-block;
    margin-right: 32px;
    color: #666;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  
  .queryForm .es-con-list .pf_title_tab .itemTitle div {
    font-size: 12px;
  }
  
  .queryForm .es-con-list .pf_title_tab .itemTitle .itemSelectNum {
    font-style: normal;
    position: absolute;
    top: -6px;
    right: -13px;
    height: 16px;
    line-height: 16px;
    background: #ff2828;
    border-radius: 8px;
    font-size: 9px;
    font-weight: 600;
    color: #fff;
    padding: 0 5px;
    display: none;
  }
  
  .queryForm .es-con-list .pf_title_tab .itemTitle .showItemSelectNum {
    display: block;
  }
  
  .queryForm .es-con-list .pf_title_tab .itemTitle span {
    display: inline-block;
    width: 16px;
    height: 2px;
    margin-top: 3px;
    background: #fff;
  }
  
  .queryForm .es-con-list .pf_title_tab .itemTitle.hover,
  .queryForm .es-con-list .pf_title_tab .itemTitle:hover {
    color: #333;
    font-weight: 700;
  }
  
  .queryForm .es-con-list .pf_title_tab .itemTitle.hover span,
  .queryForm .es-con-list .pf_title_tab .itemTitle:hover span {
    background: #fc3737;
  }
  
  .queryForm .es-con-list .search-con-box .con1 {
    display: none;
  }
  
  .queryForm .es-con-list .search-con-box .con1.hover {
    display: block;
  }
  
  .queryForm .es-con-list .dataListBox .game-hero-pf-box .game-hero-name {
    font-size: 14px;
    font-weight: 700;
    color: #4d4d4d;
    line-height: 16px;
    margin-bottom: 10px;
  }
  
  .queryForm .es-con-list .dataListBox .es-list-item {
    cursor: pointer;
  }
  
  .queryForm .es-con-list .dataListBox .es-list-item .carefully-pf-img img {
    width: 60px;
    height: 61px;
    border-radius: 2px;
    margin-right: 40px;
    margin-bottom: 12px;
    -o-object-fit: cover;
    object-fit: cover;
  }
  
  .queryForm .es-con-list .dataListBox .es-list-item .carefully-pf-name {
    width: 60px;
    height: 35px;
    overflow: hidden;
    margin-bottom: 12px;
    font-size: 12px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
  }
  
  .queryForm .es-con-list .dataListBox .es-list-item .carefully-hero-name {
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #3f96ea;
    width: 60px;
    margin-bottom: 5px;
  }
  
  .queryForm .es-con-list .dataListBox .active {
    position: relative;
  }
  
  .queryForm .es-con-list .dataListBox .active .carefully-pf-img {
    display: block;
    position: relative;
  }
  
  .queryForm .es-con-list .dataListBox .active .carefully-pf-img:after {
    position: absolute;
    display: block;
    content: "";
    top: 0;
    left: 0;
    width: 60px;
    height: 61px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA9CAYAAADxoArXAAAAAXNSR0IArs4c6QAAAbVJREFUaEPtmyFPQlEYhp+PO/+Df+Du3lGwOmlanJvBuRHYaA6UjUQj0uy6aaBQLW42s//AAI3AhpVK4DiuSGBjfNHv+N12d97wvu/znbNTjoQsu0TkCTgk5i+EOcvlnYQ8nxHCtYzHH1bzhix7ROR2r/8Q5qvAQUYj2Sv+w4KQpmckyftOi+Uy9HpQrxNHYBDy/BMoF6FbLRgMYLGASgX6feh0YDKJI/AqY0jTC5LkrQjcaEC1CsMhdLvQbsN0WixFQfh3lEOePwM3xX+tVowwzSbMZptpjyswHJBlr4ic79rPUQUuRnsVOs8fNqS3kkcXeDPeP3v6fnOQrReiDbymLaTpKaXSFXCMyFHUgbf3cXHniOHiob0TeWBtU1Z1TtgqOa1vJ6xtyqrOCVslp/XthLVNWdU5YavktL6dsLYpqzonbJWc1rcT1jZlVeeErZLT+nbC2qas6pywVXJa305Y25RVnRO2Sk7r2wlrm7Kqc8JWyWl9O2FtU1Z1TtgqOa1vJ6xtyqrOCVslp/XthLVNWdU5YavktL6dsLYpq7p/S9j8yzTNxIUsO0HkRf7N20P4IoTmN/p5nlxWreeWAAAAAElFTkSuQmCC)
      no-repeat;
  }
  
  .queryForm .es-title {
    color: #555;
    display: block;
    height: 24px;
    line-height: 24px;
    padding: 0 10px;
    border: 1px solid #ddd;
    background: #fff;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .queryForm .es-title .arrow {
    width: 12px;
    height: 8px;
    background-position: -51px -12px;
    top: -2px;
  }
  
  .queryForm .es-con-li-multi .es-list {
    padding: 0 20px 71px;
  }
  
  .queryForm .es-con-li-skin .es-list {
    padding: 0 20px 20px;
  }
  
  .queryForm .es-list {
    display: none;
    position: absolute;
    left: 1%;
    width: 98%;
    margin-top: 10px;
    background: #fff;
    border: 1px solid #dcdee3;
    padding: 0 24px 25px;
    -webkit-box-shadow: 0 12px 36px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 12px 36px 0 rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
  }
  
  .queryForm .es-list .con1 {
    max-height: 300px;
    overflow-y: auto;
  }
  
  .queryForm .es-list .con1 .new-search-select-all {
    position: absolute;
    right: 24px;
    top: 60px;
    cursor: pointer;
  }
  
  .queryForm .es-list .con1 .new-search-select-all .select-icon {
    display: inline-block;
    width: 12px;
    height: 12px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAUUlEQVQoU2M8ffq0379//2YyMDBIMOAHL5iYmNIZT548+fzfv38hlpaWR/GpP378uDUTE9MakIb/5ubmjARMB0uD1I5qIBRSZIcSaRFHatIAAPbnYL+/xHJqAAAAAElFTkSuQmCC)
      no-repeat;
    background-size: 100% 100%;
    vertical-align: -1px;
  }
  
  .queryForm .es-list .con1 .new-search-select-all .new-search-select-all-word {
    font-size: 12px;
    color: #888;
    line-height: 16px;
  }
  
  .queryForm .es-list .con1 .new-search-hasSelect .select-icon {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAzElEQVQoU5WSMQ6CUAyGv2dEcWZxkdndC+AF2DiDJC5ewDA4wOjq4mCYTFxcOAQJ15ADSEBAn1GjCRpFurZf2/9vRTIYmFKIFdDnd8RCyok46vrhj+Jnq/gGyJrOlXQt0DIMuo5DOh7fwZ9AazRC9X1y16XcbKqAut+TLxZcwvCRGA7pbbcU6zXFcvla6zVBmU5RbJvUsiBJUHc7zkFA7jjfNSjzOW3ThCzjHEXksxnIqidVDULQ8TyEpnGybSjLDwNrXXonmh+u6WtcATLnU62jkPzbAAAAAElFTkSuQmCC)
      no-repeat;
    background-size: 100% 100%;
  }
  
  .queryForm .es-list .con1 .weapon-list {
    position: absolute;
    top: 76px;
  }
  
  .queryForm .es-list .con1 .weapon-list .weapon-tab {
    margin-top: 0;
  }
  
  .queryForm .es-list .con1 .weapon-list .weapon-tab:hover {
    background: initial;
    color: #939393;
    border: 1px solid #999;
  }
  
  .queryForm .es-list .con1 .game-hero-pf-box {
    margin-bottom: 15px;
  }
  
  .queryForm .es-list .hpjy-con1 {
    max-height: 230px;
    margin-top: 70px;
  }
  
  .queryForm .es-list .multi_choose1-box .new-search-count-title {
    height: 16px;
    font-size: 12px;
    font-weight: 700;
    color: #4d4d4d;
    line-height: 16px;
    margin-top: 12px;
  }
  
  .queryForm .es-list .multi_choose1-box .new-search-progress-box {
    padding-top: 15px;
  }
  
  .queryForm .es-list .multi_choose1-box .new-search-progress-box .count-box {
    width: 252px;
    font-size: 12px;
    font-weight: 400;
    color: #a1a0ab;
    margin-bottom: 12px;
  }
  
  .queryForm
    .es-list
    .multi_choose1-box
    .new-search-progress-box
    .new-search-progress {
    width: 240px;
    margin-left: 5px;
  }
  
  .queryForm .es-list input {
    border: 1px solid #ddd;
    margin-top: 5px;
  }
  
  .queryForm .es-list .multi_btn {
    display: block;
    width: 110px;
    height: 32px;
    color: #fff;
    text-align: center;
    line-height: 28px;
    background-color: #fc3737;
    border-radius: 2px;
    cursor: pointer;
    border: none;
    position: absolute;
    left: 50%;
    bottom: 15px;
    margin: 0 0 0 -55px;
  }
  
  .queryForm .es-list .multi_btn:hover {
    -webkit-box-shadow: 0 11px 21px 0 rgba(252, 55, 55, 0.24);
    box-shadow: 0 11px 21px 0 rgba(252, 55, 55, 0.24);
  }
  
  .queryForm .es-list a {
    line-height: 1;
    display: inline-block;
    padding: 7px 12px;
    font-size: 12px;
    font-weight: 400;
    color: #939393;
    border: 1px solid #d7d7d7;
    margin-right: 16px;
    margin-top: 25px;
    cursor: pointer;
  }
  
  .queryForm .es-list a.active,
  .queryForm .es-list a:hover {
    color: #fff;
    border-color: #fc3737;
    background: #fc3737;
  }
  
  .queryForm .es-list .list-li-img {
    position: relative;
    margin-right: 30px;
    margin-top: 20px;
  }
  
  .queryForm .es-list .list-li-img .list-li-content {
    width: 150px;
    cursor: pointer;
    position: relative;
    z-index: 11;
  }
  
  .queryForm .es-list .list-li-img .list-li-content.active .person-name {
    color: #fc3737;
  }
  
  .queryForm .es-list .list-li-img .list-li-content .person-img {
    width: 150px;
    height: 76px;
    display: block;
  }
  
  .queryForm .es-list .list-li-img .list-li-content .person-name {
    margin-top: 6px;
    line-height: 1;
    font-size: 12px;
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #787878;
  }
  
  .queryForm .es-list .list-li-img:hover .list-li-list {
    display: block;
  }
  
  .queryForm .es-list .list-li-img .list-li-list {
    display: none;
    position: absolute;
    top: 0;
    left: 150px;
    width: 140px;
    text-align: center;
    background: #fff;
    -webkit-box-shadow: 0 2px 8px 1px rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 8px 1px rgba(0, 0, 0, 0.1);
  }
  
  .queryForm .es-list .list-li-img .list-li-list:before {
    position: absolute;
    content: "";
    left: -150px;
    top: 0;
    height: 100%;
    width: 150px;
  }
  
  .queryForm .es-list .list-li-img:nth-child(6n) .list-li-list {
    left: -140px;
  }
  
  .queryForm .es-list .list-li-img .list-li-list .title {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    background-color: #424242;
    float: none;
    text-align: center;
  }
  
  .queryForm .es-list .list-li-img .list-li-list .title,
  .queryForm .es-list .list-li-img .list-li-list .txt {
    width: 120px;
    height: 31px;
    line-height: 31px;
    padding: 0 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    z-index: 12;
  }
  
  .queryForm .es-list .list-li-img .list-li-list .txt {
    display: block;
    font-size: 12px;
    font-weight: 400;
    color: #888;
    border: 0;
    margin: 0;
    background: #fff;
  }
  
  .queryForm .es-list .list-li-img .list-li-list .txt.active {
    color: #fc3737;
  }
  
  .queryForm .es-list .list-li-img .list-li-list .txt:hover {
    color: #3e3e3e;
    background-color: #f0f0f0;
  }
  
  .queryForm .es-list .es_t_price {
    float: left;
  }
  
  .queryForm .es-list .price-input-box {
    width: 210px;
    float: left;
    margin-top: 25px;
  }
  
  .queryForm .es-list .price-input-box.js-danzai-input {
    float: inherit;
    display: inline-block;
  }
  
  .queryForm .es-list .price-input-box.js-danzai-input > div {
    display: inline-block;
  }
  
  .queryForm .es-list .price-input-box.js-danzai-input .danzai-input-search {
    display: inline-block;
    width: 50px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background: #fc3737;
    margin-left: 10px;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .queryForm .es-list .price-input-box .price-input {
    width: 50px;
    height: 24px;
    text-align: center;
    margin-top: 0;
  }
  
  .queryForm .es-list .price-input-search {
    width: 50px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    float: left;
    background: #fc3737;
    margin-left: 10px;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .queryForm .es-list .price-input::-webkit-input-placeholder {
    font-size: 12px;
    letter-spacing: 1px;
    color: #a8a8a8;
  }
  
  .queryForm .es-list .price-input:-moz-placeholder,
  .queryForm .es-list .price-input::-moz-placeholder {
    font-size: 12px;
    letter-spacing: 1px;
    color: #a8a8a8;
  }
  
  .queryForm .es-list .price-input:-ms-input-placeholder {
    font-size: 12px;
    letter-spacing: 1px;
    color: #a8a8a8;
  }
  
  .queryForm .es-list .price-input::placeholder {
    font-size: 12px;
    letter-spacing: 1px;
    color: #a8a8a8;
  }
  
  .queryForm .sp-list {
    height: 459px;
    top: -463px;
  }
  
  .queryForm .sp-list .esListArrow {
    bottom: -14px;
    top: auto !important;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  
  .common-law-limit .law-limit-cover .img28 {
    vertical-align: top;
  }
  
  .queryForm ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: #e4e4e4;
  }
  
  .queryForm ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
  }
  
  .queryForm ::-webkit-scrollbar-button:end:decrement,
  .queryForm ::-webkit-scrollbar-button:start:increment {
    display: none;
  }
  
  .queryForm ::-webkit-scrollbar-corner {
    display: block;
  }
  
  .queryForm ::-webkit-scrollbar-thumb,
  .queryForm ::-webkit-scrollbar-thumb:hover {
    border-radius: 8px;
    background-color: #666;
  }
  
  .queryForm ::-webkit-scrollbar-thumb,
  .queryForm ::-webkit-scrollbar-track {
    border-right: 1px solid transparent;
    border-left: 1px solid transparent;
  }
  
  .queryForm ::-webkit-scrollbar-track:hover {
    background-color: #666;
  }
  
  .zhw-goods {
    margin-top: 10px;
  }
  
  .newZoneName {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    text-align: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.7);
    line-height: 22px;
    height: 22px;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 90px;
  }
  
  .orderby-search {
    margin-top: 10px;
    margin-bottom: 10px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    vertical-align: middle;
    border-left: 0;
    border-right: 0;
    background-color: #fff;
  }
  
  .orderby-search .orderby-list ul li {
    float: left;
    width: 104px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-weight: 400;
    color: #787878;
    cursor: pointer;
    margin-right: 5px;
  }
  
  .orderby-search .orderby-list ul li[data-quick] {
    display: none;
  }
  
  .orderby-search .orderby-list ul li span.order-up {
    width: 9px;
    height: 12px;
    margin-left: 8px;
    background-position: -14px -32px;
  }
  
  .orderby-search .orderby-list ul li span.order-down {
    width: 9px;
    height: 12px;
    margin-left: 8px;
    background-position: -32px -32px;
    top: 1px;
  }
  
  .orderby-search .orderby-list ul li.cur span.order-up,
  .orderby-search .orderby-list ul li:hover span.order-up {
    width: 9px;
    height: 12px;
    margin-left: 8px;
    background-position: -56px -32px;
  }
  
  .orderby-search .orderby-list ul li.cur span.order-down,
  .orderby-search .orderby-list ul li:hover span.order-down {
    width: 9px;
    height: 12px;
    margin-left: 8px;
    background-position: -75px -32px;
    top: 1px;
  }
  
  .orderby-search .orderby-list ul li.cur,
  .orderby-search .orderby-list ul li:hover {
    color: #000000;
    /* background: #fc3737; */
    border-radius: 8px;
    font-weight: 600;
  }
  
  .orderby-search .orderby-list ul li.rentZQ a {
    color: #787878;
  }
  
  .orderby-search .orderby-list ul li:hover a {
    color: #fff;
  }
  
  .orderby-search .hot-recommend {
    float: left;
    max-width: 860px;
    margin-left: 10px;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 48px;
  }
  
  .orderby-search .hot-recommend,
  .orderby-search .hot-recommend ul {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
  }
  
  .orderby-search .hot-recommend ul {
    position: relative;
    height: 26px;
    overflow: hidden;
    padding-top: 8px;
    width: auto;
    margin-top: -8px;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -moz-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }
  
  .orderby-search .hot-recommend li {
    width: auto;
    height: 24px;
    padding: 0 16px;
    margin: 0 16px 10px 0;
    line-height: 24px;
    border: 1px solid #ddd;
    float: left;
    color: #555;
    font-size: 14px;
    cursor: pointer;
    border-radius: 4px;
    -webkit-transition: border-color 0.3s, color 0.3s;
    -moz-transition: border-color 0.3s, color 0.3s;
    transition: border-color 0.3s, color 0.3s;
    position: relative;
  }
  
  .orderby-search .hot-recommend li.active,
  .orderby-search .hot-recommend li:hover {
    border-color: #ff6b66;
    color: #ff3d3d;
  }
  
  .orderby-search .hot-recommend li.active:after {
    content: "";
    position: absolute;
    height: 16px;
    width: 16px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAbRJREFUOE+lk8srrHEYxz8/l3eOy+woSi7rUa7ZKSVldEgkWZBiYcqpg0kjU1LUm8gUdSyOP0BSFpiFphR2xqVmFrIQCeVkcVznHdOr9/25hVkwv93T9/l+6vv8nkfw7umhkA0hOoEqIPtJPgZW0fW/wmIJvrWI50LXdYVweILrawfra/EEA/DvQspp6WDLh/KKCKmpf0hM7BNCaIZkAkzzw8MKu9uVzM9BUQmUlkJGpgScn8HWFuz4oakZCot9JCTUGBAJ0LQp9na6WVyAji7IynqfTNYnJzA7A/WNUFA0LRTllzAz39zsoY7E09Ud3fyMNCAz0+ByR0hJKRC6pk3iXfrN7R00Nsm2jQ1QFCgrk7XfD6enUFsr64V5SE4C+0+PAQgwrtrMbDl5ssHng7ExGBgAqxXcbnA4oK5O6keHmLNyuoIG4D+uPivDo2D58Zrd6wWPB+LioK0NWlpetdA9DA2COnEVHRAIQH8/hMPQ2wt2e1TAxwj7++B0QkMD5OaCqkJPD1RXfxrh4xCXl+HyElpbpWFzEw4OoL39kyHG+o0xL5IJiHWVXyDfPaa3i//Vc34EVfnwpZtUF9wAAAAASUVORK5CYII=)
      no-repeat;
    background-size: 100% 100%;
    top: -8px;
    right: -6px;
  }
  
  .goods-wrap {
    position: relative;
  }
  
  .goods-wrap .goods-box {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
  }
  
  .goods-wrap .goods-list {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    max-width: 100%;
  }
  
  .goods-wrap .goods-list > ul > li {
    border-bottom: 1px solid #f4f4f4;
    position: relative;
  }
  
  .goods-wrap .goods-list > ul > li.diamonds-list > a {
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/pages/zuhao/img/diamonds-list.0aa1e6e.png)
      #fff no-repeat 100% 0;
  }
  
  .goods-wrap .goods-list > ul > li.yx-disabled > a:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: hsla(0, 0%, 100%, 0.6);
    z-index: 10;
  }
  
  .goods-wrap .goods-list > ul > li.yx-disabled button {
    background: #999;
    color: #fff;
    border: 1px solid #999;
  }
  
  .goods-wrap .goods-list > ul > li.ad-li > a {
    padding: 0;
    position: relative;
    overflow: hidden;
    height: 136px;
  }
  
  .goods-wrap .goods-list > ul > li.ad-li .ad-img {
    position: absolute;
    left: 0;
    top: 0;
    height: 136px;
    max-width: 100%;
  }
  
  .goods-wrap .goods-list > ul > li > a {
    display: block;
    padding: 20px 0;
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    align-items: center;
    background-color: #fff;
    -webkit-transition: background-color 0.2s;
    -moz-transition: background-color 0.2s;
    transition: background-color 0.2s;
    -ms-flex-align: center;
  }
  
  .goods-wrap .goods-list > ul > li > a:hover {
    background-color: #fafafa;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de {
    position: absolute;
    top: 30px;
    right: 6px;
    z-index: 9;
    width: 431px;
    height: 371px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: none;
    padding-top: 27px;
    padding-left: 12px;
    padding-right: 20px;
    background: url(https://zuhaowan.zuhaowan.com/static/client/img/feedback/show-feedback-bg.png)
      no-repeat 50%;
    background-size: contain;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .title {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    padding-left: 42px;
    position: relative;
    height: 22px;
    line-height: 22px;
    margin-top: 22px;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .title:first-child {
    margin-top: 0;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .title:after {
    position: absolute;
    content: "";
    width: 24px;
    height: 24px;
    top: 0;
    left: 8px;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .title-dislike:after {
    background: url(https://zuhaowan.zuhaowan.com/static/client/img/feedback/dislike.png)
      no-repeat;
    background-size: 100% 100%;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .title-quality:after {
    background: url(https://zuhaowan.zuhaowan.com/static/client/img/feedback/icon-hid.png)
      no-repeat;
    background-size: 100% 100%;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .title-feedback {
    cursor: pointer;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .title-feedback:after {
    background: url(https://zuhaowan.zuhaowan.com/static/client/img/feedback/feedback.png)
      no-repeat;
    background-size: 100% 100%;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .title-feedback:before {
    position: absolute;
    content: "";
    width: 16px;
    height: 16px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: -10px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAHFJREFUOE9jZKAQMFKon4E2BixZcyCVgZFBJCbYoZ2QC7G6YMnaA5UM//63/Wdk7I8NcSjCZwhOLyxec6CP8f//QkKG4A0DYgwhGIgwQxiYGKuwhQltDaDIC8RoBsUObaKR4oREKPUhyxOMBUKGUWwAAG+SRhHIPy9mAAAAAElFTkSuQmCC)
      no-repeat;
    background-size: 100% 100%;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .feedback-de {
    margin-top: 4px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .feedback-de .item {
    height: 32px;
    color: #333;
    background: #f2f3f9;
    border-radius: 31px;
    line-height: 32px;
    padding-left: 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-right: 10px;
    margin-top: 8px;
    margin-left: 8px;
    cursor: pointer;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .feedback-de .item .type {
    width: auto;
    height: 100%;
  }
  
  .goods-wrap
    .goods-list
    > ul
    > li
    .feedback-shade-de
    .feedback-de
    .item
    .type-dw {
    background: url(data:image/png;base64,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)
      no-repeat 0;
    background-size: 20px 20px;
  }
  
  .goods-wrap
    .goods-list
    > ul
    > li
    .feedback-shade-de
    .feedback-de
    .item
    .type-hid {
    background: url(data:image/png;base64,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)
      no-repeat 0;
    background-size: 20px 20px;
  }
  
  .goods-wrap
    .goods-list
    > ul
    > li
    .feedback-shade-de
    .feedback-de
    .item
    .type-jg {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAACJVJREFUWEfNmHtsFMcdx7+/2bvzPXxnA36DDZhgggShQbRRkiJRJIKhUUMhgjQVURWICOcq6UOqaaLmj6RCkAolffiIFYhSItEENSkoAdNQQVtamkgUyQFF4mVqDD78gNo+38N3u/OrZnbt2OaMzxQhRlrv+W7nN5/5/h4zO4R7vNE9zofbBuR903zovrFMQn6bgWoCKsBUoSdM3M5AOwEtAuIgiiYfobVXkrcjxoQBuTEw3zLlK0S8khn+XAYlQoKZDhku8Sptip/Opc/gMzkDcoOvUhK9BpbrGRBEYIT8RCUhUNAPeN1Ansu2O2ACqQw4lgB39gF9CWYGESBB4j3B/AuqS7blApoTIDcEHpOQHzC4kAQxVRYRTS8C8ty5jAEMZMCt3eC2bmbJRKAeAbGO6uKfjmdgXECrwfciiHcww1BqiTkVgNcznt3sv6fSkGfbtapEsMD0U6Mu+etbGbsloBXx/YiZ31DupOpSourS2wMb1YtbOsAtHbbbiX5shJNvjmV4TEDtVrIOQcXbvEo62iLQ9PdeRDszWLN8ElYvnzwh2IPHerD34+soK3Zj2aMhLK9h8Jk2BiAFGyvHcndWQG70VkmTmlXMpatKsLExjr2fXLcrCIDn1hWj8bWZEwL8ydZWvPluBxSRaqsfm4Q94Xx4r3ZBx6SLF9Cm1OXRRrMCWhHvHpa8nkoKcKAzhNU/vIB1KyfjV/WVmFbmUX6ZENzgw8qnygMv7WjD7/dfx57XZ+L7M+Lgzl6QoPeMcOqZcQH5rcACaVmnVA96pIak243Pmvvx6MKQKsDAkAZKzhxBme1uQ88TTvy7D1+fF4BbmrBOnGOwZMMwFtLz8ebhkDeNYEZ8H7Kk1aKqGDSrzHYrGYDw4Mz5fvQnTNvPwwZcND8IlyqBnLJtUx5Mk3DydMz+XwE6ARLwG5g/Ox/MFiAHdNDwxWvgti4lwEeucHLNmIDcWOGX5o1uZo9XPDSbyOOy9Zr3N5DIw4oVK3D48OERXvB4PIjFYlB3tNQCLIFZnyKdTiMYDOr78FZbW4umpiawzABnFuuJkmnC/Ow8E9Ipwz25iDa1Jwb7jFCQd/q+a5rGRwgUguZOs+csAFH9MlD0OI4ePYply5ZBSjk0Zn19PbZt2wZwBrjwTfv7+/4BkBtbtmzB9u3bh54VQuDIkSNYunQpuOsAZIvqZ3uev7wCxHtguKzVtDn5p6yAVsS7S5qBDSgrBU0pGAKEOx/0yGEQCRw/fhyRSAR9fX1YtWoVNm7caCfN1ReAxOe2Xf9DwNTfQCXFrl27sH//foRCIYTDYSxevBjMEvJELZDpV4uf3bp7wR0dEK74biOc2pgV0Ix4j8lM4RJRNRXsy3O2OmrlBTDlAYgHfwciZ70d7rfr7wI3do5wJSZvBqb8YOR3OhxNyFN1QM9psKWks0MayRRkazuEp+evrnDqW9kVbPCeNQeKa8T0CsDjgKjMJUBxcZ4PYuZToKKlgLsQiB0Det8HmaPK12BSuGcAhU+B85cAZg+46xj40vtAKgGVI2AbULd0BrI1Cpe366wRTt0/lov7zER5kGaWq/XDnp1ST1+swgrkVXcGvAA8DDIchUdGs7bPkkAm6eTmDAEDBFaXyhtp29dz0XHI4JYoDF80ZoRTobEUjJnJ8nxRXa5VsydHDiSr6qGh4GYILwN5GBcQpgIDZJpAaQInCTAx5F5FqCsWA7IlCpcv2m/UpYJjuthKF9fQjHLAPbiVGuZiF0PkMeBSpY5BClZFwuhqOuhiJq2iLo8Z0okOBZkmwLIr0tCqlMmAL0Vh5HWdM+pSc8ZMEmugcImonAr4lVzO1IRSigC3BHl0BdEqKlc3n09gxztR9PVb+NpcP559shhV5R7HfXqLCqWidqtSU8GZgFSf9VbBGSY5AKvtKoxxkmS3ZQaeFRWlQFGBszI5MabiUMWgugyADQa5GJG9HXjhl60I5Rv4b5+FokkuHHq7BovmB+zwkI47VVKoa1A9S6mr/GqHkOzsBaK6zLxj1KU2ZFWQd/rWmKbxRwoWgu63C7XOYKESTilGdrIIBhSkXgYZpslwuQX+8s9erH3xAqaWetD88TwI1U8BKCMK1LSBWK2W2v1fLe3yyyugeC8Ml/kkbU5+mB1wX3G+7Ip1AZ48+kYNkVsFm6Og6qGhFKDTXZegkQG4dWc7Xn7jCk58MBcPPxh00lSRqv2AbU6XGAdaq2yakJ+fYyA9IIIFRfRMRzwroPrSbPDtZzaeEJVqs1BiK+gwaMWUeupLfXc+DyvHsX4L+5puYP0TU+DxqJkoIhVvpFeWQTV1GXL+8MVOyLYuEFkHXHXJVcOr+027GW70L5SWPMkkIB6eQ6Te1vRi6STM/7XdcpRTwHpHxOBUBvJfZ5lYQhhiEW1KnLoloFbxt969IP4elRZCLJg+/Pk79lmpqQX84jK4o0et838w6pJPjx4g+5b/7YKZMjPQzIygmF0GmlFyx8CGG+L/dEKev6YcFBPuvAX0XO+lnAD1zHb6H5dSHtALyQPTCSX27uaOtc5eyC9aVc6xIPEdCicOZrN969fOBt/PGLxdv3beV0Z3SkmlHF+45pw2UL1Rl3x9rImP+1JhRXz1YN6qio0oKwTVlOd+ojB6VHXCcDYKqWJOH4PQS0Y4+dWONgvluIBD7ma5V8UkGcRUVWwffag6mUvLmPbRx+UuZovV8hsTJJ6mzYlPxuueE6CGjBRUS6S3ArxWnwgIMAoCpF5NKeQDPG77AEm1VEbv77gvqV8p0RtXm2gFpir7PuH2/DxbQkw4BrN14Lf8iyzJrxB4OTNyOqQhQppBfzYEvUrPJ06Op9rw33NWcLRR3l0UtNLxFcS0kplnEXEFGOX6OUKUmdqJ6CITHzI8gSba0O28g04E7+ad3MR634Wnb1vBu8DmOONujXSb49zzCv4PsNS7VtkvXfoAAAAASUVORK5CYII=)
      no-repeat 0;
    background-size: 20px 20px;
  }
  
  .goods-wrap
    .goods-list
    > ul
    > li
    .feedback-shade-de
    .feedback-de
    .item
    .type-ms {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAACUtJREFUWEftmGlsVccVx/9n5r7NfrbBxmwFzBr2ECCCpARiggJNt0iURQ0NbQoh2CQgVapaNW3y0jaokaIQoCa0aRIlVavapG26q1AWtSalhCUEsEMBg4GYxcbwnp/91junmrs8P4M3Qj7kQ0ey5vq+uef87v+cOTN3CJ/yRp9yPtwWIDMTfpY73WQeSYzBgPWnWwMTGiRRHZ5oPUhE/HGF6AywAsA4APMco0cBvA3gOQDDARx4co7x4salxkiAvsTggd05J9AlgP8kIN+mNa3bbxW0M8DdDuAgx5jpAC596gFRtnmX2rJ5qYGyOYb1MwW8oPwcwGcAPo/9SCIFJNLgSBs4lsxion9LgW9TWWxvb0F7BeiVeCe2OZD610lzaemGJH76iI/Llw8k6l8ABP3d+4rGwVfC4AvNzImU5Y+IfiP6BR+nJY3RnkB7Bfj5SSLyxzJvn71nmO9/MUEVPxiG8ke7jezNfk0FPtcIPtvInFZERB8IL3+ZVsbru0+Rm3/NhJi3BieIsuixr0wVVLk2D+9yMWY/dgoVz5agfNmAnl6+899jSajDZ8CtCRCoUUhZSqujNV0Z61JBfjNvkmpN7TfWxEcumulF1Rt3ovpwK2Y/Unt7gJrEVFBHzoKbWkCC6kSuZwZ9veVqZ5BdAqa3+GvBmOt5Mo7FC/qictMYVL/XgtnLNOAwlC+7xRCDAXbc6U4x1IHT4HAbQNgt5cQFWHUwTaQHtrcMIIdCwkrgUGhnrhfTwhty8ingYc+KMC36XCEqXx6D6gMasAYVzwxH+bL+tpWeKmnGHQGs/6H2ZxIpqPdOM8dTRFKsFYWvb0FNjfUEhUKqg3muWiz1De9Xt+3pE8C9F1/IkfLOEsg5tVi0oBCVG8ag+mAEs79Wi4pnsnKwt4C223ZIV6SmCMwP6nWor4j8onHwzIxYI5ds0+UNxKyfChEONkhc8Ymx36g4EY5zScPWARBThkNO2odF8wtR+dIdqD4UwexHXQX1JOFeKqjB9HC3d+lsRa18vN4KSWI9Spb/EP0TCtMHm0CIyVKueCKh8bgHLQlj49931F+OqL7rvz8OyMvFmufrcP/d+ViyoB+aI0msDNXhR2uHYOKYAKCTQitIVjSy4u3ElYUN5gbLdBTU93VzIo6WVphH60GEC8IzZwLyfGkUT0yh8TgT82KJbZBoSfhgHppmmtE95AtATBsBqBviJ9iGEsrutQfrHoMVg4TtmJXSIbOft2zoXoMKp7/ZrjpUB07EIWWwFHLaIeT5ElgMk3h3yADOGrgWzlVNe7/HyvyWGFgEGlJsG3eTXNvUMNKByvQAp0yYzXHIQp8FaDYnYBT5AUMCOpO0Ha1edn+DXb7QCHXpKkjIl0S/WevRt6AVGJ7WIfYiHvbAb+SZzft/DaK5cvRQK7wZBfRmxAXU6hkuqFaSbcDrCcg+DqBzTR7p2BA2YFpDahWzctKJgBXmU+f1JNolC2csQzzdAn9BinjTQz4MDHpgJvI5sne7gjFRji8BfD7baPabatWkslU0lA0tGZxWUJEEZF+vreC1JES+D2Q4YNpG2rk2s+65aavtJRIwa+shkD5O+bPmQ/oiuBRNEf/1KR+ilzxArEA1v/s+C08/OXEkIA3nbbV6Tu3S6jlw8bSJg7VRsFaAGGNH+lFcZO9mrjSl8N8zcWvWkiJMHx+EX4fbhdQqWrNapwvZOW2mYR6vA6lUkyj87F1AIIzgwJQd4oKwB+GCPL62o17B65VTx+iEsxXMnm1W3mlIhdDPz+O5Vy649QLz7s3HP97U20hg3vJa7NrXkvktVDYEz64aCmj1NJwbGXeuaLtQMA+fhEAySX0fLEFBuAVhHeIDqzyou2YgiKA6t/MIkxgkp4wCDMMx6PjRE1SH1+lPN8Twq780gZ0cmDMjD3PvybcG794XwT/324AEwrIv9MOowYF2exboDXbTaZhHToNYXRTD5k1BFFGM7Jsm3l1qIBaQiAb9qnn7bgZNlZNGATn+9uJql/RMztkqZk0cN1F1KliKZyWuOyGsWZylXmZdduy0xWEeOw0CHxKF8x9AMBpHIGYSV0GiuJQQzfOaH+2pBNMXxbghoKKCjpXfKspuHXRKjbOStMXSOHYy1qFQT74jBwG/dCZZVk3Uymk43TslUtvlq2GoDy9oH3+WnyldimBLEo17mDgEgQmLCcGogfPV60yTXxADCkHjBreXAzdXnAlhlxw3OYF1Pz6LTb+8ksk5fbFu+QC8/HSJc88Bcpc7dwFwVxJdqj5sgLrcDCnpOxh630ZEg2nUbLN1ttfjKoFXy0eZ6bYT5DFYzJpgY+lw2Rt1542z1l/rvsKR2hiq/tZxO7fkoSJMGR+w38SNePZ6bG2/rP2/5UbtrWFOpUkaOWPx+JbTwBKlt17t2y22NVFbc46w4klycgkwoKDjLM4Aa9gb198OAmb9k70uOyUruzLo68they0WdEysbptiyUGZFTyT17YeW3NWs+ItFPRBzBzrhDJrYbfe2pKiPXxdsdkhaB+n9dBe3NDaAYD6zwlwNKEBy8Xqtq0OoLtB62hdz2pVu+8YM8aK8YNBQ4qyBvS0+euW9GZVNeuFq1C1DVqxE2L8PZNo7p50tpVOPXJFYKEJ/i0ZgsXdowl5PXxa9pbrxnEtcagDp6yvPCloIZXFfn/jkC4lMbf4f8GMFRTwspgxmuC1P9Q/sZZMQ+0/xRxLEhFek+XxlZ3Z7hKQqyZ4zcYzOwG+z8rHu0YAAXszcNtNf3q+f8bKO4CqZfGIebSkJvsIIuOi26Ti14PFKm7uYOYp5JUsJpcQCoO3x9cchTpaz5w09cf7EeGXD9I3o41dGe0x6/mtAblmNPIWmBdas6t/AcSYQUDOLarZloQ6edE6BrEa0e9kMH85Lb/c2t0b9wioH9bHbOqVwHfBeJqBXBJgFPch6p8H6pdv75w7a2kT3BQBX2kBGq8zK6sst4LwvCiL/aQ3x3K9AnR98xu5A1WbGQKwQm9ZLSEkMfxe0qdb5LVV5WTSOt1CPMls2ouB3k8DeE3kyBA91nqpt3lyS4AZ0FcDQ1SKHmZWDxOhlBnOuVtHt0RIMWMPkfiDIH6HymIf9RbMHfexALOd6BxFrG0oFA82kbbOFCWMixDUAOSdoyca2m4VKnv8bQPejvPePPt/wN6o1N2Y/wHLKwt0OmvPLQAAAABJRU5ErkJggg==)
      no-repeat 0;
    background-size: 20px 20px;
  }
  
  .goods-wrap
    .goods-list
    > ul
    > li
    .feedback-shade-de
    .feedback-de
    .item
    .type-zb {
    background: url(data:image/png;base64,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)
      no-repeat 0;
    background-size: 20px 20px;
  }
  
  .goods-wrap .goods-list > ul > li .feedback-shade-de .feedback-de .item:hover {
    background: #e3e6f4;
  }
  
  .goods-wrap .goods-list > ul > li .show-feedback-btn {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 14px;
    right: 18px;
    z-index: 5;
    cursor: pointer;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAJNJREFUWEdjZBhgwDjA9jOMOmA0BEZDYDQERkMAHgL///9nu337dtO/f//iQMUzExPTIlVV1TpGRsZfyMU1tdXBHXDr1q2Of//+lSNbxsTE1KmmplaBLEZtdXAH3Lhx4xkDA4MkWuX0XENDQwpZjNrqBo8DqB20xJo3eBLhQDVMRgui0RAYDYHREBgNgdEQGPAQAACGFpYh/9JqngAAAABJRU5ErkJggg==)
      no-repeat 50%;
    background-size: contain;
  }
  
  .goods-wrap .goods-list > ul > li .recommend-close-btn {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 14px;
    right: 20px;
    z-index: 5;
    cursor: pointer;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAPdJREFUOE+tkzFuwjAUhn87g9WtAxcwS+yqh0AcBcHGAlvVvd3aC7Qbl2CBC7BGdrLkBoiNhfhVHiI5zSOqlHq0/H9+/5dYYOQSI/P4X4BzbiWlnOR5/s5NVlWVDSG8KqXWWutLPNOZoCzLFyJ6I6JPa+02hcRw0zRHIcRNKfXMAmLAOfchhNikkDRMRHNrbdXCWQcpJITwJaU8xJt/h3sV0pFbCIArgDMXHgQURfGUZdkJwAOAb2PMkhPLVkg7A9gDWHBi2Qk4YZxYVuKQ7XuQTgXv/Q7A7J6wROzUGFP3KtR1/Rg325+Ek+a912148Cv89ZGNfkw/BtKeERwLU5UAAAAASUVORK5CYII=)
      no-repeat 50%;
    background-size: contain;
  }
  
  .goods-wrap .goods-list .is_recommend_item .is_recommend_item_title {
    position: absolute;
    top: 11px;
    left: 20px;
    font-size: 16px;
    font-weight: 700;
    color: #262626;
  }
  
  .goods-wrap .goods-list .is_recommend_item a {
    background-image: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/pages/zuhao/img/recommend-item-bg.330e168.png) !important;
    background-repeat: no-repeat !important;
    background-position: top !important;
    background-size: 100% auto !important;
    padding-top: 41px !important;
  }
  
  .goods-wrap .goods-list .is_recommend_item .recommend-close-shade-de {
    width: 154px;
    height: 104px;
    background: #fff;
    -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 39px;
    right: 4px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 4px 16px;
    border-radius: 5px;
    display: none;
  }
  
  .goods-wrap .goods-list .is_recommend_item .recommend-close-shade-de:after {
    content: "";
    width: 11px;
    height: 8px;
    position: absolute;
    top: -8px;
    right: 18px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAICAYAAAAvOAWIAAAAAXNSR0IArs4c6QAAAJhJREFUKFN9ziFugmEURNEzaYKpQ1Zjm6AR1U1X0AUg6A7KCmAHVNS3KyDVCHQTLJodYEjIaxA/+UKgT87cuXlxcVXVwyfGSQ5tnSvwDO+YJ5nehKtqhBXucMRTknU3OJur6h6/GDS2LYZJ9qeshReYXL6FjyRvZ7iqnrFsx82o8JLkJ1XVxwYPV6xdtMPjCf7C6z9gV33/ASuXKrz2sYhiAAAAAElFTkSuQmCC)
      no-repeat 50%;
  }
  
  .goods-wrap
    .goods-list
    .is_recommend_item
    .recommend-close-shade-de
    .recommend-close-item {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 47px;
    cursor: pointer;
    margin-bottom: 0;
    border-bottom: 1px solid #f5f5f5;
  }
  
  .goods-wrap
    .goods-list
    .is_recommend_item
    .recommend-close-shade-de
    .recommend-close-item:last-child {
    margin-bottom: 0;
    border: 0;
  }
  
  .goods-wrap
    .goods-list
    .is_recommend_item
    .recommend-close-shade-de
    .recommend-close-item:first-child
    .recommend-close-item-icon {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAh9JREFUOE+lkzFoU1EUhv//Jr5m6dKqOHRQSl10UcRJapBSeI97o6BRLFarbiqoSwdxcnUpgqNWKeoQFJv70pgEaToJDh1EBHVxquAQECokz7x35JYkhKJC9W6Xe87Hf/7zX+I/D7v92Ww2U6/Xm1vlbQC01mMk34vIpTAMn2wF0lVAY8xDAOeSJJluNBqLw8PD8yT3i4gC8BnAy/X19WebVfZGAKC01vMApkTkolLqqIj8ICkADgA4AmAtSZIbpVLpRVdlT0Eul7sdx/EbkjMkTwM4a6193i3sjHkXQE5E7oVheBOAOIAyxjwAMA3gRCaTKTebTefDySRJpkqlUqHfE631NZJzABastZeptZ4jeRXABWvt046p5wE8IvlTRE6FYWj7IcaYKQCPReS+M29VRIaiKDpcrVa/uUJjjJN3B8AKgIk4js8sLS0tdiGTk5M7Pc97S7LBIAj2plKpZRH53mq1Jmq12prv+6PpdPodgC8ARgFsc9u21pY7zXWSQ3Ecj/fn4DWANIAZa201CIJDqVTquoiQ5A4RGSd5vLORK+122y+Xyx96awyCYJdSaoHkBIBXAFwOVtvttiK5XSl1C8AxBxkYGFgpFAqRG6k/Bxt3Y0xeRGZJHux7j6Io2u15ngubU6KLxeLy7wA9s33fH1FKjSmlkiiKPlUqla/uvwwODjoz91lrR/4K+NN/yOfzXqvV2lMsFj/+E2Az+BfiUNlASgt3hwAAAABJRU5ErkJggg==)
      no-repeat 50%;
  }
  
  .goods-wrap
    .goods-list
    .is_recommend_item
    .recommend-close-shade-de
    .recommend-close-item:nth-child(2)
    .recommend-close-item-icon {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAVpJREFUOE+lkzFLw1AUhc9Nhha0CA7iojjqrIOT1CVI0/wP0UlxEp2ETrr6A5wEF+HldaiDRRcHgzgpjmJQHEoFoQZJjryixUZMq33LW+753nnn3isY8MiAenQArutuisi8SDaTJEheaK0r5vF2ted50wBuAJwBeOnhagTAAoAZpdRtG+C67qxlWZdJksxprYMsQLr2B8C27bs4jpcA2ClQqLU+7wmwLGuK5JGkwiD54Pv+RE+A+YLjOEP5fN767iAMw7cgCN77AmRl4DjOWC6XU1EUebVa7bmvEEul0ni1Wn0y4GKxOGzuer3+2mljVheM2LbtR5LbAA5E5BTAiVJquS+AKSqXy1siskOyISJNkou+79//BTAJ4EpERgHsKaU2vnL6dRJJRnEcr7VarWahULg2ApLHIrIOYFUptd9x8DmNXbuQAuySrBjbnuetJEnS0FofdgH+u5UfE7/tEVll0wkAAAAASUVORK5CYII=)
      no-repeat 50%;
  }
  
  .goods-wrap
    .goods-list
    .is_recommend_item
    .recommend-close-shade-de
    .recommend-close-item
    .recommend-close-item-icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  
  .goods-wrap
    .goods-list
    .is_recommend_item
    .recommend-close-shade-de
    .recommend-close-item
    .recommend-close-item-name {
    font-size: 14px;
    font-weight: 400;
    color: #4d4d4d;
  }
  
  .goods-wrap .goods-img {
    width: 125px;
    position: relative;
  }
  
  .goods-wrap .goods-img .list-img {
    display: block;
    width: 90px;
    height: 90px;
    position: relative;
    margin-left: 23px;
  }
  
  .goods-wrap .goods-img .shop-hb-tag {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/pages/zuhao/img/shop-hb-tag.d7712af.png)
      no-repeat;
    height: 19px;
    text-indent: -9999px;
  }
  
  .goods-wrap .goods-img .table-img {
    display: block;
    width: 90px;
    height: 90px;
    -o-object-fit: cover;
    object-fit: cover;
  }
  
  .goods-wrap .goods-img .table-img.height_90 {
    height: 90px !important;
  }
  
  .goods-wrap .goods-img .table-img.height_100 {
    height: 100px !important;
  }
  
  .goods-wrap .goods-img .phone-system-icon {
    position: absolute;
    left: 0;
    top: 0;
  }
  
  .goods-wrap .goods-info {
    width: 47%;
  }
  
  .goods-wrap .goods-title {
    font-weight: 700;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #000;
    width: 95%;
    font-size: 0;
    max-width: 535px;
    line-height: 20px;
  }
  
  .goods-wrap .goods-title .summer7 {
    height: 16px;
    width: 56px;
    font-weight: 400;
    display: inline-block;
    font-size: 12px;
    color: #262626;
    line-height: 16px;
    text-align: center;
    background: url(https://zuhaowan.zuhaowan.com/static/www/huodong/eventRegistration/img/summer7.png)
      no-repeat 50%;
  }
  
  .goods-wrap .goods-title .newZoneName {
    top: 20px;
    left: 23px;
  }
  
  .goods-wrap .goods-title-con {
    display: inline-block;
    max-width: 374px;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
  }
  
  .goods-wrap .account-tag,
  .goods-wrap .android-tag,
  .goods-wrap .domestic-tag,
  .goods-wrap .international-tag,
  .goods-wrap .ios-tag {
    color: #fff;
    font-size: 12px;
    border-radius: 2px;
    line-height: 16px;
    margin-right: 6px;
    padding: 0 6px 1px;
    vertical-align: middle;
    display: inline-block;
  }
  
  .goods-wrap .android-tag {
    background-color: #329c22;
  }
  
  .goods-wrap .ios-tag {
    background-color: #d96a29;
  }
  
  .goods-wrap .international-tag {
    background-color: #296ad9;
  }
  
  .goods-wrap .domestic-tag {
    background-color: #4d4d4d;
  }
  
  .goods-wrap .account-tag {
    display: inline-block;
    background: #ff893d;
  }
  
  .goods-wrap .goods-game-info {
    line-height: 1;
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    color: #fc3737;
  }
  
  .goods-wrap .goods-game-info .hidden_hot:before {
    content: "";
    display: inline-block;
    width: 2px;
    height: 11px;
    background-color: hsla(0, 0%, 85.1%, 0.6);
    margin: 0 15px 0 16px;
    position: relative;
    top: 2px;
  }
  
  .goods-wrap .goods-rent-times {
    line-height: 1;
    margin-top: 5px;
  }
  
  .goods-wrap .goods-rent-times span {
    font-size: 12px;
    color: #888;
  }
  
  .goods-wrap .goods-rent-times .skin {
    display: none;
  }
  
  .goods-wrap .goods-flags {
    margin-top: 2px;
    position: relative;
  }
  
  .goods-wrap .goods-flags .discount {
    border-radius: 2px;
    border: 1px solid #ff2828;
    color: #ff2828;
    padding-right: 8px;
    float: left;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 12px;
    margin-right: 15px;
  }
  
  .goods-wrap .goods-flags .discount:before {
    content: "优惠";
    display: inline-block;
    width: 32px;
    color: #fff;
    background: #ff2828;
    text-align: center;
    margin-right: 6px;
    height: 100%;
    padding: 2px 0;
  }
  
  .goods-wrap .goods-flags .flag {
    position: relative;
    float: left;
    margin: 8px 8px 0 0;
    line-height: 1;
    font-size: 12px;
    font-weight: 400;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0;
    color: #fc3737;
    background-color: #ffefef;
    border-radius: 2px;
    padding: 3px 5px;
    -webkit-transition: background-color 0.2s, color 0.2s;
    -moz-transition: background-color 0.2s, color 0.2s;
    transition: background-color 0.2s, color 0.2s;
  }
  
  .goods-wrap .goods-flags .flag:hover {
    background: #fc3737;
    color: #fff;
  }
  
  .goods-wrap .goods-flags .flag:hover .goods-flag-tip {
    display: block;
  }
  
  .goods-wrap .goods-flags .flag-normal {
    background: #f0f6ff;
    color: #418dff;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -moz-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  
  .goods-wrap .goods-flags .flag-normal .icon-hint {
    width: 12px;
    height: 12px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAvNJREFUSEu1ll+IlGUUxn/PzLZ2MUt/kC4WcQ1D6za6EKSLmWklkcwNLchuhGIhbVlnsLoIqjtN5htbN6Iy6qI2SkoryqLdGYUosAi6qRQEoVYII6pdTGdnvke+Ycdmv/mzK7Tf7XvO+Z3znPOe9xNdvs1jXlWp8aDNFsxai/7IXOYC4pzEZ71JPj4xot86hVG7g8HD7q9VeBGxyybZLQmJGuatZC/Pf/WULsRtWwDpQ95KjXeAPsSczHGL44levr9V1AP8afrDCvfIbLPYhrkBmCHJY+VRfdIMWQDIFjxiKBoSEsfoYV9pROe6VZAZ81qqHLQZEoSCvVN5jTV8rgGizFXjWHRg8Ww5p4PdAsfP0oH3yeyv+ycZalRSB0SaVyv8Mi/L09cbvAGLIJiXIrl6erkz6kkdkCn4DcPjkSylnB5ql3n2kAdDs0HmJoufBm5m4u1duhy3zQT+aF6uI6W8nlA0ileqnHekXw93xTV/wU6cCphARODTmFnERsxFiXtLOU03Q6KeuMrPgsSKHtYoW/TuMGRccLSU18PxjLKBnwzNy8kk6clRfV2veNwDVPgB+KKU086WKgr+wLAjkWCPMoE/t9mM2FnOaaKN8SmLi+WctjefpQMfAbLlnG5v0/BHMe9KnFCm4DOGdYkVrJ/ao7MtgKL3J0K+m8zrwwVSBH4Pc3cpr/UtVY97XXiFM4KzSgeewaRW3kjf0d2aXcpoDha9sRpyUnCglNdzcZ8drzj1x2VmELPXDbiv4A2h+NLwzcAtDLWbpK1vum/mL/6pAxaTqDm7+4teUzE/Yk7ekWL768OaazvSzRIt1uQFjS14HHgklWLg02Fd6iRnOvB/TV5sTGOT8y0wHZ+ormO62EVrdn7gNa/8F+Ymh/V3p+xbLtpSV8W83TNKcn5qVO93BMRXxVKX3aZXfdvcJX4Hfi3ntbodoOOyi4yXsq6zRUe3eXpqr6JeLPi6ruuG5bI+OA3Isj6ZDciyPvrNwv4fvy1XAQI/vWae7aleAAAAAElFTkSuQmCC)
      no-repeat;
    background-size: 100% auto;
    margin-left: 2px;
  }
  
  .goods-wrap .goods-flags .flag-normal:hover {
    color: #418dff;
    background: #f0f6ff;
  }
  
  .goods-wrap .goods-flags .flag-normal .goods-flag-tip:before {
    left: 103px;
  }
  
  .goods-wrap .goods-flags .goods-flag-tip {
    display: none;
    color: rgba(0, 0, 0, 0.65);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    list-style: none;
    position: absolute;
    z-index: 99;
    visibility: visible;
    max-width: 260px;
    width: 255px;
    line-height: 1.5;
    font-size: 12px;
    -webkit-transform-origin: 0 -4px 0;
    -moz-transform-origin: 0 -4px 0;
    -ms-transform-origin: 0 -4px 0;
    transform-origin: 0 -4px 0;
    top: 30px;
    left: -12px;
  }
  
  .goods-wrap .goods-flags .goods-flag-tip:before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    top: -5px;
    border-color: transparent transparent #fff;
    border-style: solid;
    border-width: 0 5px 5px;
    left: 16px;
  }
  
  .goods-wrap .goods-flags .goods-flag-tip span {
    display: block;
    padding: 6px 8px;
    color: #666;
    text-align: left;
    text-decoration: none;
    background-color: #fff;
    border-radius: 4px;
    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    min-height: 20px;
    word-break: break-all;
  }
  
  .goods-wrap .goods-price {
    width: 25%;
    text-align: center;
    line-height: 1;
    font-size: 12px;
    font-weight: 400;
    color: #8b8b8b;
  }
  
  .goods-wrap .goods-price .price-sale {
    font-size: 18px;
    color: #fc3737;
    font-weight: 700;
    margin-right: 5px;
  }
  
  .goods-wrap .goods-price .price-hyphen {
    text-decoration: line-through;
  }
  
  .goods-wrap .goods-price .price-rent {
    font-weight: 700;
    color: #fc3737;
    font-size: 14px;
  }
  
  .goods-wrap .goods-price .price-rent .limit_full_reduction {
    padding: 2px 4px;
    background: #ff2424;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    border-radius: 2px;
  }
  
  .goods-wrap .goods-price .price-rent .crossed_price {
    color: #999;
    text-decoration: line-through;
    font-weight: 400;
    font-size: 12px;
    padding-left: 3px;
  }
  
  .goods-wrap .goods-price .price-condition {
    margin-top: 8px;
  }
  
  .goods-wrap .goods-price .price-least {
    margin-top: 10px;
  }
  
  .goods-wrap .goods-price .price-least span {
    color: #fc3737;
    font-weight: 700;
  }
  
  .goods-wrap .goods-price .price-least label {
    font-size: 14px;
  }
  
  .goods-wrap .goods-price .price-vip {
    text-align: center;
    line-height: 35px;
    color: #222;
    font-weight: 700;
    font-size: 14px;
  }
  
  .goods-wrap .goods-price .price-vip i {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAASCAYAAAAZk42HAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDphMDIzMWY2NS1hMmNiLTQ0MmItOWRhYy00YjQ3OTUwMzE4YTQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDA2N0FDRkVFNjQ4MTFFOUE1REE5RDJCRENDMDAzMUQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDA2N0FDRkRFNjQ4MTFFOUE1REE5RDJCRENDMDAzMUQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0OGYxYTkzZS0xMGZkLTQwMWItOWUyYS0xNjQ0NWYzZGE3NGYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6YTAyMzFmNjUtYTJjYi00NDJiLTlkYWMtNGI0Nzk1MDMxOGE0Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+3TLzxgAABf1JREFUeNpsV3tMllUY/x2Gco2Pi6iUIoKoqVsylC1DsbAyLWmurGy6pnQx3Zr2F3P5Z2zdnDNrtbnmurq0pqVdZpmk/eFIEhGVPhRBBAG5yCegbd/Tc857znnP+8EL5zvve97nPOe5/p7nFevWrXuCCHsByoG8+IHkJH/1vZrJWbPPfEVJrXvPUch/71kP+RdVhB6N3kgU9d9bPjzxLPSaR+Pz04KZHWatgzdsjONnVgI5At4l2Xg3cnbvoSWHXZcHGhJ7CXIIhXcr/D2GnWFPmkaJz4IJvYUohiX0hpjzSFAOK7Y3TikhfFkxSi7/haQzhEIr5h7oSSACNAJjMLbWdXiJoFGEazejjCDfLvpgbbecONfSRD4HAbJuTL9nPJy9SEtNtJ4TgcOF6zCE0hLGMiIQY2CCOVOMaUSyTIQJeraBphbeuzjtHmUdwbOruZwl8StPl6B8wXR+L5DOSuzYsBRzC7IVs4A7hB5a48qKhdhRWT62Eo4FX3h8PrZXLtM5A2SFkvDLx6+jYukcG8ImV90oJRsWvMTJTmTNTdbym59ZgCkTQ9Zb901MR3tXPzJCKRgZuYvhO/9ZUbbtPIJ5+dnYsGphQN6kxHHIDKXi2o3eYJzwtentAzK/FYed2ypw7PQlHK5pVMpUb1mJ7r5BLJgzDZur9+PmwDCDQFQnlQECUoZXQMJzfDCLhTYm4cNva/FU6QxkZ6SqZ6lAU2sPZuYCPf1DuHnrttr2019Naue55m5s/YAVYk+lJo/30UXzM3wbmjuVYDrhMD0nA1N4/MBKCCZau7xI8Xv/8xOoKJuDPVXPsTLf8JnDHkoJbWnhp4Kc400sUqzJ+HrogTx893uDOnDm1AmoD3ciMy1ZKVH/bwceLi7AvdmpuNrZ7wnLTDdWlPCht9Vw3SAPWzQ/H3v216DmzBUvTHisKpuH3v6Iotn+8qNIThiPqt0/qr2H/jivjLKn6nl8cqAGv50O29AUUVjPyIV4k/rCwWcLrSxZZPgu1q8owsmzLTh9vh2RoTt46clizMrNVsK6CSr09qmTMzAhPUX7mqw+yYnxDioLNkoiHnvwfhV6W18sU68awtdRMCUT4bZeFEzNVGvv7jvGRiv0FNH5Z2XVHvI564SHS8Br61cWIYmtVMrekcO9Cqdl43ht2MV01NRdRm3jNbR09Ou0i8pSqNg+Wz6PhR7QRgNeXb0IdRfbOHxTsPPLE2rx07fW4Hr3AMLXepE7OR2PlMzGF0f/Ru35tiAwCye2TI4QgkpYK/JaU1uPj48xvzPZKy64rmaUWVKUr4aPSx5tFid9aigZk7LOYdfXJ5Uyp85eVqzWriiOQbMgZBMJ625TAoz3jajxLjqTrgWG5lT9Fdy4GfGFt8hKWFqcj5P/XEF79y174PfHL+Dg8UblBdOOSPidwBavu9SGc00dOHLqolXwRF0LK50XyKMsBpfWzj4d+06DEPVrlin0pEsFTLL7ZYm8QsO31ZuXqTcZnNwjDLXDDLnuJeFY5kHp/Dx8drgWMziuFzueMFcue+1qaxdyJ2WosXKxVxs2VR9U/ZWTYSiePVndNXNYBQoteUDiFmwKlGGbI05l1jhd9dExPodRpbQQy0oKse9IHRoud3nKsnXee2M53tx11Fq+PnyDvXFBN3JkG71Duyux5Z1DAS/ZhBV+6ElhXluzGAd+PRMIIdfQItjF+c2tRa1Y5NUpI4kP/9mkLNTePYiKJbNUwicljOOwaxlVrYUOu9XlMlcKVEGMDAzp44TqgP06TYG2poxDtacvgq9+PjO6NXNbuUCWan+IMSq7bc/JbeM9BqGUBCVM3+AdvwUnp5XX7Xga92Zz8yaqlcbmLvTeGlIqmE8A1fBHtUDOZ4Bp9Q1d1JHD7jcqRH3ZDGp1sE45pPtnIQg+aOlQ037sj4wgCN9efFrA0/EwMDjCHmv1Q0wXsKiDQh5rcppU+d6EtrBJPLo9E/B7YOudTtk0VvLodCHWaSpHf4eIoNOJggeRDaPgdwW5kGmUCH5XBIKInFJLboLHQrRAO/9s/F+AAQA28W8e51ZzxgAAAABJRU5ErkJggg==)
      no-repeat 0 0;
    display: inline-block;
    width: 50px;
    height: 18px;
    vertical-align: middle;
    margin-top: -2px;
    margin-right: 5px;
  }
  
  .goods-wrap .goods-price .price-coupon {
    font-size: 14px;
    color: #4d4d4d;
    margin-top: 5px;
  }
  
  .goods-wrap .goods-price .price-coupon .icon {
    height: 16px;
    background: -webkit-gradient(
      linear,
      right top,
      left top,
      from(#ff6d27),
      to(#ff9510)
    );
    background: -webkit-linear-gradient(right, #ff6d27, #ff9510);
    background: -moz-linear-gradient(right, #ff6d27 0, #ff9510 100%);
    background: linear-gradient(270deg, #ff6d27, #ff9510);
    border-radius: 2px;
    display: inline-block;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    padding: 0 4px;
    vertical-align: 0;
  }
  
  .goods-wrap .goods-price .price-vip-new {
    font-size: 14px;
    color: #4d4d4d;
    margin-top: 5px;
  }
  
  .goods-wrap .goods-price .price-vip-new .icon {
    height: 16px;
    background: #ffe1d3;
    font-weight: 600;
    color: #8f2f1d;
    border-radius: 2px;
    display: inline-block;
    font-size: 12px;
    line-height: 16px;
    padding: 0 4px;
    vertical-align: 0;
  }
  
  .goods-wrap .goods-control {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
  
  .goods-wrap .carousel {
    width: 648px;
    height: 500px;
    border: 1px solid #bbb;
    position: absolute;
    left: 125px;
    top: 0;
    z-index: 2;
    display: none;
    background: #fff;
    text-align: center;
    -webkit-box-shadow: 1px 1px 5px rgba(24, 8, 8, 0.5);
    box-shadow: 1px 1px 5px rgba(24, 8, 8, 0.5);
  }
  
  .goods-wrap .carousel .slideshow {
    width: 620px;
    height: 410px;
    position: relative;
    overflow: hidden;
    margin: 14px;
  }
  
  .goods-wrap .carousel .slideshow li {
    height: 100%;
    background: #fff;
  }
  
  .goods-wrap .carousel .slideshow li img {
    max-width: 100%;
    border-radius: 1%;
    height: 100%;
  }
  
  .goods-wrap .carousel .swiper-next,
  .goods-wrap .carousel .swiper-prev {
    width: 34px;
    height: 60px;
    position: absolute;
    top: 50%;
    margin-top: -30px;
    cursor: pointer;
    z-index: 2;
  }
  
  .goods-wrap .carousel .swiper-prev {
    left: 0;
    background-position: -127px -68px;
  }
  
  .goods-wrap .carousel .swiper-next {
    right: 0;
    background-position: -203px -69px;
  }
  
  .goods-wrap .carousel .swiper-prev:hover {
    background-position: -165px -68px;
  }
  
  .goods-wrap .carousel .swiper-next:hover {
    background-position: -241px -69px;
  }
  
  .goods-wrap .carousel .swiper-pagination span {
    background: #ccc;
  }
  
  .goods-wrap .carousel .swiper-pagination span.swiper-pagination-bullet-active {
    background: #fc3737;
  }
  
  .goods-wrap .carousel button {
    background: #fc3737;
    color: #fff;
    margin: 22px auto 10px;
  }
  
  .goods-wrap .carousel button .experiencing {
    font-weight: 700;
  }
  
  .goods-wrap .carousel ol {
    width: auto;
  }
  
  .goods-wrap .s_audio {
    position: absolute;
    bottom: 25px;
    left: 20px;
    width: 100px;
    height: 23px;
    background-color: rgba(0, 0, 0, 0.8);
  }
  
  .goods-wrap .s_audio span {
    float: left;
    color: #fff;
  }
  
  .goods-wrap .s_audio .s_time {
    padding: 2px 0 0 5px;
  }
  
  .goods-wrap .s_audio span:last-of-type {
    float: right;
    padding: 2px 5px 0 0;
  }
  
  .goods-wrap .mi-audio-suspend {
    width: 18px;
    height: 18px;
    margin: 2px 0 0 5px;
    cursor: pointer;
    background: url(//zuhaowan.zuhaowan.com/pic/201911/0712_bf.1414648e96f64424.png)
      no-repeat;
  }
  
  .goods-wrap .mi-audio-play {
    width: 19px;
    height: 18px;
    background: url(//zuhaowan.zuhaowan.com/pic/201911/horn_play.d5c06b15bd198374.gif)
      no-repeat;
    margin: 3px 0 0 5px;
    cursor: pointer;
  }
  
  .goods-wrap .gamename {
    text-align: center;
    margin-left: 15px;
    line-height: 20px;
    padding-top: 6px;
    color: #333;
    font-size: 12px;
    width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  
  .goods-empty-all {
    height: 336px;
    background-color: #fff;
    margin-top: 20px;
  }
  
  .goods-empty-all .no-data-img {
    padding: 65px 0 0 309px;
    width: 289px;
    height: 160px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/pages/zuhao/img/goods-empty-all.72cd2c5.png)
      no-repeat 100% 100%;
    float: left;
  }
  
  .goods-empty-all .no-data-tip {
    padding: 91px 21px 0;
    text-align: left;
  }
  
  .goods-empty-all .no-data-tip .no-data-h {
    font-size: 14px;
    font-weight: 400;
    color: #464646;
    line-height: 1;
    margin-bottom: 16px;
  }
  
  .goods-empty-all .no-data-tip .no-data-txt {
    font-size: 12px;
    font-weight: 400;
    color: #a6a6a6;
    line-height: 1;
    margin-bottom: 10px;
  }
  
  .goods-empty-all .no-data-tip .no-data-btn {
    display: block;
    width: 72px;
    height: 25px;
    background-color: #fc3737;
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    line-height: 25px;
    margin-top: 16px;
  }
  
  .goods-empty-all .no-data-tip .no-data-btn:hover {
    -webkit-box-shadow: 0 5px 13px 0 rgba(252, 55, 55, 0.28);
    box-shadow: 0 5px 13px 0 rgba(252, 55, 55, 0.28);
  }
  
  .goods-empty-data {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    margin-top: 33px;
    background: initial;
  }
  
  .goods-empty-box {
    text-align: center;
  }
  
  .goods-empty-data .no-data-img {
    display: inline-block;
    height: 48px;
    width: 60px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/pages/zuhao/img/goods-empty-zuhao.ccbb50c.png)
      no-repeat;
    background-size: 100% 100%;
  }
  
  .goods-empty-data .no-data-txt {
    display: inline-block;
    vertical-align: 17px;
    font-weight: 400;
    margin-left: 10px;
    color: #a1a0ab;
  }
  
  .similar-account-title {
    height: 19px;
    font-size: 16px;
    font-weight: 700;
    color: #000;
    line-height: 19px;
    margin: 20px 0 14px;
    padding-left: 23px;
  }
  
  .bottom_img_box img {
    display: block;
    height: 176px;
    width: 176px;
  }
  
  .bottom_item_mes {
    line-height: 1;
    margin-top: 7px;
    margin-bottom: 11px;
  }
  
  .bottom_item_mes span {
    font-size: 12px;
    font-weight: 400;
    color: #424242;
  }
  
  .bottom_item_mes em {
    font-size: 12px;
    font-weight: 700;
    color: #e6292c;
  }
  
  .bottom_item_title {
    display: block;
    max-height: 32px;
    font-size: 12px;
    font-weight: 400;
    color: #7c7c7c;
    overflow: hidden;
    word-break: break-all;
  }
  
  .bottom_item_title:hover,
  a.bottom_item_title {
    color: #7c7c7c;
  }
  
  .bottom_img_box .left_hb_img {
    position: absolute;
    width: 176px;
    height: 22px;
    bottom: 0;
    left: 0;
  }
  
  .bottom_item_mes .hb_line_th {
    font-weight: 400;
    text-decoration: line-through;
    color: #888;
  }
  
  .bottom_item_mes .ztc_redbag {
    width: 12px;
    height: 14px;
    margin: 0 6px 0 0;
  }
  
  .bottom_item_mes .hb_price {
    color: #fc3737;
    font-weight: 700;
    font-size: 12px;
  }
  
  .zl-scrollContentDiv {
    margin-left: 20px;
  }
  
  .immediate-use-btn {
    width: 251px;
    height: 128px;
    background: url(https://zuhaowan.zuhaowan.com/v1/pull_new/v2/newimg/hb-usenow.png)
      no-repeat;
    margin: 116px auto 0;
    cursor: pointer;
  }
  
  .immediate-use-btn a {
    display: block;
    width: 100%;
    height: 100%;
  }
  
  .user_hb_new .layui-layer-setwin {
    left: 50%;
    bottom: -48px;
    right: auto;
    top: auto;
    width: 32px !important;
    height: 32px !important;
    margin-left: -16px;
  }
  
  .user_hb_new .layui-layer-setwin .layui-layer-close {
    width: 32px !important;
    height: 32px !important;
    background: url(//zuhaowan.zuhaowan.com/v1/pull_new/images/hb_close.png);
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    top: 0;
    right: 0;
    cursor: pointer;
  }
  
  .user_hb_new .layui-layer-setwin .layui-layer-close:hover {
    background: url(//zuhaowan.zuhaowan.com/v1/pull_new/images/hb_close_hov.png);
  }
  
  .hb-item {
    width: 301px;
    height: 98px;
    background: hsla(0, 100%, 71%, 0.1);
    border-radius: 6px;
    margin-bottom: 12px;
  }
  
  .hb-item:last-child {
    margin-bottom: 0;
  }
  
  .item-left {
    float: left;
    width: 62px;
    height: 74px;
    background: url(//zuhaowan.zuhaowan.com/v1/pull_new/images/hb_bg.png)
      no-repeat;
    margin: 12px 0 0 12px;
  }
  
  .hb-num {
    font-size: 16px;
    color: #fff;
    padding-top: 24px;
    text-align: center;
  }
  
  .item-right {
    float: left;
    margin: 23px 0 0 16px;
  }
  
  .hb_title {
    font-size: 20px;
    font-weight: 700;
    color: #b14141;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .hb-time {
    font-size: 12px;
    color: #ba6868;
    margin-top: 10px;
  }
  
  .hb-list_box {
    width: 305px;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    -webkit-transition: opacity 0.5s;
    -moz-transition: opacity 0.5s;
    transition: opacity 0.5s;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  #searchFormApp .filter_template_box,
  #searchFormApp .se-election-box,
  #searchFormApp .search-hot-history,
  #searchFormApp .template_box,
  #searchFormApp .template_hint {
    display: block;
  }
  
  #searchFormApp .page-empty-data {
    background-color: #fff;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    height: 336px;
    text-align: center;
    margin-top: 20px;
  }
  
  #searchFormApp .page-empty-data .no-data-img {
    padding-top: 53px;
    height: 160px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/pages/zuhao/img/goods-empty-all.72cd2c5.png)
      no-repeat bottom;
  }
  
  #searchFormApp .page-empty-data .no-data-txt {
    margin-top: 25px;
    font-weight: 400;
    color: #a6a6a6;
  }
  
  .goods-wrap .goods-img-num {
    display: none;
  }
  
  .goods-wrap .goods-info-price {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: 72%;
  }
  
  .goods-wrap .goods-info-price .goods-info {
    width: 65%;
  }
  
  .goods-wrap .goods-info-price .goods-info .IntroduceBox {
    display: none;
  }
  
  .goods-wrap .goods-info-price .goods-price {
    width: 35%;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    align-self: center;
  }
  
  .goods-wrap .goods-detail-btn,
  .goods-wrap .goods-game-info .area:before,
  .goods-wrap .hidden_hot,
  .goods-wrap .tj-old-price {
    display: none;
  }
  
  .goods-wrap202306 .goods-list .goods-info .goods-fix-height {
    min-height: 70px;
    height: auto;
  }
  
  .goods-wrap202306 .goods-list .goods-info .goods-fix-height .IntroduceBox {
    margin-top: 6px;
    display: block;
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .verified-icon {
    display: inline-block;
    background: url(//zuhaowan.zuhaowan.com/img/searchV1/verified_icon.png)
      no-repeat;
    background-size: 100% 100%;
    width: 64px;
    height: 18px;
    margin-right: 6px;
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .IntroduceImg {
    width: 18px;
    height: 18px;
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .IntroduceMes {
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 8px;
    border: 1px solid #ffe5d0;
    color: #a86c3a;
    border-radius: 0 4px 4px 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .recom_reason_lab_num_1,
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .recom_reason_lab_num_2 {
    border-color: #dbe7fb;
    color: #4b6fa9;
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .is-ban {
    position: relative;
    z-index: 10;
    margin-right: 6px;
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .is-ban:hover
    .goods-tag-tip {
    display: block;
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .is-ban
    .ban-txt {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -moz-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    height: 18px;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #ffbdcd;
    font-size: 12px;
    color: #f6194f;
    text-align: left;
    padding: 0 6px 0 22px;
    position: relative;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .is-ban
    .ban-txt:before {
    content: "";
    width: 18px;
    height: 18px;
    background: url(data:image/png;base64,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)
      no-repeat;
    background-size: 100% auto;
    position: absolute;
    left: -1px;
    top: -1px;
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .is-ban
    .goods-tag-tip {
    display: none;
    position: absolute;
    left: 50%;
    -webkit-transform: translate(-50%);
    -moz-transform: translate(-50%);
    -ms-transform: translate(-50%);
    transform: translate(-50%);
    top: 25px;
    white-space: nowrap;
    background: #fff;
    -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
    border: 1px solid #ddd;
    padding: 14px 12px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 4px;
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .is-ban
    .goods-tag-tip:before {
    position: absolute;
    content: "";
    width: 5px;
    height: 5px;
    background-color: #fff;
    top: -4px;
    border: 1px solid #ddd;
    border-right: none;
    border-bottom: none;
    left: 50%;
    -webkit-transform: translate(-50%) rotate(45deg);
    -moz-transform: translate(-50%) rotate(45deg);
    -ms-transform: translate(-50%) rotate(45deg);
    transform: translate(-50%) rotate(45deg);
  }
  
  .goods-wrap202306
    .goods-list
    .goods-info
    .goods-fix-height
    .IntroduceBox
    .is-ban
    .goods-tag-tip
    span {
    font-size: 12px;
    color: #666;
    line-height: 16px;
    text-align: left;
  }
  
  .ad-ff-previn {
    position: fixed;
    width: 672px;
    height: 542px;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 77;
  }
  
  .ad-ff-previn .close {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    font-size: 24px;
    color: #666;
    border: 1px solid #666;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
  }
  
  .recommond {
    position: relative;
    z-index: 999;
  }
  
  .recommond .recommond-dialog {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 200;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  
  .recommond .float-wrap {
    position: fixed;
    left: 50%;
    bottom: 150px;
    margin-left: 613px;
    z-index: 5;
  }
  
  .recommond .float-wrap .float-img {
    display: inline-block;
    width: 86px;
    height: 96px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/pages/zuhao/img/recom-btn.94041cd.png)
      no-repeat;
    background-size: 100% auto;
    cursor: pointer;
  }
  
  .recommond .float-wrap .remove-btn {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 0;
    top: 0;
    cursor: pointer;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAARJJREFUOE+tk79Og1AUxn8lLA4mDJWBgJCujYRNnXT1LXwJm/QJTNqX6Kt0st0IpqvhCmFAB5IOLo2ak/Saa8X4h7Lxne/8ON/l3B5fn0PgGDgCDrblF+AJeATWZkvPeLGAIRACpm763wAFrIBXKWijNJ8C/ZaJ2qRnYCkQDTgBol82a1sO3AtAMl+YY7uua9d1vTGBLZrEmQtAcg+0WYxlWc6qqlolSTIVPU3TG8/zhr7vX++AHwRwuZ3i44N5no/DMDwvimIhYhAEZ0qpuyiKbndirgVwBdhmwXEcO8uykTSKLqA4jidN03yKBWz2Avg2glJqYVnWjxE6H2Ln3yjn1GmRBNB5lTXk35fJXIM/Xed3oG6Fk7Sx2ZgAAAAASUVORK5CYII=)
      no-repeat 50%;
    background-size: 16px auto;
  }
  
  .recommond .recommond-main {
    width: 412px;
    background: #fff;
    -webkit-box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    padding-bottom: 32px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .recommond .recommond-top {
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/pages/zuhao/img/rec-bg.49d291f.png)
      no-repeat;
    background-size: 100% auto;
    text-align: center;
    position: relative;
  }
  
  .recommond .recommond-top .recommond-tit {
    font-size: 16px;
    font-weight: 700;
    color: #262626;
    line-height: 14px;
    padding: 30px 0 26px;
  }
  
  .recommond .recommond-top .close-btn {
    position: absolute;
    right: 12px;
    top: 12px;
    width: 20px;
    height: 20px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAL9JREFUKFNjZGBgYFjRO0Xt1z++p3GlcV9BfHSwqHsRNxvTJ+mI4pxbjCDF//7+v87IwHCNmeO/U1he3mtkDasmTRL9+4Nx338GBi0mZkZNRpBu1v8fT/xnYNBhZGS4wsyO0ARW/JNx3///DDqMDAxXfjPyWzCCTEORgGr68fMnIysDx16wYiSDwBqwaQKJoSsGicE1oGsCS6I5EUPDou5uMZgzCGpAVgwyGa+TsHkapAEeQsieJjlYSY44UpMGAHbXsJ/suDCdAAAAAElFTkSuQmCC)
      no-repeat 50%;
    background-size: 12px auto;
    cursor: pointer;
  }
  
  .recommond .hb-info {
    width: 328px;
    height: 78px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/pages/zuhao/img/hb-bg.10a355c.png)
      no-repeat;
    background-size: 100% auto;
    margin: 0 auto;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  
  .recommond .hb-info .hb-txt {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: left;
  }
  
  .recommond .hb-info .hb-txt .hb-name {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: 700;
    color: #333;
    line-height: 18px;
    margin-bottom: 8px;
  }
  
  .recommond .hb-info .hb-txt .hb-limit {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
  }
  
  .recommond .hb-info .hb-txt .limit {
    color: #4d4d4d;
  }
  
  .recommond .hb-info .hb-txt .time {
    color: #999;
    margin-left: 4px;
  }
  
  .recommond .hb-info .hb-txt .countdown {
    color: #ff2828;
    margin-left: 4px;
  }
  
  .recommond .hb-info .hb-money {
    min-width: 72px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
    -webkit-align-items: baseline;
    -moz-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 0 7px 0 15px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .recommond .hb-info .hb-money em {
    font-size: 12px;
    font-weight: 400;
    color: #ff2828;
    line-height: 14px;
    font-style: normal;
  }
  
  .recommond .hb-info .hb-money .int {
    font-size: 26px;
    font-weight: 700;
    color: #ff2828;
    line-height: 30px;
  }
  
  .recommond .hb-info .hb-money .float {
    font-size: 14px;
    font-weight: 700;
    color: #ff2828;
    line-height: 16px;
  }
  
  .recommond .hb-info .get-btn {
    height: 100%;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 80px;
    -moz-box-flex: 0;
    -ms-flex: 0 0 80px;
    flex: 0 0 80px;
    width: 80px;
    text-align: center;
    line-height: 78px;
    font-size: 12px;
    color: #fff;
    cursor: pointer;
  }
  
  .recommond .hb-info .get-btn.disabled {
    opacity: 0.5;
    cursor: auto;
  }
  
  .recommond .recommond-bottom {
    padding: 0 32px;
  }
  
  .recommond .recommond-bottom .tit {
    position: relative;
    margin: 17px 0 10px;
    text-align: center;
  }
  
  .recommond .recommond-bottom .tit:after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 100%;
    height: 1px;
    background: #eee;
    z-index: 5;
  }
  
  .recommond .recommond-bottom .tit span {
    display: inline-block;
    width: 180px;
    background-color: #fff;
    position: relative;
    z-index: 10;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #a1a0ab;
    line-height: 16px;
  }
  
  .recommond .recommond-bottom .link {
    display: block;
    font-size: 12px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: 700;
    color: #3d8bff;
    line-height: 16px;
    text-align: center;
    margin-top: 20px;
    cursor: pointer;
  }
  
  .recommond .game-item {
    height: 66px;
    background: #fafafa;
    border-radius: 6px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .recommond .game-item + .game-item {
    margin-top: 6px;
  }
  
  .recommond .game-item .game-img {
    width: 46px;
    height: 46px;
    border-radius: 4px;
    margin-right: 14px;
  }
  
  .recommond .game-item .md {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
  }
  
  .recommond .game-item .game-name {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: 700;
    color: #4d4d4d;
    line-height: 20px;
  }
  
  .recommond .game-item .game-tips {
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #ff2828;
    line-height: 16px;
    margin-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .recommond .game-item .btn {
    width: 78px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #ff3636;
    border-radius: 2px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #fff;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
  }
  
  .recommond .game-item .btn:hover {
    -webkit-box-shadow: 0 5px 11px 0 rgba(255, 101, 101, 0.5);
    box-shadow: 0 5px 11px 0 rgba(255, 101, 101, 0.5);
  }
  
  .recommond .submit {
    display: block;
    margin: 28px auto 0;
    width: 96px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ff3636;
    border-radius: 2px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #fff;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
  }
  
  .recommond .submit:hover {
    -webkit-box-shadow: 0 5px 11px 0 rgba(255, 101, 101, 0.5);
    box-shadow: 0 5px 11px 0 rgba(255, 101, 101, 0.5);
  }
  
  .wh-tips {
    width: 304px;
    height: 32px;
    line-height: 32px;
    background: #fff6e8;
    border-radius: 4px;
    margin-right: 10px;
    padding: 0 12px;
    display: none;
    position: relative;
    margin-left: 10px;
  }
  
  .wh-tips:after {
    content: "";
    border: 5px solid transparent;
    border-right-color: #fff6e8;
    position: absolute;
    left: -10px;
    top: 12px;
  }
  
  .wh-tips .tips-txt {
    font-size: 12px;
    color: #f29608;
    display: inline-block;
  }
  
  .wh-tips .hb-tips {
    float: right;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: #ff893d;
    border-radius: 2px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #fff;
    padding: 0 8px;
    cursor: pointer;
    margin-top: 6px;
  }
  
  .zhw-main.has-user-bg {
    background-image: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/newUserHb/bg.baf55e4.png);
    background-repeat: no-repeat;
    background-size: 100% auto;
    margin-top: 0;
    padding-top: 18px;
  }
  
  .newPullwapper {
    height: 0;
    z-index: 10;
    overflow: hidden;
  }
  
  .newPullwapper.show {
    padding: 20px 23px 0;
    margin-bottom: 22px;
    background: #fff;
    border-radius: 4px;
    -webkit-border-image: -webkit-linear-gradient(
        275deg,
        #fff,
        hsla(0, 0%, 100%, 0.52)
      )
      1 1;
    -moz-border-image: -moz-linear-gradient(275deg, #fff, hsla(0, 0%, 100%, 0.52))
      1 1;
    -o-border-image: linear-gradient(175deg, #fff, hsla(0, 0%, 100%, 0.52)) 1 1;
    border-image: linear-gradient(175deg, #fff, hsla(0, 0%, 100%, 0.52)) 1 1;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    height: 190px;
  }
  
  .newPullwapper .newPullinner {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  
  .newPullwapper .np-title {
    height: 33px;
    background-image: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/newUserHb/title.7d0a82d.png);
    background-size: auto 100%;
    background-repeat: no-repeat;
    margin-bottom: 18px;
    font-size: 0;
  }
  
  .newPullwapper .np-title.np-txt {
    background: none;
    font-size: 22px;
    color: #fe3a5c;
    font-weight: 700;
  }
  
  .newPullwapper .newPullinner[data-item="1"] .np-lfbox {
    width: 130px;
  }
  
  .newPullwapper .newPullinner[data-item="1"] .np-item {
    width: 100%;
    background-image: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/newUserHb/max-card.b2cd0a0.png);
    padding-right: 25px;
  }
  
  .newPullwapper .newPullinner[data-item="1"] .npfree-item .np-tips {
    display: block;
  }
  
  .newPullwapper .newPullinner[data-item="1"] .npfree-item .np-time {
    position: absolute;
    right: 118px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    margin: 0;
  }
  
  .newPullwapper .newPullinner[data-item="2"] .np-lfbox {
    width: 128px;
  }
  
  .newPullwapper .newPullinner[data-item="2"] .np-item {
    width: 568px;
    background-image: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/newUserHb/normal-card.e99bbfc.png);
    padding-right: 25px;
  }
  
  .newPullwapper .newPullinner[data-item="3"] .np-lfbox {
    width: 141px;
  }
  
  .newPullwapper .newPullinner[data-item="3"] .np-item {
    width: 372px;
    background-image: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/newUserHb/mini-card.39ec2f1.png);
    padding-right: 13px;
  }
  
  .newPullwapper .np-item {
    height: 96px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
  }
  
  .newPullwapper .np-icon {
    width: 60px;
    height: 60px;
    background-size: 100% 100%;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    margin: 0 12px;
  }
  
  .newPullwapper .np-lfbox {
    width: 128px;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    margin-right: 15px;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  
  .newPullwapper .np-lfbox:after {
    content: "";
    width: 18px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    display: block;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAABgCAIAAACfRrXKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUQzRTE1OUMwRjI5MTFFREI4N0I4MzM5RENFNkNDMDkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUQzRTE1OUQwRjI5MTFFREI4N0I4MzM5RENFNkNDMDkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBRDNFMTU5QTBGMjkxMUVEQjg3QjgzMzlEQ0U2Q0MwOSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBRDNFMTU5QjBGMjkxMUVEQjg3QjgzMzlEQ0U2Q0MwOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pos0IJoAAAIFSURBVHja7FhNTwIxEH1TV+OKIib4hSeiUePB//87TEyM8esCuGIUERZUQp1usS5Ly7Je7WQh0O7MvHnTvsPQQ0MisWoFpTXMsXiAl5fJb/ElJT+dnoyeMd/abbz15AgYQQYHB2qp08FzlOPWH2B7F5sVhU7opXIZvRiDodNnOEQ/xkb5ByR/CFgSqNVw/QApLT68eHOPvRqESLnpN3d2ZbAiL66yOfnv5RV4i18wixTLsU4ok+8oolYL6yFK4YQ9xrZfQ9rn1017ahuP0e2qYtjCVVW2wWbJ5jIDJG3CbEiHm7QFDVwbGjsJeyxhQmas2VKPwQIrSLJXRS4sv33LhBTsRNLJU6ZvLjKdtREKmHDFYxATMudQMts3w2Sxvi0EchYGkSLTBVIxmZuqQN8WAgk3kzm1kYPJYn3L3DdLA8wGTTNJ7gOUf7tzzuRfQMJ9u4vdt4WYLGqBq29iLkteJ71Oep30Oul10uuk10mvk14nvU56nfx/OhnMxjNjFl5cTcYsHJysEmTumxrqNLG+lozKZN5QRwe7vcPog47rapaTHiHd3qsRUv3QVhvnYZ/z0ykfPQ46O8Hok54imjlcY9VczkM2ZoTAUR2PTVX2VN/eumpIlcmTNuaGq33v/jDZaCTzuT42whzSSyHaEeK+AhcsJ3RUSqhu5bhtV7H0qmugbwEGAAwxfzeild20AAAAAElFTkSuQmCC);
    background-repeat: no-repeat;
    background-size: 100% auto;
    -webkit-transform: translateX(50%);
    -moz-transform: translateX(50%);
    -ms-transform: translateX(50%);
    transform: translateX(50%);
  }
  
  .newPullwapper .np-money {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
    -webkit-align-items: baseline;
    -moz-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #f6194f;
  }
  
  .newPullwapper .np-money i {
    font-size: 14px;
  }
  
  .newPullwapper .np-money span {
    font-size: 24px;
    font-weight: 700;
  }
  
  .newPullwapper .nphb-icon {
    background-image: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/newUserHb/hb-icon.e8089b6.png);
  }
  
  .newPullwapper .nprent-icon {
    background-image: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/newUserHb/rent-icon.e40bf5f.png);
  }
  
  .newPullwapper .npfree-icon {
    background-image: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/newUserHb/free-icon.e8a1909.png);
  }
  
  .newPullwapper .np-inner h4 {
    font-size: 18px;
    font-weight: 600;
    color: #262626;
    line-height: 24px;
  }
  
  .newPullwapper .np-tips {
    font-size: 12px;
    color: #666;
    margin-top: 6px;
  }
  
  .newPullwapper .np-tips b {
    font-weight: 400;
    padding: 0 4px;
  }
  
  .newPullwapper .npfree-item .np-tips {
    display: none;
  }
  
  .newPullwapper .np-time {
    color: #ff3d3d;
    font-size: 12px;
    margin-top: 6px;
  }
  
  .newPullwapper .np-content {
    width: 100%;
    -webkit-flex-shrink: 1;
    -ms-flex-negative: 1;
    flex-shrink: 1;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  
  .newPullwapper .np-btn,
  .newPullwapper .np-content {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  
  .newPullwapper .np-btn {
    width: 74px;
    height: 32px;
    background: -webkit-linear-gradient(6deg, #fe4a7d, #ff3636);
    background: -moz-linear-gradient(6deg, #fe4a7d 0, #ff3636 100%);
    background: linear-gradient(84deg, #fe4a7d, #ff3636);
    border-radius: 23px;
    font-size: 14px;
    color: #fff;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  
  @charset "UTF-8";
  
  .bind-mobile[data-v-7b5f6e16] {
    position: fixed;
    z-index: 998;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #0000004d;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .popup-bind-phone[data-v-7b5f6e16] {
    width: 360px;
    height: 348px;
  }
  
  .bind-phone[data-v-7b5f6e16] {
    position: relative;
  }
  
  .bind-phone-box[data-v-7b5f6e16] {
    width: 312px;
    padding: 24px;
    height: auto;
    border-top: 2px solid #fc3737;
    background: #fff;
  }
  
  .bind-phone-h2[data-v-7b5f6e16] {
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
    margin-bottom: 24px;
  }
  
  .bind-phone-icon[data-v-7b5f6e16] {
    float: left;
    width: 36px;
    height: 36px;
    background: rgb(255, 209, 209)
      url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAASCAYAAACAa1QyAAAAqElEQVQ4T+2TUQqCUBREZyyCBKG24QJ8tJnaQX7lGqKvrB24GZej8MCE7E0EIRQmr8+g+3vnMHDvDBXHMxdFBwFrAEt8nopAEVib8WrMkUA6In5ZEcjZJUkFcuELQarZGSNv4Cn8Qz98CEpZEIZn17appP378wefOwmCkGV50Wo1vznXeEG9U9OkIgecvg0sUD2qkRPY+oZWwIl9CaXNaEWkWmQxtXZ3B0O9XFUBFnewAAAAAElFTkSuQmCC)
      center no-repeat;
    border-radius: 50%;
    margin-right: 12px;
  }
  
  .close[data-v-7b5f6e16] {
    position: absolute;
    top: 26px;
    right: 24px;
    display: block;
    width: 10px;
    height: 10px;
    cursor: pointer;
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/order-pop-close.a86bce47.png)
      no-repeat;
  }
  
  .form-box[data-v-7b5f6e16] {
    width: 312px;
    margin: 0 auto;
  }
  
  .rent-tit[data-v-7f02cbaa] {
    font-size: 24px;
    font-weight: 600;
    color: #262626;
    line-height: 40px;
    margin-bottom: 24px;
  }
  
  .rent-list[data-v-7f02cbaa] {
    border-radius: 10px;
    border: 1px solid #eeeeee;
    box-sizing: border-box;
  }
  
  .hb-wrap[data-v-7f02cbaa] {
    background: #ffffff;
    padding: 20px 0 20px 16px;
    border-radius: 10px;
    border: 1px solid #eeeeee;
    margin-top: 20px;
  }
  
  .xdhb_tips[data-v-7f02cbaa] {
    color: #fc3737;
    font-size: 12px;
    font-weight: 400;
    margin-right: 30px;
    height: 28px;
    line-height: 28px;
    text-align: right;
  }
  
  .dpay-20220420 {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: MicrosoftYaHei;
  }
  
  .dpay-20220420 * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }
  
  .dpay-20220420 .i-sprite {
    background-image: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/icon-sprite.png?t=233);
    background-repeat: no-repeat;
  }
  
  .dpay-20220420 .dpay {
    position: relative;
    width: 428px;
    background: #ffffff;
    border-radius: 4px;
  }
  
  .dpay-20220420 .dpay-head {
    font-size: 18px;
    font-weight: 700;
    color: #4d4d4d;
    line-height: 24px;
    text-align: center;
    padding-top: 32px;
  }
  
  .dpay-20220420 .dpay-close {
    position: absolute;
    right: 20px;
    top: 24px;
    width: 15px;
    height: 15px;
    background-position: 0 0;
    cursor: pointer;
  }
  
  .dpay-20220420 .dpay-money-wrap {
    background: #fafafa;
    border-radius: 8px;
    margin: 24px 20px 0;
    padding: 16px 0;
    text-align: center;
  }
  
  .dpay-20220420 .dpay-tit {
    font-size: 14px;
    color: #4d4d4d;
    line-height: 24px;
  }
  
  .dpay-20220420 .cd {
    color: #ff893d;
  }
  
  .dpay-20220420 .dpay-money {
    font-size: 32px;
    font-weight: 700;
    color: #ff3d3d;
    line-height: 24px;
    margin-top: 13px;
    height: 24px;
    overflow: visible;
  }
  
  .dpay-20220420 .dpay-money .icon-m {
    font-size: 16px;
    vertical-align: 2px;
    margin-right: -5px;
  }
  
  .dpay-20220420 .dpay-money-detail {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
  
  .dpay-20220420 .money-item {
    font-size: 12px;
    color: #4d4d4d;
    line-height: 16px;
    margin-right: 24px;
  }
  
  .dpay-20220420 .money-item:last-child {
    margin-right: 0;
  }
  
  .dpay-20220420 .dpay-type-tit {
    font-size: 16px;
    color: #262626;
    line-height: 24px;
    text-align: left;
    margin-top: 30px;
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
  
  .dpay-20220420 .pay-warning {
    background: #fff6ee;
    border-radius: 3px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #ff893d;
    line-height: 16px;
    padding: 3px 6px;
  }
  
  .dpay-20220420 .dpay-tips {
    font-size: 12px;
    color: #999;
    line-height: 16px;
    margin-top: 6px;
    text-align: left;
    margin-left: 20px;
    display: none;
  }
  
  .dpay-20220420 .dpay-types {
    overflow: hidden;
    margin-left: 0;
    padding-top: 30px;
  }
  
  .dpay-20220420 .dpay-types .item {
    width: 116px;
    height: 40px;
    float: left;
    margin: 0 0 10px 20px;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
    user-select: none;
    padding: 0 8px;
    cursor: pointer;
    list-style: none;
    display: flex;
    align-items: center;
  }
  
  .dpay-20220420 .dpay-types .item.active {
    border: 1px solid #ff3d3d;
    position: relative;
  }
  
  .dpay-20220420 .dpay-types .item.active:before {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    right: -1px;
    top: -1px;
    background: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/icon-sprite.png)
      no-repeat -18px 0;
  }
  
  .dpay-20220420 .dpay-types .item.disabled {
    cursor: auto;
  }
  
  .dpay-20220420 .dpay-types .item.disabled .type-txt {
    color: #cdcdcd;
  }
  
  .dpay-20220420 .dpay-types .item.disabled .icon {
    opacity: 0.6;
  }
  
  .dpay-20220420 .dpay-types .item .item-top {
    display: flex;
    align-items: center;
  }
  
  .dpay-20220420 .dpay-types .item .item-tip {
    font-size: 12px;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 4px;
  }
  
  .dpay-20220420 .dpay-types .icon {
    width: 32px;
    height: 32px;
  }
  
  .dpay-20220420 .dpay-types .item-1001 .icon {
    background-position: -128px 0px;
  }
  
  .dpay-20220420 .dpay-types .item-2001 .icon {
    background-position: -96px 0px;
  }
  
  .dpay-20220420 .dpay-types .item-10011 .icon {
    background-position: -64px 0px;
  }
  
  .dpay-20220420 .dpay-types .item-100 .icon {
    background-position: -98px -29px;
  }
  
  .dpay-20220420 .dpay-types .item-6001 .icon {
    background-position: -128px -28px;
  }
  
  .dpay-20220420 .dpay-types .type-txt {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #262626;
    line-height: 19px;
    margin-left: 4px;
  }
  
  .dpay-20220420 .dpay-types .type-txt > span {
    font-size: 12px;
    color: #fc3737;
    background: #ffeeee;
    border-radius: 10px 10px 10px 0;
    height: 20px;
    line-height: 20px;
    padding: 0 6px;
    margin-left: 6px;
  }
  
  .dpay-20220420 .submit-pay {
    display: block;
    cursor: pointer;
    width: 164px;
    height: 40px;
    background: #ff3d3d;
    border-radius: 4px;
    margin: 60px auto 20px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
  }
  
  .dpay-20220420 .dpay-qrcode {
    text-align: center;
  }
  
  .dpay-20220420 .dpay-qrcode .qrcode-box {
    width: 170px;
    height: 170px;
    background: #ffffff;
    border: 1px solid #e6e6e6;
    margin: 32px auto 0;
    position: relative;
  }
  
  .dpay-20220420 .dpay-qrcode .qrcode-error {
    position: absolute;
    left: 9px;
    top: 9px;
    right: 9px;
    bottom: 9px;
    background: rgba(0, 0, 0, 0.76);
    backdrop-filter: blur(3px);
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .dpay-20220420 .dpay-qrcode .error-txt {
    font-size: 14px;
    color: #cdcdcd;
    line-height: 19px;
  }
  
  .dpay-20220420 .dpay-qrcode .tips {
    background: #fff6ee;
    padding: 8px 20px;
    font-size: 12px;
    color: #ff893d;
    line-height: 16px;
    text-align: center;
    margin-top: 24px;
  }
  
  .dpay-20220420 .dpay-qrcode .tips .high {
    font-weight: 700;
  }
  
  .dpay-20220420 .dpay-qrcode .get-btn {
    display: block;
    width: 88px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #cdcdcd;
    margin: 12px auto 0;
    font-size: 12px;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .dpay-20220420 .dpay-qrcode .get-btn:hover {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(2px);
  }
  
  .dpay-20220420 .dpay-qrcode .loading {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    width: 20px;
    height: 20px;
    animation: loading-rotate 0.8s infinite linear;
    background: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/loading.png)
      no-repeat;
    background-size: 100% auto;
  }
  
  @keyframes loading-rotate {
    0% {
      transform: rotate(0);
    }
  
    to {
      transform: rotate(360deg);
    }
  }
  
  .dpay-20220420 .dpay-qrcode .qrcode-img {
    display: block;
    width: 157px;
    height: 157px;
    margin: 5px auto 0;
  }
  
  .dpay-20220420 .dpay-qrcode .warning-txt {
    font-size: 12px;
    color: #999;
    line-height: 16px;
    margin-top: 5px;
  }
  
  .dpay-20220420 .dpay-qrcode .pay-tips {
    font-size: 12px;
    color: #999;
    line-height: 16px;
    margin: 12px 20px 0;
    text-align: justify;
  }
  
  .dpay-20220420 .dpay-qrcode .pay-tips .high {
    color: #262626;
  }
  
  .dpay-20220420 .dpay-qrcode .refresh-qrcode {
    color: #3d8bff;
    cursor: pointer;
  }
  
  .dpay-20220420 .dpay-qrcode .qrcode-tips {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 9px;
    padding-right: 5px;
    font-size: 12px;
    color: #4d4d4d;
    line-height: 16px;
  }
  
  .dpay-20220420 .dpay-qrcode .qrcode-tips i {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }
  
  .dpay-20220420 .dpay-qrcode .qrcode-tips .icon-zfb {
    background-position: -33px -30px;
  }
  
  .dpay-20220420 .dpay-qrcode .qrcode-tips .icon-wx {
    background-position: 1px -31px;
  }
  
  .b-auth-pop .notice-box {
    width: 100%;
    height: 134px;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 12px 20px;
    box-sizing: border-box;
  }
  
  .b-auth-pop .notice-box h3 {
    font-size: 14px;
    font-weight: 700;
    color: #4d4d4d;
    line-height: 22px;
    margin-bottom: 12px;
  }
  
  .b-auth-pop .notice-info p {
    font-size: 12px;
    color: #4d4d4d;
    line-height: 23px;
  }
  
  .b-auth-pop .code-box {
    margin-top: 24px;
  }
  
  .b-auth-pop .code-top {
    text-align: center;
  }
  
  .b-auth-pop .code-top h3 {
    font-size: 18px;
    font-weight: 700;
    color: #4d4d4d;
    line-height: 22px;
    margin: 0 0 8px;
  }
  
  .b-auth-pop .code-top p {
    color: #737373;
    line-height: 16px;
  }
  
  .b-auth-pop .code-detail {
    margin: 24px auto 40px;
  }
  
  .b-auth-pop .code-pic {
    width: 170px;
    height: 170px;
    border: 1px solid #e2e2e2;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  
  .b-auth-pop .code-pic img {
    width: 158px;
    height: 158px;
  }
  
  .b-auth-pop .code-pic .re-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #000c;
    text-align: center;
    padding: 50px 24px 0;
    box-sizing: border-box;
    color: #fff;
  }
  
  .b-auth-pop .re-mask .refresh-btn {
    width: 60px;
    height: 25px;
    background: #ff3d3d;
    color: #fff;
    text-align: center;
    line-height: 25px;
    border-radius: 50px;
    cursor: pointer;
    margin: 0 auto 10px;
  }
  
  .b-auth-pop .code-detail p {
    color: #ff893d;
    line-height: 22px;
    margin-top: 16px;
    text-align: center;
  }
  
  .b-auth-pop .code-opaction {
    text-align: center;
  }
  
  .v-image {
    position: relative;
    display: inline-block;
  }
  
  .v-image-img {
    width: 100%;
    height: auto;
    object-fit: cover;
    vertical-align: middle;
  }
  
  .v-image-img-placeholder {
    position: absolute;
    width: 100%;
    display: inline-block;
    left: 0;
    top: 50%;
    min-height: 60px;
    transform: translateY(-50%);
    background-color: #f5f5f5;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 30%;
  }
  
  .v-image-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s;
  }
  
  .v-image-mask:hover {
    opacity: 1;
  }
  
  .v-image-mask-info {
    padding: 0 4px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .v-image-mask-info .anticon {
    -webkit-margin-end: 4px;
    margin-inline-end: 4px;
  }
  
  .zhw-review-box {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    z-index: 1000;
    box-sizing: border-box;
  }
  
  .zhw-review-box .review-close {
    width: 50px;
    height: 50px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAsZJREFUaEPdmsuL1EAQh791XCEqLiKCL1iEWQQfICrqSXyAB/+UHAcGDx7EgwcZmGP+Gx94ElFZUATZAVnwBYuI4m5g11H5QQKxnUzSSWdmp/uYVFfXl+6qru7UHO5aABwAFoC9wG5gHtiZDPEL2AI2gJ/Ad+ArELswYa6mEhl/DDiaGF9FnaA+Ah/qQFUF2QcsAYeAqjpM6D/AF2AF+GH7RWyN2AWcTGbBdiwbec3OW2CzbCcbkCPAmWTdl9VfR07+9Br4VEZJGRDJnAYWyyhsQGYVeANo6eW2IpAWcAE42ICBNirXgBfAMK/TOBBBXAb224zYoOw34FkeTB6Inl/cBjNhfhfNzPNRyywPRE49LZ8omlT5jILAP20UiKLTuSJtU37/yoxmJoj2iWsTDLFVv4dC8+PsPmOCnJ3AZlfVeLOfNs3l9GEWRGnHFVejTEjP0zSdyYKcBw5PyABXw3wGXkpZCqIs9rrDBNCVoUV6tNs/UtacgiiTPVHUa5u+f6eMOQW5WuM8Qa/Xe9BqteajKLo3GAx0YCps7XZ7IQzDu8PhcKvb7d4u7JAvoPPME4FoWd2ooYh+v98PgmApjuPVKIruFMEkEPeDIFiM43il0+l06owPPBSITngKu5WbYdhYGBtZC4OWBXIKOG7RaaRoGQPLyFS0471ALrlKDscZ2iCE2NcEorCrGw8nbZTBUhyGYeoTpfzI0pgNgdwElGM5ayaMFCeO3QSE1G8K5BawwxlFoigLo0dlI1pFO357BeLN0tL5Y0/FKf2v25Scfd2r8OvNhuhNiuJN0iiH9SKNF4g3BytvjrqaFS8uHwTizXWQYLy4oBOIN1emgvHiEjtNAr34rSAYb370CMaLX2/pEvPiZ2gK48Xv6ewJcOYLBrIwXpRwZIFmvqjGvGyY+TKnUZcuZuGZbmZUdJYtPFPx2XoThWd/Ae+CsvObWdFHAAAAAElFTkSuQmCC);
    background-repeat: no-repeat;
    position: absolute;
    right: 24px;
    top: 24px;
    cursor: pointer;
    z-index: 1;
  }
  
  .zhw-review-box .review-close:hover {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAArtJREFUaEPdmj2IE0EUx39nDjxFi1xYzkIQK8FOFNRKLJUTEQtFGxvFQggphWCIBKwkBBREm2sULERE0VKsVFDsDqxEsFCWXArFD7io/CEry7LJ7k52E/MWUoR985/325l58+ZjjvyeRWAXsANYAjxgE7AwqOIn8APwgS/AR+A9sJaHC3NjilSA/YPfNketz8Drwa/rqIEryHbgKLAH2OBaeaTcb+Ad8BT4lFUzK8hW4CRwAJw/QpKPf4BXwAPga5Jx8D4LyD7gLLA5rfiYdt+Bu8CbNDppQErAKeBQGsECbF4A94H+KO0kkI3ARWB3AQ5mkVwFbgG/hhUaBSKIGrAzS40F2n4A2sNghoGoO136D1oi+l3UMjfiutkwkDNTHBNJjaoxcy9qFAei6HQ+SW3K7+9Eo1kURPPE1QmGWNfvodB8JTzPREHOAQdd1Sdc7iWwEjchKu2oFzhj582pDKAVpDPhFrkA7M27toL13gK3VUcAoixWdHklgAX7/09eiaZ6UTcAUSZ7fFK151zPI2XMAUgTcF1P0Gw2j5VKpflOp/PM930toBIfz/MWqtXqkX6/v95oNB4nFhhuoPVMQyBa2V0bQ4hWq3WiUql4vV5vrd1uP0mCEUStVlsul8uL3W7Xr9frD8epH7gsEIVbhV3nJ+xYEkwW2wwOrQjkNHA4Q6FY0zQOprFx9OO5QKp5JYejHC0QQuyrAlHY1Y5HLk+cwxIOxkRS13N0whfIdWCLo0CqbiYjDeyCICT/TSA3gfk8QaQVbhn9LxBC8uumQMx0LTOD3Uz4NTMhmklRzCSNisMm0niBmFlYmVnqqlVMbD4IxMx2kGBMbNAJxMyWqWBMbGIHyxITxwqCMXPQIxgTR29BFzNxGBrAmDieDu9JzPyFgTCMiSscYaCZv1QT3f6a+WtOcft5U7149hfSF7myLaHc8QAAAABJRU5ErkJggg==);
  }
  
  .zhw-review-wrap {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  .review-preview {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
    text-align: center;
  }
  
  .review-preview .v-preview-img {
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
    transform: scaleZ(1);
    cursor: grab;
    transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    pointer-events: auto;
  }
  
  .review-ctrl {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  
  .review-ctrl .arrow {
    width: 64px;
    height: 64px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
  
  .review-ctrl .v-preview-switch-left {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAA4RJREFUeF7tm0mLFDEUx3/j0uKG4gYiCgquBxfEFqQHN/TgV5hT37zNwZOfwJOHwQ/QpznMZxBRcWhwZNwObgcFZRDccFBHbB2V/5CSsuiurq6upNOTDgSa6qrkvV9ekpeXZAj7qQRsBNaYvBrQs2UmS4JfJjeAb8BXkz8CemYtDVkqeR2wDdhslM5bzx8D4j0wA8wWLW9ewZrJoRbdAWwH1hYtqCnvC/AGeG0sputqigCwHNhpsn67SD+BVybrd+7ULQC19j5gRW4JuvvwB/DMWEWukvICWAUcBjbkqrX4jz4BD4G5TovOA2ArcBBwZe5ZdVJXeAy8zfqB3usUwAFgVycV9ODdl8CTrPVmBaD3ZPKa2vohacpUl9A0mpqyANA7x4At7Qrz7P93wL12ELIAONJHLZ9sA1nCg7SGaQegH/p8O8NLHRPSAGi0P9qu9D75f7rV7NAKgOb5YQ+nury8NUXeaeYntAJwwiMnJ6/Sye/kLNWTD5sBkHt7qKhaPSvnUdJtTgKQd3farNc9k70QcRRbuAn8W0AlAewBlBdzegEoL6Q4AK3nzy6iga9VI6r1b0TxhDgA+fia90NIWivIP/jPAk5ajOSkQh0ZGTleLpcv6qV6vX5tYmLivuVWUGTpdhyAYnia952narU6XC6XLwFLVXmj0fgwOjpadSCI/ILZqAv0xOVNKu8YwIKLHAFwbv7NlAfmJycnr4yPj991YAEL3UAAFKM/lyM4klvGVspPTU1drdVqMk0XSbGC6wLgdNHjifIR4GkB2A3sdYHcM+Wl8nMBcBLw8FB5AZgRgAqw3qYFeKq8VP4sAHJ/V9oC4LHyUvm7AJy3tfqTh1epVC5HTo6BPO94tE9r24YAXACW2LCAsbGxWqlU2hQr2yflJdbvAYBBF4AzgIKgVpLng+DcYBocOEIDV3iwGAp+OazRP+iAiAAEHxILPijak24QeV4+hMUlS/AbI8FvjckKgt4cFQBtj5/q4dFXKwuyWKE6WnsrbXtc7wZ9QCKCFfQRGUEI/pCUIDjdMbLc+Ts+JhfJ0xMXuWAYuQ9KRnI42TkqWOmouK6Pyqqg4A9LRxCCPS4ft85+GBOsXJiIQwj6ykwEIuhLU3FrkNu839bmaoaZQUdfn/bi2lxctqAvTsZBBHt1tpmlBnl5ulWXbXZ9XldtdTJUVqOk6/PzgNbrTq/P/wWNmnFXajiq7gAAAABJRU5ErkJggg==);
  }
  
  .review-ctrl .v-preview-switch-left:hover {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAA2tJREFUeF7tmz2IE0EUx39RQY1aifhVXHFYWNgoWCgWEY8rjB6oaQTxCxTrQwsFEcErlJQiWviBYBOVO7U5TgwYtDiwsrAQiwM/ESvPqKBG/kf22Fs22WSzu9njZSBNdnbee7+Z2ffmzUyG+MsKYAOwFlgDrAaWA4uBJXXxv4DfwDTwBfgMfALeAt/jVDETU+N9wFZgI7AOCCunBnwE3gCTwFTU+oZVzE8P9eYOYHu9t6PWVe1pVLwAKoBGTcclCgBZYGf9t6xjjVpr4AfwrP6rtvaKf61OAWwD9gGa590o+j48BF6GFR4WwCrgKNAfVnDE770DbgFf2203DIAtwCFgabvCYq7/E7gLvGpHTjsAVHc/MNCOgC7UnQAeAPIggaVVAAuBI3XXFthoCirIZd4G/gbp0goAGX8K2BTUWMqevwauBUEIAqDnx+ZRz3v7QCPhZrPpEATgwDyY80EDT9+E+40qNQOgr/2JoNbnyfMbjbxDIwDy8+dS6OrC8paLvOQXJzQCcCZFQU5Yo73vKVi67P3TD4DC28NRSU1ZO3e8YbMXgBY2F7sY28fNS2uH88DsAsoLIA/siVuLLrf/GHji6OAGoPX8CJDUkrZbHLSUPuvkE9wAFOPL71soigsUH8xJVV2IMZPTFGoul+vL5/PKJDE6Ovq8Uqm8j7kXlFmSvbMAlMPTsEi8DA4O9g8NDeUymcwCCa9Wq9PDw8P3ElBE033KmQIFYFcCQueI8BqfMICnQMkBINewPkkAfsbXarV/pVJpolwuR5799bHtg1y+ACifd6WD1HXb3BoZPzY2Vh4fH1fElkRRwuS0AGwGTiYhUTJSYrxj7nUB2A3sTQJAyoyXyY8E4HgSCY8UGi8AkwIg9yc3GFtJqfGyd8YNyh+ujMv6FBsvk78JQLG+Wxs5A0V4hUJhwAlyJECuLuGvfTO7pgXgKrAocutFtlg8mM1mtRU+U1JmvFT60wPQmwK9j2DPDZoPhMyHwuYXQ+aXwwoITCdEBMB8Ssx8UlSjwHRaXADMb4yY3xrTKDC9OSoA5rfHBcH0AQkneWP6iIwgmD8kJQimj8k5U8H0QUlBMH9UVhBMH5Z2poLp4/IOBNMXJtwbR2avzLghmL405QZh9tqcG4Lpi5NuEGavzvrtrJu8PN3oiEGqr8//Bzmgrm7mW/n5AAAAAElFTkSuQmCC);
  }
  
  .review-ctrl .v-preview-switch-right {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAA3JJREFUeF7tm0lrFEEUx39xGXFDcQMRBQW3HFxxhGGCG3rwC+Qwp/kAkoMnP4EnD7l5m1M+hYiKQXAkuBzcDgpKENwwqBFHo/IfqqVtZ61eqic1Dwqa7q7tV6+qXr2qGiF9KQAbgTUmrAb0bpkJKsFPExrAV+CLCR8AvUtNRlJKeR2wDdhsKm2bz28D4h0wC8wlXV7bgrUqh1p0B7AdWJt0QU16n4HXwCujMbGzSQLAcmCnCXrOQn4AL03Qs7XEBaDW3gessC5BvIjfgadGK6xSsgWwCjgEbLDKNflIH4EHwHy/SdsA2AocALJS917rpK7wCHjTawT91y+AUWBXPxk4+PcF8LjXfHsFoP+k8praBkE0ZapLaBrtKL0A0D/HgC3dEsvZ97fAvW4QegFweIBaPtoG0oT7nRqmG4BB6PPdFK/jmNAJgEb7o91SH5DvM+1mh3YANM+P5XCqs+WtKfJ2KzuhHYBSjowc20pH48lYuhN92QqAzNuDSeWas3QeRs3mKABZd6fMej1nZU+kOPIt3AD+LqCiAPYACotZngMKTQkD0Hr+zCIa+No1olr/euBPCAOQja953wfRWkH2wT8acCJFT04T6vj4+JFSqXRBz/V6/erU1NRdR7TlWboVBiAfnub9VGVycrJWKBQ2mUwW6vX6lVqtpvnZhSjfuaALZGLyRgCo0i4hNE3kAEDq6q/aViqV4+Vy+RKwNNTkriA0u4EAyEd/1sI5YqW21Wp1rFgsXswBBPkKrglA5oueHEGYEYDdwF6r5owRKScQngmAM4dHDiDMCkAZWB+jMWNFdQzhkwDI/F0ZqxYxIzuE8E0AzuVh9dcOwvT09OUULcaGAJwHlsRsxESit4LQaDTeT0xMVBPJ4P9Efg0BDLsAnAbkBHUmDgfB+eE0ODSEhqbwcDHk/XJYo7/XDhEB8N4l5r1TNJNukGe3uAB4vzHi/daYtMDrzVEB0Pb4SYdHX9NekOlo7c1O2+MqgNcHJIIW8PqIjCB4f0hKEDLfMUpxAOj7mFxQlkxM5BQrrqStD0oG5XK2c5QAmNhHZVUG7w9LBxC8PS4f1sRBGBNSuTARhuD1lZkAhNeXpsLaILN5v8PNVR19feLi2lwYgtcXJ8MgvL0628pe8fLydDvDrdX1eV211VlBaY1E1+cXAK3XM70+/wd54nNXN0yW4AAAAABJRU5ErkJggg==);
  }
  
  .review-ctrl .v-preview-switch-right:hover {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAA5BJREFUeF7tm0+ITVEcxz8PhYcVItSU2CgbitJQz7/ZYJp4Cxv5V2Q7UkLIv5KxFBtkY/FYDLMZ/15ZTI2yUjakLIiwMh4KT9/XvdPt9u7c+8579507c+bUrWne+ff73N+5v9/5nfPLkX6ZAywHFgELgIXALGCG92gGv7znB/AJ+Ax8BN4A39OcYi6lzjuANcAKT3DTcaoeiNfAC+B9q+drOrF689Ab3QCs84Ru9VzVn7RiCHjuaUzTY7QCQB7YBGz0VLvpSSXoQEvlGfAUqCSoH1mlWQB62zsBrXMbRd+H+55WGI1vCmA+sA9YZjRq6xu9BW4BXxrt2gTAamAPMLPRwVKu/xO4A7xsZJxGAKjuLmBLIwNYqPsYuAfIgsSWpACmAnuBtbE9ZqPCMHAb+Bs3nSQAJPwRYGVcZxn7/RVwLQ5CHAD9vn8cvfnwO5Am3BxrOcQBKI6DNR+nePomlKIqjQVAX/tDcb2Pk99vRFmHKACy8yczaOpMectEnq/nJ0QBOJYhJ8dU6HA7OUuXw/+sB0DurUzeRCwyjdpMjZYwAG1szln07dOGrr3DqeAGKgxgO6BnIpeHgJ5aCQLQfv5SG7e0tiBrK33cjycEAWz1fH1bE2vnuNorPAprwJkUIzk14To7O5f09PSs198DAwND5XK55SGuhBQVWZK8o0tAMbwTCRsbV+vr69udz+dnq4Nqtfqvv7+/PDg4+M64w+YaXlCM0V8CbXF5gwAyAKHmIvsATgOLmwMa37pQKHQUi8XNuVxuil/boiZ8AM4KgOJ5V0IWIV4awxpdXV1Lu7u7CxmAoIDJUQFYBRw2lMeoWYYgXBeAbcAOI0maaJQRCA8E4KB3itOEOGZNMwBhWABk/mQGrRTLEGpmUO7vXCvSe4NahPBNAK4CNefEZomCUCqVnqToMY4IgCKn02wK749dD0KlUhnp7e29m9L8/kwCmFwCcBGYl5KKJerW4kfw66QZBA7YOvmx+OZ9zaw5Qs67ws5vhpzfDms9OB0QEQDnQ2LOB0WlBU6HxQXA+YMR54/GpAVOH44KgPPH44Lg9AUJf5Pg9BUZQXD+kpQgOH1Nzl8KbXGRE4WNzCsZX5TUkM5flRUEpy9L+4rn9HV5H4LTCRPBT5CzKTNBCE4nTQVBOJs2F4TgdOJkEISzqbP1fDQnk6ejnNVg+rxS55VCrwsZ00Pp87+BES91Xin0bUmf/w8GqLZ3lrkDVwAAAABJRU5ErkJggg==);
  }
  
  .review-small-wrap {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    white-space: nowrap;
    bottom: 0;
  }
  
  .review-small-wrap .small-switch-left {
    position: absolute;
    left: -26px;
    top: 20px;
    width: 12px;
    height: 22px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAYAAAD0OH0aAAAAAXNSR0IArs4c6QAAAJVJREFUOE+tlMENgCAMRW2YwS08OoFDsCIJA3h0AT26hQt4Id9AlAQVaKOc30ub3xZqGM9a2zrnRgA71fgTngB0RLQUhRu8KqWGrPAGa623VyEH+/YfQgl+CDU4EThwFLhwECRwEIwxM4CeiELOPrrSMOWCuCVfXiLFwXGlZNIc6dtqXHGKlq8m/XdAmUrlE71J4RM4AGqc9SfrUYDNAAAAAElFTkSuQmCC);
  }
  
  .review-small-wrap .small-switch-left:hover,
  .review-small-wrap .small-switch-left.on {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAYAAAD0OH0aAAAAAXNSR0IArs4c6QAAAJVJREFUOE+tlMENgCAMRW3CCo7AzaMTOLRHF9CjCQdGcAEPJN9A1EQQaKOc30ub3xZqGM9a2zrnRgA71fgTngB0RLQUhQhelVJDVniDtdbbq5CDffuJUIIToQY/BA58C1w4CBI4CMaYGUBPRCFnH11pmHJB3JIvL5HuwXGlx6Q50rfVuOIULV9N+u+AMpXKJxpJ4RM4ACN1+I14c446AAAAAElFTkSuQmCC);
  }
  
  .review-small-wrap .small-switch-left.no:hover {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAYAAAD0OH0aAAAAAXNSR0IArs4c6QAAAJVJREFUOE+tlMENgCAMRW2YwS08OoFDsCIJA3h0AT26hQt4Id9AlAQVaKOc30ub3xZqGM9a2zrnRgA71fgTngB0RLQUhRu8KqWGrPAGa623VyEH+/YfQgl+CDU4EThwFLhwECRwEIwxM4CeiELOPrrSMOWCuCVfXiLFwXGlZNIc6dtqXHGKlq8m/XdAmUrlE71J4RM4AGqc9SfrUYDNAAAAAElFTkSuQmCC);
  }
  
  .review-small-wrap .small-switch-right {
    position: absolute;
    right: -26px;
    top: 20px;
    width: 12px;
    height: 22px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAYAAAD0OH0aAAAAAXNSR0IArs4c6QAAAIhJREFUOE9jXLZs2WFGRkYOZmZmr7CwsNcMBADj8uXLT////9+EkZHxCjMzsxMhTYyrVq0S/fv3777////rEKOJEeQCUjSBNZCiCa6BWE0oGojRhKGBkCasGvBpwqkBlya8GrBoOkNdDdgilDqexpdUKIs4YhIheYmPGJNhqZr0DERyFiW1EAAApnvrvXF7MfsAAAAASUVORK5CYII=);
  }
  
  .review-small-wrap .small-switch-right:hover,
  .review-small-wrap .small-switch-right.on {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAYAAAD0OH0aAAAAAXNSR0IArs4c6QAAAIdJREFUOE+t1DEKgDAMBVA/ZPACHqGboydw9NAujjpKO/QIXqEQUVAQa5uo3V9IyE9hrR0AlETUGWOWIvPgnBuZuQEwE1GbQ/DeVyGEnplrCcLWgQbtQINOIEUXIEE3kENRkEKP4AklQQRN/4LYQv8ZOhWVb4uThPBd+CSVj1TrD0h9otpPYAUdhu4DHhylCAAAAABJRU5ErkJggg==);
  }
  
  .review-small-wrap .small-switch-right.no:hover {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAYAAAD0OH0aAAAAAXNSR0IArs4c6QAAAIhJREFUOE9jXLZs2WFGRkYOZmZmr7CwsNcMBADj8uXLT////9+EkZHxCjMzsxMhTYyrVq0S/fv3777////rEKOJEeQCUjSBNZCiCa6BWE0oGojRhKGBkCasGvBpwqkBlya8GrBoOkNdDdgilDqexpdUKIs4YhIheYmPGJNhqZr0DERyFiW1EAAApnvrvXF7MfsAAAAASUVORK5CYII=);
  }
  
  .ul-wrap {
    white-space: nowrap;
    max-width: 648px;
    overflow: hidden;
  }
  
  .zhw-review-ul {
    transition: all 0.3s;
    transform: translate(0);
  }
  
  .zhw-review-ul .review-li {
    width: 100px;
    height: 62px;
    overflow: hidden;
    box-sizing: border-box;
    display: inline-block;
    margin-left: 8px;
    cursor: pointer;
  }
  
  .zhw-review-ul .review-li:first-child {
    margin-left: 0;
  }
  
  .zhw-review-ul .review-li.on {
    border: 1px solid #ff3d3d;
  }
  
  .zhw-review-ul .review-li img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  
  .v-preview-opera {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: #000000d9;
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    font-feature-settings: "tnum";
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    width: 100%;
    color: #ffffffd9;
    list-style: none;
    background: rgba(0, 0, 0, 0.1);
    pointer-events: auto;
  }
  
  .v-preview-opera-operation {
    margin-left: 12px;
    padding: 12px;
    cursor: pointer;
  }
  
  .v-preview-operation-disabled {
    color: #ffffff40;
    pointer-events: none;
  }
  
  .v-preview-opera-operation:last-of-type {
    margin-left: 0;
  }
  
  .v-preview-opera-icon {
    font-size: 18px;
  }
  
  .zuhao-game-detail[data-v-39f48c01] {
    width: 100%;
    background: #f5f6fa;
    border-radius: 4px;
    padding: 16px 0 0;
    margin-left: 120px;
    margin-top: 16px;
  }
  
  .zuhao-game-detail.detail1040 .detail-item .info-item[data-v-39f48c01] {
    flex: 0 0 20%;
  }
  
  .detail-item[data-v-39f48c01] {
    display: flex;
    margin-top: 16px;
  }
  
  .detail-item.item2 .det-tit[data-v-39f48c01] {
    padding-top: 19px;
  }
  
  .detail-item[data-v-39f48c01]:first-child {
    margin-top: 0;
  }
  
  .detail-item .det-tit[data-v-39f48c01] {
    font-size: 14px;
    font-weight: 700;
    color: #262626;
    line-height: 20px;
    margin: 0 20px 0 16px;
    white-space: nowrap;
  }
  
  .detail-item .det-info[data-v-39f48c01] {
    display: flex;
    flex-wrap: wrap;
    margin-top: -10px;
    flex: 1;
  }
  
  .detail-item .info-item[data-v-39f48c01] {
    flex: 0 0 25%;
    overflow: hidden;
    margin-top: 10px;
  }
  
  .detail-item .info-nei[data-v-39f48c01] {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .detail-item .info-name[data-v-39f48c01] {
    font-size: 12px;
    font-weight: 400;
    color: #737373;
    line-height: 17px;
  }
  
  .detail-item .info-val[data-v-39f48c01] {
    color: #262626;
  }
  
  .det-score[data-v-39f48c01] {
    display: flex;
    flex: 1;
    border-top: 1px solid #ebebeb;
  }
  
  .det-score.det-score2[data-v-39f48c01] {
    justify-content: end;
  }
  
  .det-score .star-wrap[data-v-39f48c01] {
    display: inline-flex;
    margin-right: 24px;
    flex: 0 0 143px;
    padding-top: 21px;
  }
  
  .det-score .star-wrap .star-icon[data-v-39f48c01] {
    width: 16px;
    height: 16px;
    overflow: hidden;
    margin-right: 3px;
  }
  
  .det-score .star-wrap .star-icon[data-v-39f48c01]:before {
    content: "";
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/star.04e62b70.svg)
      no-repeat;
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
    transform: translate(80px);
    filter: drop-shadow(#eaeaea -80px 0);
  }
  
  .det-score .star-wrap .star-icon.active[data-v-39f48c01]:before {
    filter: drop-shadow(#ff2828 -80px 0);
  }
  
  .det-score .star-wrap .num[data-v-39f48c01] {
    font-size: 14px;
    font-weight: 700;
    color: #262626;
    line-height: 20px;
  }
  
  .det-score .tag-wrap[data-v-39f48c01] {
    display: inline-block;
    padding-bottom: 6px;
    flex: 1;
    align-self: center;
  }
  
  .det-score .tag-wrap .tag[data-v-39f48c01] {
    border-radius: 4px;
    border: 1px solid #ccd2de;
    box-sizing: border-box;
    padding: 3px 8px;
    margin: 6px 0 0 6px;
    font-size: 12px;
    color: #4d4d4d;
    white-space: nowrap;
    display: inline-block;
  }
  
  .det-look[data-v-39f48c01] {
    font-size: 14px;
    color: #3d8bff;
    width: 160px;
    height: 58px;
    text-align: right;
    line-height: 58px;
    flex: 0 0 160px;
    box-sizing: border-box;
    cursor: pointer;
    margin-right: 20px;
    align-self: center;
  }
  
  .det-look[data-v-39f48c01]:hover {
    color: #296ad9;
  }
  
  .det-look:hover .icon-svg[data-v-39f48c01]:before {
    content: "";
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/more_hover.e219c1d4.svg)
      no-repeat;
    display: inline-block;
    width: 14px;
    height: 14px;
    background-size: 100% 100%;
    transform: translateX(0px 20px);
    filter: drop-shadow(#418dff 0px -20px 0px);
  }
  
  .det-look .icon-svg[data-v-39f48c01] {
    width: 14px;
    height: 14px;
    overflow: hidden;
    background: none;
    vertical-align: -2px;
    display: inline-block;
    margin-left: 5px;
  }
  
  .det-look .icon-svg[data-v-39f48c01]:before {
    content: "";
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/more.583d474f.svg)
      no-repeat;
    display: inline-block;
    width: 14px;
    height: 14px;
    background-size: 100% 100%;
    transform: translateX(0px 20px);
    filter: drop-shadow(#418dff 0px -20px 0px);
  }
  
  .det-look-wrap[data-v-39f48c01] {
    text-align: right;
    margin-top: -5px;
    padding-bottom: 0;
  }
  
  .det-look-wrap .det-look[data-v-39f48c01] {
    display: inline-block;
    height: 46px;
    line-height: 46px;
  }
  
  .det-look-wrap .det-look .icon-svg[data-v-39f48c01]:before {
    transform: translateX(0px 14px);
    filter: drop-shadow(#418dff 0px -14px 0px);
  }
  
  .det-look-wrap .det-look:hover .icon-svg[data-v-39f48c01]:before {
    transform: translateX(0px 14px);
    filter: drop-shadow(#418dff 0px -14px 0px);
  }
  
  .det-close[data-v-39f48c01] {
    font-size: 14px;
    color: #3d8bff;
    width: 160px;
    height: 58px;
    text-align: right;
    line-height: 58px;
    flex: 0 0 160px;
    box-sizing: border-box;
    cursor: pointer;
    align-self: center;
    display: inline-block;
    margin-right: 20px;
  }
  
  .det-close[data-v-39f48c01]:hover {
    color: #296ad9;
  }
  
  .det-close:hover .icon-svg[data-v-39f48c01]:before {
    content: "";
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/more2_hover.9e01c8ce.svg)
      no-repeat;
    display: inline-block;
    width: 14px;
    height: 14px;
    background-size: 100% 100%;
    transform: rotate(-90deg);
  }
  
  .det-close .icon-svg[data-v-39f48c01] {
    width: 14px;
    height: 14px;
    vertical-align: -2px;
    display: inline-block;
    margin-left: 5px;
  }
  
  .det-close .icon-svg[data-v-39f48c01]:before {
    content: "";
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/more2.75784130.svg)
      no-repeat;
    display: inline-block;
    width: 14px;
    height: 14px;
    background-size: 100% 100%;
    transform: rotate(-90deg);
  }
  
  .detail-wrap[data-v-2ff9fbfd] {
    display: none;
  }
  
  .guide[data-v-5e09ab1a] {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;
  }
  
  .guide .guide-img[data-v-5e09ab1a] {
    position: absolute;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  
  .guide01 .guide-img[data-v-5e09ab1a] {
    width: 579px;
    height: 214px;
    background-image: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/small01.931eba61.png);
  }
  
  .guide02 .guide-img[data-v-5e09ab1a] {
    width: 880px;
    height: 416px;
    background-image: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/small02.ba2ab16c.png);
  }
  
  .guide03 .guide-img[data-v-5e09ab1a] {
    width: 579px;
    height: 214px;
    background-image: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/small01.931eba61.png);
  }
  
  .guide04 .guide-img[data-v-5e09ab1a] {
    width: 1080px;
    height: 393px;
    background-image: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/big02.19328d94.png);
  }
  
  .disabled {
    cursor: not-allowed !important;
  }
  
  .goods-wrap .goods-img-num {
    display: none;
  }
  
  .goods-wrap .goods-info-price {
    display: flex;
    width: 72%;
  }
  
  .goods-wrap .goods-info-price .goods-info {
    width: 65%;
  }
  
  .goods-wrap .goods-info-price .goods-price {
    width: 35%;
    align-self: center;
  }
  
  .goods-wrap .tj-old-price {
    display: none;
  }
  
  .goods-wrap .goods-game-info .area:before {
    display: none;
  }
  
  .goods-wrap .goods-detail-btn,
  .goods-wrap .hidden_hot {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 {
    font-family: PingFang SC, Roboto, Helvetica Neue, Helvetica, Arial,
      Microsoft YaHei, Microsoft Jhenghei, Source Han Sans, sans-serif;
  }
  
  .goods-wrap.goods-wrap202306 .newZoneName {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 .hidden_hot {
    display: inline;
  }
  
  .goods-wrap.goods-wrap202306 .goods-list {
    background: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-list ul > li {
    background: #ffffff;
    border-radius: 4px;
    border-bottom: none;
    margin-bottom: 12px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-list ul > li a {
    padding: 16px 20px;
    width: auto;
    border-radius: 4px;
    flex-wrap: wrap;
    box-sizing: border-box;
    position: relative;
  }
  
  .goods-wrap.goods-wrap202306 .goods-list ul > li a .zuhao-game-detail {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-list ul > li a:hover {
    box-shadow: 0 6px 14px #00000014;
    background-color: transparent;
  }
  
  .goods-wrap.goods-wrap202306 .goods-list ul > li a.active .zuhao-game-detail {
    display: block;
  }
  
  .goods-wrap.goods-wrap202306 .goods-list .shop-hb-tag {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-list li.detail-open .goods-title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    max-height: 46px;
    height: auto;
  }
  
  .goods-wrap.goods-wrap202306
    .goods-list
    li.detail-open
    .goods-title
    .goods-title-con {
    white-space: pre-wrap;
  }
  
  .goods-wrap.goods-wrap202306 .goods-list li.detail-open .goods-flags {
    height: auto;
  }
  
  .goods-wrap.goods-wrap202306 .goods-list li.detail-open .goods-game-info {
    margin-top: 6px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-img {
    width: 120px;
    flex: 0 0 120px;
    height: 104px;
    align-self: baseline;
  }
  
  .goods-wrap.goods-wrap202306 .goods-img:hover .carousel {
    display: none !important;
  }
  
  .goods-wrap.goods-wrap202306 .goods-img .phone-system-icon {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-img .goods-img-num {
    position: absolute;
    height: 23px;
    background: rgba(0, 0, 0, 0.72);
    border-radius: 12px 0 0;
    backdrop-filter: blur(1px);
    padding: 0 9px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    right: 0;
    bottom: 0;
    line-height: 23px;
    z-index: 1;
    display: inline-block;
  }
  
  .goods-wrap.goods-wrap202306 .goods-img .list-img {
    width: 104px;
    height: 104px;
    background: #f3f6fc;
    box-sizing: border-box;
    margin-right: 16px;
    margin-left: 0;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: relative;
  }
  
  .goods-wrap.goods-wrap202306 .goods-img .list-img:before {
    content: "";
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: #00000080;
    position: absolute;
    display: none;
    transition: all 0.3s;
  }
  
  .goods-wrap.goods-wrap202306 .goods-img .list-img:hover:before {
    display: inline-block;
    transition: all 0.3s;
  }
  
  .goods-wrap.goods-wrap202306 .goods-img .table-img {
    width: 104px;
    height: 104px;
    object-fit: cover;
    display: inline-block;
  }
  
  .goods-wrap.goods-wrap202306 .goods-control {
    flex: 0 0 115px;
    position: relative;
  }
  
  .goods-wrap.goods-wrap202306 .goods-control button {
    width: 115px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #ff6b66;
    font-size: 14px;
    line-height: 36px;
    font-weight: 500;
    color: #ff3d3d;
  }
  
  .goods-wrap.goods-wrap202306 .goods-control button:hover {
    background: #ff3d3d;
    color: #fff;
    box-shadow: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-control .btn-hui {
    background: #cdcdcd;
    color: #fff;
    border-color: #cdcdcd;
  }
  
  .goods-wrap.goods-wrap202306 .goods-control .btn-hui:hover {
    background: #cdcdcd;
    border-color: #cdcdcd;
    color: #fff;
  }
  
  .goods-wrap.goods-wrap202306 .goods-control .btn-wait {
    background: #ffc4c4;
    color: #fff;
    border-color: #ffc4c4;
    cursor: pointer;
  }
  
  .goods-wrap.goods-wrap202306 .goods-control .btn-wait:hover {
    background: #ffc4c4;
    color: #fff;
    border-color: #ffc4c4;
  }
  
  .goods-wrap.goods-wrap202306 .goods-detail-btn {
    display: inline-block;
    position: absolute;
    font-size: 14px;
    font-weight: 400;
    color: #3d8bff;
    line-height: 20px;
    right: 20px;
    bottom: 16px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-detail-btn:hover {
    color: #296ad9;
  }
  
  .goods-wrap.goods-wrap202306 .goods-detail-btn:hover .icon-svg:before {
    content: "";
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/more_hover.e219c1d4.svg)
      no-repeat;
    display: inline-block;
    width: 14px;
    height: 14px;
    background-size: 100% 100%;
    filter: drop-shadow(#418dff -20px 0px);
    transform: rotate(90deg) translate(20px);
  }
  
  .goods-wrap.goods-wrap202306 .goods-detail-btn .icon-svg {
    width: 14px;
    height: 14px;
    overflow: hidden;
    background: none;
    vertical-align: -1px;
    display: inline-block;
    margin-left: 5px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-detail-btn .icon-svg:before {
    content: "";
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/more.583d474f.svg)
      no-repeat;
    display: inline-block;
    width: 14px;
    height: 14px;
    background-size: 100% 100%;
    filter: drop-shadow(#418dff -20px 0px);
    transform: rotate(90deg) translate(20px);
  }
  
  .goods-wrap.goods-wrap202306 .goods-info-price {
    flex: 1;
    display: flex;
  }
  
  .goods-wrap.goods-wrap202306 .goods-info {
    width: 72%;
  }
  
  .goods-wrap.goods-wrap202306 .goods-fix-height {
    height: 70px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price {
    width: 28%;
    text-align: left;
    align-self: center;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .goods-price-nei {
    padding-left: 10%;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .price-rent {
    font-size: 20px;
    font-weight: 500;
    color: #262626;
    line-height: 28px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .price-rent span {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .price-rent .price-symbol {
    font-size: 12px;
    display: inline;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .tj-old-price {
    font-size: 12px;
    font-weight: 400;
    color: #999;
    line-height: 12px;
    text-decoration: line-through;
    margin: 2px 0 8px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .price-vip-new {
    line-height: 16px;
    border-radius: 4px;
    border: 1px solid #ffe1d3;
    position: relative;
    padding-left: 40px;
    padding-right: 5px;
    font-size: 12px;
    color: #8e301d;
    display: inline-block;
    /* margin-top: 2px */
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .price-vip-new .icon {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0 4px;
    height: 100%;
    background: linear-gradient(139deg, #ffeae0 0%, #ffe1d3 100%);
    border-radius: 4px 0 0 4px;
    font-size: 12px;
    font-weight: 400;
    color: #8e301d;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .price-coupon {
    height: 16px;
    line-height: 16px;
    border-radius: 4px;
    border: 1px solid #fdada2;
    position: relative;
    padding-left: 48px;
    padding-right: 5px;
    font-size: 12px;
    color: #8e301d;
    display: inline-block;
    margin-top: 2px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .price-coupon .icon {
    position: absolute;
    left: -1px;
    top: -1px;
    padding: 0 4px;
    height: 18px;
    background: linear-gradient(25deg, #f63161 0%, #ffc3ad 100%);
    border-radius: 4px 0 0 4px;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    line-height: 18px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .tj-old-price + .price-vip-new {
    margin-top: 0;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .tj-old-price + .price-coupon {
    margin-top: 0;
  }
  
  .goods-wrap.goods-wrap202306 .goods-price .price-condition {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-title {
    max-width: 74.35%;
    height: 22px;
    font-size: 16px;
    font-weight: 700;
    color: #262626;
    line-height: 22px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
    text-align: justify;
  }
  
  .goods-wrap.goods-wrap202306 .goods-title .summer7 {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-title-con {
    max-width: 100%;
    display: inline;
    font-size: 16px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-title-con:hover {
    color: #ff3d3d;
  }
  
  .goods-wrap.goods-wrap202306 .goods-game-info {
    margin-top: 8px;
    font-size: 13px;
    color: #4d4d4d;
    line-height: 18px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-game-info span:before {
    margin: 0 11px;
    width: 1px;
    background-color: #cdcdcd;
  }
  
  .goods-wrap.goods-wrap202306 .goods-game-info .area {
    color: #3d8bff;
  }
  
  .goods-wrap.goods-wrap202306 .goods-game-info .area:before {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-rent-times {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags {
    width: 90%;
    margin-top: 6px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .discount {
    display: none;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .flag {
    line-height: 22px;
    background: #f3f6fc;
    border-radius: 4px;
    border: 1px solid #ccd2de;
    padding: 0 5px;
    box-sizing: border-box;
    margin: 4px 6px 0 0;
    color: #262626;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .flag:hover {
    color: #262626;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .icon-hint {
    display: inline-block;
    width: 16px;
    height: 16px;
    overflow: hidden;
    vertical-align: -4px;
    background: none;
    margin-right: 2px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .icon-hint:before {
    content: "";
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/wen.9a707f20.svg)
      no-repeat;
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
    transform: translate(28px);
    filter: drop-shadow(#657088 -28px 0px 0px);
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .flag-szq {
    padding: 0 5px 0 4px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .flag-szq .icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    overflow: hidden;
    vertical-align: -4px;
    background: none;
    margin-right: 2px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .flag-szq .icon:before {
    content: "";
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/szq.1abbabc8.svg)
      no-repeat;
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
    transform: translate(28px);
    filter: drop-shadow(#657088 -28px 0px 0px);
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .flag-bzmoney {
    padding: 0 5px 0 4px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .flag-bzmoney .icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    overflow: hidden;
    vertical-align: -4px;
    background: none;
    margin-right: 2px;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .flag-bzmoney .icon:before {
    content: "";
    background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/bzmoney.bae04e69.svg)
      no-repeat;
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
    transform: translate(28px);
    filter: drop-shadow(#657088 -28px 0px 0px);
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .rentgive .flag {
    background: rgba(255, 219, 206, 0.2);
    border: 1px solid #ffc3ad;
    color: #ff5a2e;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .flag-hb {
    background: #fff4f7;
    border: 1px solid #ffbdcd;
    color: #f63161;
  }
  
  .goods-wrap.goods-wrap202306 .goods-flags .flag-hb:hover {
    color: #f63161;
  }
  
  .goods-wrap.goods-wrap202306 .zhw-pages {
    background: none;
    font-family: MicrosoftYaHei;
  }
  
  .goods-wrap.goods-wrap202306 .zhw-pages .zhw-pages-inner {
    text-align: right;
  }
  
  .goods-wrap.goods-wrap202306 .zhw-pages .zhw-pages-inner div {
    padding: 30px 0;
    text-align: right;
    line-height: 1;
    display: inline-block;
    margin-right: -5px;
  }
  
  .goods-wrap.goods-wrap202306 .zhw-pages .zhw-pages-inner div a {
    color: #262626;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #fff;
  }
  
  .goods-wrap.goods-wrap202306 .zhw-pages .zhw-pages-inner div a:hover {
    border: 1px solid #262626;
    background-color: #fff;
  }
  
  .goods-wrap.goods-wrap202306 .zhw-pages .zhw-pages-inner div .current {
    background-color: #262626;
    border-color: #262626;
    color: #fff;
    border-radius: 6px;
    margin: 0 5px;
  }
  
  .goods-wrap.goods-wrap202306 .zhw-pages .rows,
  .goods-wrap.goods-wrap202306 .zhw-pages .jump_p,
  .goods-wrap.goods-wrap202306 .zhw-pages .pagebtn {
    display: none;
  }
  
  /*统一功能设置*/
  .common-law-limit {
    position: relative;
    padding: 0 16px;
    box-sizing: border-box;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: bold;
    transition: all 0.3s;
    display: flex;
    border: 1px solid #e6e6e6;
    margin: 0 16px 16px 0;
    border-radius: 2px;
    cursor: pointer;
    color: #4d4d4d;
    height: 40px;
    line-height: 40px;
    font-style: normal;
    align-items: center;
  }
  
  /*设置inline-block flex等*/
  .common-law-limit.shape-inblock {
    display: inline-block;
  }
  
  .common-law-limit.law-limit-float {
    float: left;
  }
  
  /*租号大厅官网固定宽度*/
  .common-law-limit-box .law-limit-con1 {
    margin: 14px -12px 0 0;
    overflow: hidden;
    max-width: 1090px;
    height: 60px;
  }
  
  .common-law-limit-box .law-limit-con2 {
    margin: 0px -12px 0 0;
    overflow: hidden;
    max-width: 1090px;
    height: 60px;
  }
  
  .common-law-limit.law-limit-fixed {
    width: 130px;
    height: 45px;
    padding: 0 0 0 16px;
    margin: 0 12px 20px 0;
  }
  
  .common-law-limit.law-limit-fixed .law-limit-txt {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }
  
  .law-limit-left {
    float: left;
    display: block;
    width: 88px;
    height: 40px;
    line-height: 40px;
    /* padding-right: 15px; */
    text-align: right;
    color: #888;
  }
  
  /*设置左右padding*/
  .common-law-limit.fill {
    padding: 0 16px;
  }
  
  /*文字颜色设置*/
  .common-law-limit .law-limit-txt {
    color: #4d4d4d;
    font-weight: normal;
    font-style: normal;
  }
  
  .common-law-limit .law-limit-cover {
    height: 100%;
    margin-right: 8px;
    display: flex;
    align-items: center;
  }
  
  .common-law-limit .law-limit-cover .img28 {
    width: 28px;
    height: 28px;
  }
  
  /*选中设置*/
  .common-law-limit:hover,
  .common-law-limit:active,
  .common-law-limit.active {
    transition: all 0.3s;
    border: 1px solid #fc3737;
  }
  
  .common-law-limit:hover .law-limit-txt,
  .common-law-limit:active .law-limit-txt,
  .common-law-limit.active .law-limit-txt {
    font-weight: bold;
  }
  
  /*字体大小设置*/
  .common-law-limit.font14 {
    font-size: 14px;
  }
  
  .common-law-limit.font16 {
    font-size: 16px;
  }
  
  /*元素边框圆角设置*/
  .common-law-limit.radius2 {
    border-radius: 2px;
  }
  
  .common-law-limit.radius4 {
    border-radius: 4px;
  }
  
  /*设置元素间的margin值*/
  .common-law-limit.margin16 {
    margin: 0 16px 16px 0;
  }
  
  .common-law-limit.margin10 {
    margin: 0 10px 10px 0;
  }
  
  .bc {
    margin-left: auto;
    margin-right: auto;
  }
  
  ol li {
    line-height: 150%;
  }
  
  h1,
  h2,
  h3 {
    font-size: 100%;
    font-weight: 400;
  }
  
  :focus {
    outline: 0;
  }
  
  a:active,
  a:link,
  a:visited {
    text-decoration: none;
    cursor: pointer;
  }
  
  a:hover {
    text-decoration: none;
  }
  
  .dis {
    display: block;
  }
  
  .left {
    float: left;
  }
  
  .right {
    float: right;
  }
  
  li {
    list-style: none;
  }
  
  .clear {
    clear: both;
  }
  
  .fr {
    float: right;
  }
  
  i {
    font-style: normal;
  }
  
  .clearfix:after {
    content: "";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  
  .clearfix {
    zoom: 1;
  }
  
  .a-line {
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .a-line,
  .over-hidden {
    overflow: hidden;
  }
  
  .clearfixd:after {
    content: "";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  
  .clearfixd {
    zoom: 1;
  }
  
  .free-play-list .slick-arrow,
  .icon {
    display: inline-block;
    vertical-align: middle;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/zhw-sprites.81df5ee.png) -41px -53px
      no-repeat;
  }
  
  .icon-arrow {
    width: 6px;
    height: 10px;
    background-position: -41px -53px;
    margin: 0 10px;
  }
  
  .zhw-view-move a.sprite-ico i {
    position: absolute;
    top: 10px;
    right: 0;
    background-position: -246px -4px;
    width: 6px;
    height: 11px;
  }
  
  .se-triangle,
  .se-triangle-on {
    width: 6px;
    height: 5px;
    display: inline-block;
    background-position: -31px -53px;
    margin-left: 10px;
    position: relative;
    top: -2px;
  }
  
  .se-triangle {
    background-position: -21px -53px;
  }
  
  .fr.act_color .se-triangle {
    background-position: -31px -53px;
  }
  
  .hot-item .hot-icon {
    width: 9px;
    height: 11px;
    background-position: -64px -52px;
    display: inline-block;
    margin-left: 4px;
  }
  
  .hot-item-on .hot-icon {
    background-position: -51px -52px;
  }
  
  .history-del-icon {
    width: 12px;
    height: 15px;
    display: inline-block;
    background-position: -77px -49px;
    position: absolute;
    right: 20px;
    top: 22px;
    cursor: pointer;
  }
  
  .home-download-icon {
    width: 11px;
    height: 12px;
    background-position: -193px -50px;
    display: inline-block;
    margin-right: 5px;
  }
  
  .side-hot-icon {
    width: 12px;
    height: 16px;
    float: left;
    background-position: -167px -50px;
    margin: 12px 8px 12px 19px;
  }
  
  .side-right-icon {
    width: 7px;
    height: 12px;
    float: right;
    background-position: -183px -52px;
    margin: 14px 15px 14px 19px;
  }
  
  .side-game-icon1 {
    width: 16px;
    height: 14px;
    background-position: -201px -28px;
    float: left;
    margin: 16px 41px 16px 22px;
  }
  
  .side-game-icon2 {
    width: 14px;
    height: 18px;
    background-position: -122px -28px;
    float: left;
    margin: 16px 43px 16px 22px;
  }
  
  .side-game-icon3 {
    width: 16px;
    height: 16px;
    background-position: -181px -28px;
    float: left;
    margin: 16px 41px 16px 22px;
  }
  
  .side-game-icon4 {
    width: 16px;
    height: 15px;
    background-position: -140px -28px;
    float: left;
    margin: 16px 42px 16px 22px;
  }
  
  .side-game-icon5 {
    width: 17px;
    height: 14px;
    background-position: -160px -28px;
    float: left;
    margin: 16px 41px 16px 22px;
  }
  
  .side-game-icon6 {
    width: 14px;
    height: 14px;
    background-position: -104px -28px;
    float: left;
    margin: 16px 43px 16px 23px;
  }
  
  .shq-down-icon {
    width: 12px;
    height: 18px;
    display: inline-block;
    background-position: -209px -51px;
    position: absolute;
    top: 12px;
    left: 64px;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
  }
  
  .drawer-fire-icon {
    width: 9px;
    height: 11px;
    display: inline-block;
    background-position: -51px -52px;
    margin-left: 4px;
    -webkit-animation: hot-icon 4s infinite alternate;
    -moz-animation: hot-icon 4s infinite alternate;
    animation: hot-icon 4s infinite alternate;
  }
  
  .search-sprites {
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/search-sprites.7bffd99.png)
      no-repeat;
    display: inline-block;
  }
  
  .ad-ft-header {
    width: 100%;
    display: block;
    position: relative;
    z-index: 10;
  }
  
  .ad-ft-header a {
    display: block;
  }
  
  .ad-ft-header .close {
    width: 20px;
    height: 20px;
    font-size: 20px;
    background: rgba(0, 0, 0, 0.6);
    line-height: 20px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 5px;
    cursor: pointer;
    color: #fff;
    margin-left: 600px;
  }
  
  .zhw-header {
    background-color: #252525;
    font-size: 12px;
  }
  
  .zhw-header .header-content {
    position: relative;
    width: 1200px;
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    background-color: #252525;
  }
  
  .zhw-header .header-left {
    float: left;
  }
  
  .zhw-header .header-left i {
    width: 18px;
    height: 14px;
    background-position: -80px -152px;
    margin-right: 8px;
  }
  
  .zhw-header .header-left a {
    display: block;
    color: #a2a2a2;
  }
  
  .zhw-header .header-left a:hover {
    color: #fff;
  }
  
  .zhw-header .header-left a:hover i {
    background-position: -57px -152px;
  }
  
  .zhw-header .header-right {
    height: 100%;
    float: right;
  }
  
  .zhw-header .header-right a {
    color: #a2a2a2;
  }
  
  .zhw-header .header-right .login-packets {
    color: #a2a2a2;
    position: absolute;
    bottom: -36px;
    z-index: 100;
    left: -3px;
    background-color: #404040;
    text-align: center;
    font-size: 14px;
    border-radius: 5px;
    margin-left: 0;
    float: none;
    line-height: normal;
    height: auto;
    padding: 5px 15px;
    letter-spacing: 1px;
  }
  
  .zhw-header .header-right .login-packets:after {
    content: "";
    width: 0;
    height: 0;
    border-bottom: 12px solid #404040;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    position: absolute;
    left: 33px;
    top: -5px;
  }
  
  .zhw-header .header-right .private-sphere-box {
    float: left;
    width: 80px;
    height: 40px;
    margin-left: 23px;
  }
  
  .zhw-header .header-right .private-sphere-box img {
    width: 80px;
    height: 40px;
    margin-top: 0;
    vertical-align: initial;
  }
  
  .zhw-header .user-msg {
    float: left;
    margin-left: 23px;
    position: relative;
  }
  
  .zhw-header .user-msg:hover .sys-mes-icon {
    background: url(//zuhaowan.zuhaowan.com/pic/201910/mail-hover.bfcf2da711cfba04.png)
      50% no-repeat;
  }
  
  .zhw-header .user-msg:hover .sys-mes-important {
    display: block;
  }
  
  .zhw-header .sys-mes-icon {
    display: inline-block;
    width: 15px;
    height: 11px;
    background: url(//zuhaowan.zuhaowan.com/pic/201910/mail.6491a03a8fe699d3.png)
      50% no-repeat;
    position: relative;
    top: 1px;
  }
  
  .zhw-header .sys-mes-num {
    font-size: 12px;
    color: #fff;
    display: inline-block;
    min-width: 17px;
    height: 17px;
    text-align: center;
    line-height: 17px;
    border-radius: 50%;
    background: #fc3737;
    position: absolute;
    right: -8px;
    top: 4px;
  }
  
  .zhw-header .sys-mes-important {
    width: 154px;
    height: 80px;
    background-color: #fff;
    -webkit-box-shadow: 0 6px 23px 1px rgba(86, 86, 86, 0.1);
    box-shadow: 0 6px 23px 1px rgba(86, 86, 86, 0.1);
    border: 1px solid #ebebeb;
    position: absolute;
    top: 40px;
    left: -70px;
    line-height: 1;
    display: none;
    z-index: 1;
  }
  
  .zhw-header .sys-mes-important-arrow {
    position: absolute;
    width: 0;
    height: 0;
    left: 72px;
    top: -5px;
    border-color: transparent transparent #fff;
    border-style: solid;
    border-width: 0 5px 5px;
  }
  
  .zhw-header .sys-mes-important-inner .sys-mes-important-tip {
    padding-top: 11px;
    margin: 0 auto;
    font-size: 12px;
    font-weight: 400;
    color: #787878;
    text-align: center;
  }
  
  .zhw-header .sys-mes-important-inner .sys-mes-important-btn {
    margin: 14px auto 0;
    display: block;
    width: 80px;
    height: 23px;
    background-color: #fc3737;
    border-radius: 2px;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    font-weight: 400;
    line-height: 23px;
    text-align: center;
    color: #fff;
  }
  
  .zhw-header .sys-mes-important-inner .sys-mes-important-btn:hover {
    -webkit-box-shadow: 0 5px 13px 1px rgba(252, 55, 55, 0.2);
    box-shadow: 0 5px 13px 1px rgba(252, 55, 55, 0.2);
  }
  
  .zhw-header .envelope-unread {
    font-size: 12px;
    width: 17px;
    height: 17px;
    text-align: center;
    line-height: 17px;
    border-radius: 50%;
    position: absolute;
    top: 4px;
    left: 7px;
    background-color: #fc3737;
    color: #fff;
    cursor: pointer;
  }
  
  .zhw-header .user-box {
    float: left;
    position: relative;
  }
  
  .zhw-header .user-box > a {
    float: left;
    margin-left: 23px;
  }
  
  .zhw-header .user-box a:hover {
    color: #fff;
  }
  
  .zhw-header .user-box .user-recharge,
  .zhw-header .user-box .user-reg {
    color: #ff5b5b;
  }
  
  .zhw-header .user-box .user-loginReg:before {
    content: "";
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAEMElEQVQ4T02U64tUdRjHP8+5zOycMzM7s9reXM3LaqRGQoK9iO4avrAi6IJouoVvigwq7F+Q9YVsBhshVoZJF8oiEC274IsuRvrCiAIzcnf2vjM7Mzu3c/nF75xx8cC5cM7D5/l+n+/vd4T2oc4NrcTMnCKZ3EIYXsZvHpZH3j578/utd3X2wOMkOw4h5t0QXsKr7pEdJwq6RvRFfbE/h+tcojM3SKYLGjWYn1VhuXrUfOrE60tNFcLX+47hZF7GzUKiA1oNKJf+pD62TZ74qhIDP3tuhGzuIPnbwMlCqwVT0zBbJlyoHTbWZK7QaIY0qveS7XwtqsnmY+D8LMxMQL02LM+feVPUWzuT9PXNkl2exklBQlD1GkwWYbKC9HUoVvQL5RLMTYEEkEyBnQBlQiAgJjSrRf4udIv6aN8mhX1VjV0jbHRCz1rMgRxq8gbMTGPc7sCyFbBQgqkJCBoo14Wu1QSFOqpUwHRqyNo7EBUOivryhYwar/3h/XRlpQpWoxZThGGa5NZVGIkKsiEPZgr8AAIfxicJai7NX8YxpIy4i0hiHPvhbdel4WyOZzg88ga+NYxKCmJAGEIYQM6C7WvBN8C0IZWAz3+FUg3w22cTrIYixaty6MgxUUeOuHiJOZSbhGQcqAohaKI6PWTHGvAAy0bPWH38M1JsASGoFhgNMBuQCmpkjS5Rw0e30Awvo2sCDVNthU1U3kd23QWtAKwEOGnU6e+ROV2sQDSwCQkfXAPSiY2iRkbuoeb9Rq0Jvg+B7qyi7qpLIU9uhZYPpgWOizp1ASl68QoW/b4FyRDSFrjuZlGjo934wV80Wzk8rw3TKluoTIA8fV/cyDDATqJOfYtUBSyTaBaGB4kAOow5ctb6KJTKwNDB0C6P4Jpg6fEIhq0wekzsO9MYRlkbRIV5vKtVgrEAVde8oJ1NgBHmX8rMHR+NU143tE918z79FiTMaN6R7eUCmzOoaoUo/c4u+H0BKQhUgAUfKj4sKsK6v9sqvnc6Bm54cS/99skImDIgMCKg6gYeGoiV6N2QcuG7f5GCCaUQ5j0oBVDW4OBZmX/nkxg4eGAvveZJVpjgaIVGpEj1hMjOlTFMh2LaqHMaaIEOZsaDeR9KPlRvBa4a2kOP9SEDOik7XouGher1kcfy0TOGHb+7MItMJGJ10xqoVWrb4TMyP/pprLB7/3a6rPP0mdCllWhFJqq/iTzYVhcBbdTFJlJwYtBMC+bawIa6X4qjF2Mg+zvo5TrLzF6W2URpJyzUwCLyQG1JXWT5xyQy7sSBaMva+mJwg6lwnfCuFwEjqLtnO451hozhkNEBWKjBKvLoTLyPtW0NPJ9H/kvHQRSj2VWp+7ukdPyHpT/2EjS5ez0p6xWSxiZSls3GRdg5AYbeFXohW/BNP/zjQj1sUQuu0mock+kPrt1k/A+hB+CoICS/lwAAAABJRU5ErkJggg==)
      no-repeat 100%;
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 6px;
    position: relative;
    top: 4px;
  }
  
  .zhw-header .user-box .user-avatar img {
    background: #a2a2a2;
    width: 20px;
    height: 20px;
    display: block;
    border-radius: 50%;
    margin: 10px;
  }
  
  .zhw-header .user-box .user-name {
    margin-left: 0;
  }
  
  .zhw-header .registered-wapper {
    float: left;
    margin-left: 23px;
  }
  
  .zhw-header .registered-wapper .registration-guide {
    display: none;
    position: absolute;
    background: #fff;
    top: 40px;
    left: -17px;
    z-index: 999;
    width: 300px;
  }
  
  .zhw-header .registered-wapper .registration-guide .regist-box {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 28px 20px;
    -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);
    border: 1px solid #f1f2f3;
    width: 457px;
    height: 276px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/zhuce-bg.cc46f9c.png)
      no-repeat;
    background-size: 100%;
  }
  
  .zhw-header .registered-wapper .registration-guide .regist-box .regist_top {
    width: 113px;
    font-size: 16px;
    color: #000;
    line-height: 21px;
  }
  
  .zhw-header .registered-wapper .registration-guide .regist-box ul {
    overflow: hidden;
    margin-top: 6px;
  }
  
  .zhw-header .registered-wapper .registration-guide .regist-box ul li {
    font-size: 16px;
    width: 50%;
    float: left;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 54px;
  }
  
  .zhw-header
    .registered-wapper
    .registration-guide
    .regist-box
    ul
    .red-envelope-home {
    color: #ff893d;
  }
  
  .zhw-header .registered-wapper .registration-guide .regist-box ul li:before {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    line-height: 15px;
    background-size: 100%;
    width: 42px;
    height: 42px;
    margin-right: 10px;
  }
  
  .zhw-header
    .registered-wapper
    .registration-guide
    .regist-box
    ul
    li:first-child:before {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAEaElEQVRYR9WZS2hcVRjHf9+dPGYSE2isSWwTJWAJVixqRcgq8bHRqtCF4sKu21UXduNjoS7ElS5cSEt33algEam6qRVFAqKkFFSUvmSm2DwkaJN5NDP3k3PuzJ07yUxyz500JBeGOwz3nPO7//N9//OdM0LCS1W7KOYm8HkS4QDCOCqDiPbZLlVuITqH8gfKJTwukB6ZFpHbSYYU10a6fONRPD2K6svALsf2i4h8ii+npHfvjEvb2KBayh7A532UZ4HY7VrAKMLXeLwh3aOX4gBvOKDqtTSlzvfw9TjQEadTh2fKePIR3StviYwV12u3LqgW5x7Av/0Z6CMOgyd4VC7idb0k6cHLrRq3BNV89gmUcwi7E4zs3kRZQDgkPaM/NWvcFNRCwnngLvcR22qxBDzdDHYNqJ3uSml6y5Rc/V5G2VT3xOowaAC1iVPonG4rJlduBUN3Bnaa7JKLZFYmognWCFrMfYCvryXq3F9BZy+gizOgigw8hgw9BV5Co/DkQ0mPnKixhKDWJyv8ksiCinPojS/R0oJZkiyo/aR3IyOHkfQ9Sd69TIqDNZ+tgxay51Cec+rRwCz+jM79AFpGjZKptIXUSj64Swrv3meQgcedurYPC19JZvRQ8NVoYJZF8Y2aGy4A4WjlJfTvb2D5eqCemeI9zyN9++wj+u/vaO4L1F+xKnv948jeF6CjxwVYUe+gWW4D0ELuJKpHY/dQvInmzkKlAOoHoIOTyN3G1eqXzn6LP/djEA7m09GHN/Yqkh6MPRQipyQzckxsFVTI3XQpMPT6GSj9AwSQZsq9sSOQHm4E/e9P/L8+qcctimSG8fYdiw8Ki2RGhkUL2UmU72K3rBTRKycDFaugVq09LyL9442g89P4s+cR9dFIkqUeeh06MrGHRJgSXc6+g/B27FblZfTK6ep01hWVrgHk/legozeI0eI8eu0MVPJW8eDFgntq/wno7I89JMq7ovns58Dh2K0M6NXTVQvyw/izGe+lofc+MJ66dDW4RwATg8JZM/W/oux3B61CVtUKpzbqo/ibAyr8JprPzYPGr5BCReugVk0ThU3UU+MKtayvvpTz1CMLRtEiSre7opFkMplfU3LVPQRtJ0aFUhugRikjVjWhNgKNZr1rMlnQxFNfVzQ65Y0h0CRGUVIPOmZ9deoTJlOjj4YWVJtiq6DxT9b6qLuiJpkS2FMTHw2rpoYQaB4W7slk7CmJ4bfw0aipB+CbZE/W8F2X0Kg9RTL5DvvolHtRsvU+GhQlzmVedAmtFSV30kdrZZ5z4Wwq+csfg19289EwTCD18JvgdcVZYxoL50BVh63I4gw6/73dftTq0VrWr++j4A1NIkNTcSDXbkUsqOvmzijqF6vlm+2hWsZFv5vfzGVsymwbe1y2Is03d0EN2cZ2OZ5G8Z9qtV22oJtxABEfZZ0nNziACFTdAUc6tVfcEYdkDbDb/dgxhN0JB7kh7E44Go+m5bb/s2G1h2z7v2/WAG/xH2L/AwPPos6g3z9HAAAAAElFTkSuQmCC)
      no-repeat;
  }
  
  .zhw-header
    .registered-wapper
    .registration-guide
    .regist-box
    ul
    li:nth-child(2):before {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAE0ElEQVRYR9WZW2hcVRSGv3XSJBNjCoombS5CoKEoNF4ihRSxFvFBA6KgIvggiLmoIa29klpti4hgbYs+2Scfij4oVHxoRVGqYgkUQkOs1kul6iSpxpgYq9JMZmbJPpeZM5NpcvYRQzKQMMzsy7f/vfa/1j4jxHypagUjI+04bEJoBdaC1KJa4w4pcgl0HPgWZZgsJ2lsHBCRVJwpxbaTjo7eimg3qo8A11j2n0LkHVSOSEPDGZu+kUH112QrGV5GudfoZTNJibaK8AFl9Etd03CUsRacUC9cSFBZ/hKqfcCKKINatEkj8jozs89Jc/Pl+frNC6rj42uYTb0LeovF5DGayhDlFQ9Lbe35K3W+IqheTK4ny3Hguhgzx+kygUOHrG46XapzSVAf8hPg6jgz/oc+f+FwdynYOaDeds8MLKKSxeuaoLyyvTgMCkDdg1NRPvD/x+RCmssQqdn28AErBB0bOYjq1oWGWZTvRQ5JfeO2YK4cqOuTaQajWJCeP4ueeBsuTXmOav4cb0hxJPRZ6L1pU70SufMhaGmLstY0K2gLfDYPOpY8jnJflBGyh3f7kAphMMMl4kEXLSBoJ5UJ6DwAjr+y+c3zhNQ3dbgCmH9uWiRr1FwwAZj22X09eRBXzSLlRJAwrAuvZhVuP+l8Baqqo2hilGgz6dYDHRt5A9XuKD1Nm8zeHn+bA+V80AK4ojDIKSxIV2RQs7gjUt/YI24VNDbyi02BkXm+21WnULUoyrpVFdJjAQpT1DeuEk0mN+LwaVQ1XUX3GFB/0uAgBYoVxaiJWTWCh9SWpw5E3XoPK8tdoqPJfcBeG1D9/EP09Gfo9O+eQgGsI0htPTp7GaYnQ4fKb5Oogts2Ihs6wCmzmXK/6FjyGMqDNr34529IVKHfDKPnhuCn70ykI4/1InUN7lB6bhDefxOqa+CGFqRlHbTcDNkslJfbgQrvGdCvUG6yAc280IesvwNnwya49np/ezJzJ0/NQEWl9/2fU+jgSRj+Aul60W7rha9Fx0Z+Q9WqQsrs6spbTd0qZM2NyD0PgPHI0Esnx+HMKUh+j178EcSzKKfPMkZFJkyMmoLVX3Y0XTM7uvz4y/un83gvsnZdIejHx9CBj3KLCpKAs+VVO0VhJhZoertRtNAnpW418sRmZKV3jdKff0CPvgaZVM4hcqDPxgGNsfXpbT5ogTUJJBJIcwukZtCkKdbVc4SQ2Zv3zlZLUHfrYxym9FYP1FU1DEGJ3O/4PhryWWe7Lah7mOztKb2lMx93Tgi2ZN73E0PI8J0dB+1i1LWnGIaf3mxA5+b5AnXDWx4UIz6ss9MSFPbHSqHpvhBoTimv8PJSZakixa+cHHB2WYK6KTRGUZLu7SysOYO8H5SYxbBmBaHPyvqtQL2iJE6Zl37mybzlFNedwSELK11U/pX1H4KrItWj+TLPBbUsnGef9kDdaj5cyfvK5hwhDBtqV7Y7Mmhh4eypGv0qku7fiU5P+tZUCrZUCejHaFUCZ8/heFcRF9Tmcnf2SzJvHUX/mAzVmaXVNaKra2ECNTU49z+KtN4eJVeXvtz5sbr0r8su6HJ5AOHCLodHOkHgLIuHZEWwS/uxYw52OTzIzcEuh0fjBfefpf5jQ7EzL/mfb+YAL/IPYv8CNdjd4gUXsm0AAAAASUVORK5CYII=)
      no-repeat;
  }
  
  .zhw-header
    .registered-wapper
    .registration-guide
    .regist-box
    ul
    li:nth-child(3):before {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAFNklEQVRYR9WZW2wVVRSGvzWntECh0ILQpIfGouWmIEogaVAuikYtMSGK+mB8IQaejFFf1ICiIUqieCEYIb6YGBMhgBgpxoR4jY2oUGooKW1p4BQk0PZQCtiWMsvsmTk9l7b07GlC6Lyck9l77f3Pv9b615o9QshLVXNbLlKBy3Ic5qHMFGGKwnizpECnKucR6nGpxeHH6ESqRaQnzJZia3QmrveqslbhaaDQ0j4usFOE7SWFcsTGNmugsXadB7wLPOYTNqxLgQPAa9OKpDablYbcsLlZR4+ayCZVXgRyslnUYk6vCJ9cu8gbZWXSdSO7GwI936F39rjsUmW+xebWU0WoyXVYPWWCNA5mPCjQWKsuwmE/MNl653AGrbhUTpsshwYyHxBoAPIgMC7cnqGtLuPy0EBg+wE17u6+TvVNZDLzqVrzIlRkhkEa0CBxqsPG5NVeqLng73vfbTA6ZOqZmL12kYrUBEsD2hLXD1R5OYzj6trh6walsxtcVSbmCk+WC3NDRrgIW6KF8koCSx/QQCf/DiNBv5yFfU2KKhiBVA3+KzxVLiyJDqmCA3HTCyxI6GwqUJPhj9uyaVz9Zb3iql8FSvINUIh1Ktc91PD8HGFhcSiwVdOKpDIoyWDKoqsYNq1Wu3oNNh9WLvfA6AisnSuUepUeTl2CbUddrvTA2BxYX+FQkGtLA+oIC0y59YC1tOtnCmttl6k6BQdPq+fuJ8qEZdH0FczYngYTBsqSEodnZ1vx4C0msD1aJOvE64LinLNtMIyr3/lT6ej2Xb1urjAzo0U53qZsPeIDHROB95ZGyI3Y0kE8WkixxOK6FOUnW/OmDvi01o9NA7SyTHi4NH2V75uVbxvdviR7YZ7DgjCxKiyTWJu+hfCmLdCfz8C+k4nsVkY5wpq7YFaR717D5o5apas3qQAPljo8E8L9KBsNo3tQVtkC3dWgVP9rNNNY+mDM/0l54ulo23++TPnjPuvlhcKrixzbrUyg7pVYux4D5thaf3FcvSqUqpmejvZpaf+x4nx4+wH7IAXqpCWuF1TtOiTD0kc1yulLSTDmQV23v+AnwJvx/Bz4cIU9UBFajeu7UPJsGN3dqPx2xi+Vged9JtMYTYaDmWTGHIENix1KxlvKlNBtDfRkB2w96kuOqvi/Jgb72Exx+QD3SwuEDYsjiA1WA9TW9V/VK4fOZYAJGDOIfblKrft+GfWSKkiulxZGuGdq9kh911sm08Y/lHhXUnIS2e65N8j+tDBICwnf7v6osGa+VazWWcmTqe2v/24EPMXlqUASbA4WCsHcknHCpuUWQD15shD8052w5bDiuskk8l3qZ7u572V/4l6KywPP+0kFfL4yx0uurK5A8LMuocfaYMc/QUlUKJsAK6cLxWOFv84pO+uTYwbQqhkOsyZBUxy+a3TpSAmZjx+JUDgmS6SmhNo0JfVx2FbjUloAlbc7zJ6U5GP3CeWHZjdonH05WjVDqLzDr0TdvXjjVY2u1xa+vyLC1PysgPpNiW2bZ7qlgrz+jeuBk8o3DemMPne3w7LSdDBXepSzl6E86AmGcn1fm2cmhm2cUzc5fxXW/3q9r5vKEdi83GFCXlasDYY3vXE2s2LtGupVJHWHvSeU/U0+q6tnOTw6fVggzdLpryIBUHMIFurlLhVsXauS48CMLF17A9cP/HLnxeowXpeHijXb8UFfl81Cwz2AsAUz2PwhDyCM4Yg40kk84Yg4JMsAe2sfOybAjoiD3ATYEXE0npqVt/zHhkwJueU/32QCvtkfxP4H3JQ4cLHqAUsAAAAASUVORK5CYII=)
      no-repeat;
  }
  
  .zhw-header
    .registered-wapper
    .registration-guide
    .regist-box
    ul
    li:nth-child(4):before {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAFR0lEQVRYR9WZW2wUVRjHf2e33S4tvWGp0p0tVIoSiFVETXjxEpNGKHhBCog0hkSjTz7ok/FBfTA+aQSjAhpjTAxRohiRgiQoYkxjCdYQRCnFortLS1mLUFq229055sxlbyx0ZoiEzkPbdM6Z85v/+b7/982MwOMhpQxEiS4BHvBBC3AriHqJrFSXFIgRkEPAMR0OA99raF1CiKSXJYXbSTEZWySRz4JcDdS6nH8WxOcCsSUkQj1u5joGjchIi4A3gKWGYFd3SGC3hJfCIqzUnvSYdMF+2R8so/R1Hfk8UDLpFd0NSPkQm8aZeLlJNCWuNPWKoENyqHmC5HaJvMPd+u5GC8SvpQTa60V93+VmXhY0IiP3CNgF1Llb1vPouIS2sAh3F7tCUVALch8w3fOy3iZekPBgMdhLQNV2JxnvuoZKFt5SPEDZksIwyANViROgtOv/jsnJxFYxm2RiSW6C5YGektE3deQLk13oWpz3Id5qENqL9loZUMsnD3mxoAupc8TG+hlKRDmXHCYlU5T7K6kLziJU3kR9sEFVKrf3l5Kw2PbZzOyojKgMX+b0arpME7vYT//IUYaTQ0gp0ZFIifqJLtXf6n9Q7q9gbuUC5lUtJOif5nQJNa5TE+E2syQDZlnUlZqOblsp1zN8gER6zACRUke3AG0447eCtc8DPvzcPuNuWmrvcgorBb7FqtwaYFEZ3YxRv50de09tYyw9mqOigjKVLK4sltomePucp6gqrXa2GGKLJrTnhOqCYkQH3TQYO/7+wILKApjKGqjWtmdDIKusGR4rwu3MmhZyCMrZENpNIiIj9wnY73SWGvfFX1uzQBZg0fi0tt4+ZwJLHmlc7QZU7cL9CvRVAa+4Ad1+ckseqAmSTZ7cOM0LBRXLwKONa2god6yoAn1NxGTkSwmPuQH97OTmTFarmLOVyotTS826YD2tDSs4fv4Pfho6YNzQytkKVHO8pIAdCvQ3CQsczwK29b9vJodux2SOJVkWpc4ryLbQSsr8QQ6f7eGHwX2GfT0+Zy0hd6BHRUxGz0ikqw7p0z/fy1FRcu+NrfiEn/2De5nQJ4ybqCurZ7lmQp4YOc7u6E7SMm2Atjc94RJUxEVURlTDWuZG0U9OvJvNcGDV7A6qSmsYGIvSGfuKmsCMDGTf+V72xL4hpafNuAbWNK1Dc6EoMO4J9OO+dywjN+2msqSatvAqppdM5/TFAWoCtYaSfSO9ppK6SiIr4ZCsbXoSrSLsRptxT1v/0fFNeaAqmZSiDyvYUuMhFKVkp7XdhT667ub1hF2ACkTcUzJ92Lsx354sawqWlDO/eiGjqVF+//eIoaThCnaCWT66fm6HS1BUMrm3p63H3rZAC7M9W0ozlSqnWdGlCd7R3EFjRaPjrTfsyYvhb+3daCaHXXkypTOn3mcaEjOOc7d/w7wNaBUuDd9LCf1u4FuOnjti+OglpTPHR80OKl/1mcGZPHPL05T4nD95GyXUS1Oi/LD7TBcH4z+b3mjX+0sUtts8U9H5NfNZHl5GRUmF420Hqynx0ubZqwxeHGBPrJN44kyOcgVdlDJpfxlLtYdoqb3NDaA11mrzvDTOuaul9BQ/nj7AwXg3aZUsOQ2zCovmqmZWhJdTZdmWS9L8xtlU1d2jSOGC0dEIX0d28k9i2HCEgC9Aa6iVO29Y5JItb3j+o4g6dTUPd/alk3qSQ/FfSKQTBmB1wGkXX/Reij/cqaFT4nFZgU6ZFxAKdkq80rEjZUq8JCuAvb5fO9qwU+JFrg07JV6N57rbdf+xodCKr/vPN4XA1/qD2H/12sf0ompbjwAAAABJRU5ErkJggg==)
      no-repeat;
  }
  
  .zhw-header .registered-wapper .registration-guide .regist-box .regist_foot {
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 28px;
    margin-bottom: 10px;
  }
  
  .zhw-header
    .registered-wapper
    .registration-guide
    .regist-box
    .regist_foot
    .regist-btn {
    width: 200px;
    height: 38px;
    background: #ff3d3d;
    border-radius: 6px;
    line-height: 38px;
    color: #fff;
    text-align: center;
    display: block;
    font-size: 14px;
  }
  
  .zhw-header
    .registered-wapper
    .registration-guide
    .regist-box
    .regist_foot
    .red-border {
    background: none;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #ff3d3d;
    color: #ff3d3d;
  }
  
  .zhw-header .registered-wapper .registration-guide .regist-box .regist-food {
    width: 100%;
    text-align: center;
  }
  
  .zhw-header .registered-wapper .registration-guide .regist-box .regist-food a {
    color: #3d8bff !important;
  }
  
  .zhw-header
    .registered-wapper
    .registration-guide
    .regist-box
    .regist-food
    a:hover {
    text-decoration: underline;
    color: #fc3737;
  }
  
  .zhw-header .header-line {
    margin-left: 23px;
    float: left;
    width: 1px;
    height: 12px;
    background-color: #444;
    margin-top: 14px;
  }
  
  .zhw-header .site-nav {
    float: left;
  }
  
  .zhw-header .site-nav ul > li {
    margin-left: 20px;
    float: left;
    position: relative;
  }
  
  .zhw-header .site-nav ul > li > a {
    display: block;
  }
  
  .zhw-header .site-nav ul > li > a i {
    width: 0;
    height: 0;
    border-top: 3px solid #a2a2a2;
    border-right: 3px solid transparent;
    border-left: 3px solid transparent;
    display: inline-block;
    vertical-align: middle;
    margin-left: 4px;
  }
  
  .zhw-header .site-nav ul > li:hover > a {
    color: #fff;
  }
  
  .zhw-header .site-nav ul > li:hover > a i {
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    transform: rotate(-180deg);
    border-top-color: #fff;
  }
  
  .zhw-header .site-nav ul > li:hover .site-second {
    display: block;
  }
  
  .zhw-header .site-nav .site-second {
    position: absolute;
    top: 40px;
    left: -17px;
    z-index: 99;
    width: 190px;
    display: none;
  }
  
  .zhw-header .site-nav .site-second.site-about-second {
    width: 150px;
  }
  
  .zhw-header .site-nav .site-second.site-member-second {
    width: auto;
  }
  
  .zhw-header .site-nav .site-second .site-list {
    background: #fff;
    border: 1px solid #f1f2f3;
    min-width: 90px;
    min-height: 80px;
    padding: 5px 10px 10px;
    -webkit-box-shadow: 0 10px 18px 0 #ccc;
    box-shadow: 0 10px 18px 0 #ccc;
    line-height: 30px;
  }
  
  .zhw-header .site-nav .site-second .site-list > a {
    display: block;
  }
  
  .zhw-header .site-nav .site-second .site-list .hotli {
    font-weight: 700;
  }
  
  .zhw-header .site-nav .site-second .site-list .hotli:after {
    content: "";
    width: 9px;
    height: 12px;
    background: url(//zuhaowan.zuhaowan.com/static/www/head/hot-icon.png)
      no-repeat;
    display: inline-block;
    margin-left: 2px;
    position: relative;
    top: 1px;
  }
  
  .zhw-header .site-nav .site-second .site-list2022 {
    width: 150px;
    height: 97px;
    padding: 20px 10px 21px 20px;
    background: #fff;
    -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2);
    border: 1px solid #f1f2f3;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .zhw-header .site-nav .site-second .site-list2022 > a {
    display: block;
    height: 18px;
    font-size: 13px;
    color: #000;
    line-height: 18px;
    margin-top: 20px;
  }
  
  .zhw-header .site-nav .site-second .site-list2022 > a:first-child {
    margin-top: 0;
  }
  
  .zhw-header .site-nav .site-second .site-list2022 .icon {
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-right: 11px;
  }
  
  .zhw-header .site-nav .site-second .site-list2022 .icon.icon_hz {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAilBMVEUmJiYnJycpKSktLS0vLy8wMDA2NjY4ODg5OTk9PT0/Pz9BQUFCQkJHR0dISEhLS0tNTU1XV1dwcHB0dHR1dXV2dnZ3d3eBgYGCgoKRkZGTk5OampqhoaGlpaWwsLC2trbCwsLLy8vMzMzg4ODh4eHi4uLr6+vw8PD29vb8/Pz/VVX/lZX/l5f///8RsClcAAAAlklEQVQY033Qiw6CMAwF0I7JFOtABJ+IiC/cdP//ezLaLEaNTW6ynKRbV3BfBc7dlzPkWnREW0hYprAhmiShZz4yno6wC7SHg6c1XAN1YuUpVf35xhlrT4VoXStPFFF4OkdCAcAQEV2GF1HqsinTPloiDYEYrsc3elhrn38pjw33mTgnqkHxHxXURK7KmLKKl/NjX5/1AutJKU72TwW5AAAAAElFTkSuQmCC)
      no-repeat;
    vertical-align: -4px;
  }
  
  .zhw-header .site-nav .site-second .site-list2022 .icon.icon_zk {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAV1BMVEUAAAD/NzcgICAmJiYoKCgoKCj/PT0mJib/Pj4mJiYlJSUmJiYnJycmJiYmJib/PDwlJSUnJycnJyclJSUnJyf/PT0mJiYmJiYmJiYmJiYlJSUmJib/PT2v+faPAAAAG3RSTlMAFxgbIEZLV29/goWYn6atv7/M4eHx8vP0+fyOuopbAAAAdklEQVQY033OWQ6AIAwE0EFwR3BBROX+57RuiQHifDThZVIK/KUsI+r7ALJu6QIiyQIahu9LSLPtlM1IcUtunWpqSqOcza+OHfnb56M9e9JxMM0ec5KmUWCVr8iKAlCGaG2hvfcamGegXePWlN6V+DFxV+r6MAfypwdUbB33zgAAAABJRU5ErkJggg==)
      no-repeat;
    vertical-align: -3px;
  }
  
  .zhw-header .site-nav .site-second a {
    color: #666;
  }
  
  .zhw-header .site-nav .site-second a:hover {
    text-decoration: underline;
    color: #fc3737;
  }
  
  .zhw-header .site-nav .site-second dt {
    color: #333;
    font-weight: 700;
    line-height: 30px;
  }
  
  .zhw-header .site-nav .site-second dd {
    line-height: 25px;
    padding-left: 5px;
  }
  
  .zhw-header .site-nav .site-second dd span {
    margin-left: 2px;
    margin-right: 3px;
  }
  
  .zhw-header .site-nav .site-second .site-second-btn {
    border-top: 1px dashed #e4e4e4;
    padding-top: 5px;
    margin-top: 5px;
  }
  
  .zhw-header .site-nav .site-second .site-second-btn a {
    float: left;
    width: 49%;
    color: #ff594b;
    text-align: center;
    font-weight: 700;
  }
  
  .zhw-header .link-mobile {
    float: left;
    margin-left: 20px;
  }
  
  .zhw-header .link-mobile a {
    display: block;
  }
  
  .zhw-header .link-mobile a:hover {
    color: #fff;
  }
  
  .zhw-header .link-mobile a:hover i {
    background-position: -109px -153px;
  }
  
  .zhw-header .link-mobile i {
    width: 9px;
    height: 12px;
    display: inline-block;
    background-position: -123px -153px;
    position: relative;
    top: 1px;
    margin-right: 4px;
  }
  
  .zhw-top {
    padding-top: 20px;
    background-color: #fff;
    position: relative;
    -webkit-box-shadow: 0 14px 16px 0 rgba(0, 0, 0, 0.03);
    box-shadow: 0 14px 16px 0 rgba(0, 0, 0, 0.03);
  }
  
  .zhw-top .se-focus-toggle2 .history-word .history-item {
    display: inline-block;
    margin-right: 16px;
    padding: 0 17px 0 0;
  }
  
  .zhw-top .se-focus-toggle2 .guess-word {
    display: none;
    width: 314px;
    margin-left: 20px;
    margin-right: -32px;
  }
  
  .zhw-top .se-focus-toggle2 .guess-word .guess-refresh-icon {
    font-size: 12px;
    font-weight: 400;
    color: #888;
    padding-right: 19px;
    background: url(https://zuhaowan.zuhaowan.com/static/client/search202211/left-ipt/icon-refresh.png)
      no-repeat;
    background-position: 100%;
    cursor: pointer;
  }
  
  .zhw-top .se-focus-toggle2 .guess-word .guess-item-box .history-item {
    display: inline-block;
    padding: 0 17px 0 0;
    margin-right: 16px;
  }
  
  .zhw-top
    .se-focus-toggle2
    .guess-word
    .guess-item-box
    .history-item
    .guess-hot-icon {
    display: block;
    position: absolute;
    right: 5px;
    top: 7px;
    width: 10px;
    height: 10px;
    background: url(https://zuhaowan.zuhaowan.com/static/client/search202211/left-ipt/icon-hot.png)
      no-repeat;
  }
  
  .zhw-top .zhw-search {
    width: 1200px;
    margin: 10px auto 20px;
  }
  
  .zhw-top .zhw-logo,
  .zhw-top .zhw-logo .logo-img {
    float: left;
  }
  
  .zhw-top .zhw-logo .logo-text {
    font-size: 14px;
    font-weight: 400;
    color: #6e6e6e;
    margin-left: 18px;
    padding-top: 21px;
    float: left;
  }
  
  .zhw-top .gameSearchForm,
  .zhw-top .zhw-form {
    float: right;
    margin-top: 10px;
  }
  
  .zhw-top .zhw-form {
    position: relative;
  }
  
  .zhw-top .zhw-form .gameSearchForm {
    float: none;
    margin-top: 0;
  }
  
  .zhw-top .zhw-form .search-hot {
    width: 435px;
    height: 25px;
    overflow: hidden;
    clear: both;
  }
  
  .zhw-top .zhw-form .hot-item-box {
    padding-left: 0;
  }
  
  .zhw-top .zhw-form .hot-item {
    display: inline-block;
    float: none;
    line-height: 25px;
    margin-top: 0;
    margin-right: 15px;
    cursor: pointer;
  }
  
  .zhw-top .zhw-form .hot-item i {
    margin-right: 4px;
  }
  
  .zhw-top .zhw-form .hot-item:hover .hot-icon {
    background-position: -51px -52px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word {
    width: 198px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word .se-focus-title {
    color: #fc3737;
    padding-left: 20px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word .hot-item {
    margin-top: 4px;
    margin-right: 0;
    margin-left: 20px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .se-focus-divider {
    width: 1px;
    background: #f0f0f0;
    position: absolute;
    top: 56px;
    bottom: 20px;
    left: 351px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .history-word {
    width: 220px;
    margin-left: 10px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle {
    width: 329px;
    min-height: 216px;
    padding-bottom: 10px;
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 0 0 3px 3px;
    border: 1px solid #fc3737;
    border-top: none;
    position: absolute;
    top: 46px;
    z-index: 99;
    background-color: #fff;
    height: auto !important;
    display: none;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 {
    top: 54px;
    width: 432px;
    padding-bottom: 10px;
    padding-top: 9px;
    padding-left: 10px;
    border: 1px solid #fc3737;
    width: 690px;
    right: 0;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .history-word {
    width: 314px;
    margin-left: 20px;
    margin-right: -32px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word {
    width: 338px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word .game-hot-wrap {
    width: 338px;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#ffefe5),
      to(hsla(0, 0%, 100%, 0))
    );
    background: -webkit-linear-gradient(top, #ffefe5, hsla(0, 0%, 100%, 0));
    background: -moz-linear-gradient(top, #ffefe5 0, hsla(0, 0%, 100%, 0) 100%);
    background: linear-gradient(180deg, #ffefe5, hsla(0, 0%, 100%, 0));
    border-radius: 4px;
    opacity: 0.86;
    border: 1px solid #ffecdf;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word .game-hot-wrap .se-focus-title {
    height: 18px;
    line-height: 18px;
    color: #7f322a;
    padding-left: 38px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAsZJREFUOE91lE1IFGEYx//PzOz6EUuXPHXKYA9hkCAKlWHsHoSCsI/VDd3MXGG7dKiIPETQB0GUUKig4iEE0UOLQh9EglEECmZSIexBukiEZtmm2+rM+8Q778zs+tELwwzzzvOb5z/P/z+EbRbHI2EILQKmKljabggCmOZh0gQEhmn4yevNZZR/g+P1QYC6IVBpF1s2QJ2FBgXUAAuTYCNByd6UW++BuLWhGoQhCAQ8iCx0Ae61BNvXlIaJenrW91bCbJDTyXgOIt8O4OBhHTVHfRgYWkPqq7C7UxB1WFoaEDX0vDelQK0NY2BXjiNBPngu5seRah9WVhnXbmWw9JtVh1Cd2pJpkl51h4hbImGQlszbUG+rrNLRdqEAREr+0xdrGHtvYukPY124EOe7cR1xS7QHTFGHrjZqaw2cOeV3pdug6S8mpj5bKC/TcacvC0t25UhkGiRuPjsDQaXeB66o0JFoK4TTiDfVj7MmVv4yDpX70D+SRfKNqaZqy5wjjjUuwkKBR79xvRCle/Qt9lpOC+wMSJmE+QWB+L2MA5Eys8SNTRtB/Z3FMIwN/toAlR1YgnH86qrtKeW3LHE0NgMBJU1u9HQUo6hQgT6lTOwPGh5IQuRa+CXQdDuT57E54kisB6xHPY9civtRecBnF9zsyuBycyECxWTLcNfIuzV0jq7n+WmQ+GQsDM1Iejd3lRDuXilCYAeh/XEG5ft0nA7JCar1/afAxUcZLK/mTQ11ypB1LWNgTeVLHiUlhKYTfnz7ITDwch3t5wtQtlfHxKyFrtE1LKY5l0NtkqYehBxQPAgL47AokAuo417p4s3R8AKtpWFyDc08VBGxuzrWWg3LcELrxsBJf36+VMYkPA3W6unD/VxoPVgoHoRmdMOSMv/XiT3ySVickJ24tdv6hWsSYbAegdCqYFHuxyZoAiYP03THlh/bP4iAXpqdN/fpAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-x: 14px;
    margin: 14px 0 20px;
    font-weight: 700;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item {
    width: 137px;
    height: 18px;
    line-height: 18px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 24px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #333;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 12px;
    cursor: pointer;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item
    .hot-word-mes {
    width: 106px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item
    .left-arrow {
    height: 13px;
    width: 13px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAALJJREFUKFNjZCADMOLSc+zouTsMjAzLrKyM6tDV4NR0/PiF6Qz//2cw/GOotrQxbEPWiFNTQ0MDk4d7wML///9H/2dgKLSyMpwI04hTE0jB/v37WTjY+VcyMDAGMjAypFlaGs4BiePVBFKwatVVNlmZXxsYGBjc/jMwxFlZGS4jqAmk8dixY0KMDJwPGBgY/ltaGfIT1ESyTch++vf/X7q1tfFsvH4iK/TIiieyUgS+JAkAgaZMDt+yRtcAAAAASUVORK5CYII=)
      no-repeat;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item-1 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAbBJREFUOE+tlL1rVEEUR8+dO7PPsEVgCdE0IgRErOwsLC0EqyBokdIka5V0i1XA0kILy91GbOxsBP8AS9OkEYkkIKlEUTFKzGb3zbsyk43xI8as7JTD3DO/Oe/eJ4xoyYg4HBtkbQIwLbdYO+zyI0G52LgcHdeBGQcvXJOrQ4Gsw5UIj4HGfqHAPW3SGgrU73BX4LYIZjZQINz0CzwcCtRrM++ELyJcMmMpFavjosyzMhRo/3DZ5gnCNcBUGZc5vv4XqN/htcBZgU1tcuZv7ZK/mt3B0SCwi6dA+YSnhjJGPdbZSK/CeK5bxQKlKQ4lonlXe++kxXsxEBapUeCZwFPh6eWe8XGCC1LwNMuOPNLP4UHaJ1oA71E8mKe7uyY5zUcCp9OBX0HVJDfMcz+LLllmKzw7AOFRvwcqY3kAOiRRdYplczQzqMss2yF19Z+JwB0JosG5qJxMPrQbXhIxYnq2+QxMiSoLuOrDnuw0CuvUfneUvVF4Skuj4gkDwM+OXPzGWH/1x6xlV+cRXiFMIbxFaCC8wTE+6Ow6QoVjB+EEglJKi+0U5tjT/6/fzchA3wH3Ro2iNB9aSQAAAABJRU5ErkJggg==)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item-2 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAidJREFUOE+91L9rk0EYB/Dv9+7eN0lFaWxCFScr2kEzlCoGHBTq0klBSrO4OOii2OI/oNC51kXETWyldlNBRAdBNDQuFX9A2kFwEH/E/jLa5E3eu0eSNlKkwQjFm+7gns/dPXfPEZvUuEkO/gqNTgUpWnSLuEK++C5789zB6kaLN4XG7vzopPInBK6vESiC947ov5SJzv2JNYcmy88BHCEoAimTjIoIBbg3nImebAkam6wcIiVXDxROLWv/dLtUvkMkQnDuYibS3RJ0bTI44MSdUlDOaT6gDSOgmq4Hk/eHBiMnWoLWTxq9tbKLvnpGoguAFbqjw4NtL/4JujpR7qLGYwB7AAigzg9l/OvNb+2yqP55eDYCs/wJWkVhjvWG+zvj9i6InSJwS0WOPMr64wrQyoMOBVopCBW+ZG/wKwFh/wX4dglmPgajyzDH0zad3G7HCWkHaBeK6sr0G/OwFlwJQFuFpoKBgwFhgiryRGM3a9DeJLalU0EeQNtGR5j9YM68yuvZ9RAUwlUoB88mYFwMJt0T9iTi9mmT0pEnLyN9C4sIGpAljCLUb+hjAsaLwRzeHSQTHUxVHbRYaGdhxFGHhBYH5ma8t9AwDUgAz2l8q7/s3rPidZTgN3IkCp4yMAxhqGGE8Gr9OlCDa+O1HFmNlfkYZtaViKiBAbBQAIv7wNIiWNkBJj9DVeKrxV0tgVs9qDAAwy1gtYTw9W3+rL/T//aNtLrQL0hQ2+b3mniSAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item-3 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAiRJREFUOE+t0jFME1Ecx/Hv/9072lIQiAQcXNCCgyFKGFgcWDuYuJC4GAYSaeKkMRJkcTEGGRyFuLk4aOLk4mZMxEjQSAzU6IAoUbFRgUJb7u49cteComAk6Vtuuf/n/X//9xeqdKRKDv+ELAijg92IbQNnifXcpFy7v7Hb5XtC9sZACqUfgJzYLrT2E1qdkcu3p//E9oZGMy+BrnKBXUOkFhslmJGh8V94RdwVsmOZFox9hhWLss9Zn+gnMTgNchIwMjTu/HdHUR9j55JQdxQ/OIbIXUTiwAsZGu/ZJ5Q5i+Eegq3EeovY03Jl4t3+oJuZ61iuhs0RviDM4Sa65dKtwq6QBUU65dJcqym6ei1Zn0ga5eAXNS6aI+0DxBPDYbFZWb6gsrNP8BwHCWfofZWHM0sS7Uo6VUNQq2lwNW3t7RxsnIpu9INHpcmpi7GerhFqYv1hRPP957CZyz7VVjSOaMKvTzaEFOm0S7BYhuKxGMc7XyNyqBzJ5kHqy1tgcryZ7fNX8xu/Q75Y/2/IdzSdHb0k6+4ATREQDtuY+eDL5xFn4eN7P8DdARmrKlDK3Y4WQiXrcripkdaWU6AOUCwssvAhS8EoT+GK9fUW5BtcLeSihbTnu13mvZoo2hYUVxpT0hilcXAxlXloX+/oSFinsPJqe7OjWfUhfOsVOlaFHwUhvyHUFRXF1vJ/jZ7klkuq2QsEr0FQni+PZ9bK6at0qgZtAvQk1FkMT12oAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item-4 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAP9JREFUOE/N07FKxEAQgOF/dsX2wNIHUKwUO7G/ys5KloUggg8gliJccT6CYCGb3UKI11la6QvYXadi5SMkTRixkxC4JB7i1DMfszM7wpJCluTwt1Ce5yciMrLWzpxzH22vWNhRSulQVWffxSIy9t4/9oaKohiVZTkXkfVfQTHGa+AYeAc2B3UUQtg3xjwDU2AHOOgNFUWxWlXVC7BS1/W2tfZ+EJRSulDVCXAJPAFXwJ6InAF33vvP5sBbtxZjnANbrdsROfXe33SCQghjY8zaj+RzYFdVp6p6m2XZayeomRRjfBg0oyaUUjoCNowxyTn31vtD9jnohSfSFft/0BdnwlMTbIno8AAAAABJRU5ErkJggg==)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item-5 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAUdJREFUOE/NlD9Lw1AUxc9JWsoTXB1cigoiDuLm5J/NSScpSJvXxI/gJ8hHcA2IyWu2LjoLgkPB0UEcRETs3EUQEsTkSsGClFZSaME73/PjnHvfu8SUilPiYPYgY8wRyepvxyTfHcc5H5VirCNjzD3JzSHRq9Z6eSJQq9XqiUgK4GAgFJFP13UfC4OCIJhTSn2Q7DiOs+v7vu37/tdfixkZzRizSvIJQI9kOc/zecuyOlmWnbiu+1LYURiGa7Ztx30ByUsR2QGwD6Cjtd4uDBpubLfbdpIkXZKLIlJtNpvd4Z6R0aIoWiG5VCqVnuv1+ltfNNiiZVkbjUbjoRAojmNPRC5E5CZN00Ol1DqAO5JppVJZqNVqSSFQEARlpdQ1gD0AGQAbgAA41VqfTTSjn7kcA9jqw/I8v/I873bcE5j9X5v0Kvw/R9/RxW8TgfBRQwAAAABJRU5ErkJggg==)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item-6 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAVJJREFUOE+906FLQ0EAgPHv3oMZFlwVk0GbwSBoFGFWg0U271hx2sSiaBNBwSAMUTRt917zHzBZhqAWZdjEIBhEEOPh9O7kiRZ5g03GLl24+/HdHSfo0hBdcugdFMfxqHMu771/V0odtDpBy6JKpdKXy+VOgAX4Lr+SUk50DGmtj4FFoB6G4Za1tiGlfOkI0loPAffAQ7PZnMxkMv3GmKdyufzREVStVpeDIDgEboAEzQHPQRDMFYvFizQs9Y5qtdquEGINeBNCVJxzI0KIeeDRGDOcVpYKaa33gRVgVUqZzImiqOG9Hw3DcKxQKNz+rWoFbQLbwIaUcifZpLU+A2aAaSnleVtQHMfjzrlr4M4YM5XNZgestZdACAwqpV7bgn4KjoAl770TQiTl3nu/rpTaa/uyfxdGUTTrvc8Dn9ba01KpVO/o+f/zkXv3adut61rRF72qfBNM9wWNAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item-7 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAQdJREFUOE+10zFKxEAUBuB/XkIsthQrYZG0C7Kd4AFsrWPCiwFrT7BILPYAHkDIe6J30M5qwcZGtLCysfAENpkRCxtJsuMQp52Zb/4Z/jEYaZiRHPwvpKrHADZ70l4x88fvuc5EqvoEYNYFEdGsKIpnL0hEptbajZ/FcRxvOefuAbww827XAV5vpKrnAM4AnDDzZRCkqhMAbwBs27bTqqo+Q6FTABcAlsy86KvL4NXquo7TNH11zm0nSbKTZdl7EKSqRwCuAdwwcz5U3sFEIvJojJlHUbSX5/lDENQ0zQER3QJYMfP+uq/Um0hEDolobq29K8tyFQyt2+jV7L8i3+u9mu0DjwZ9AWtQRxPStBDVAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item-8 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAWdJREFUOE+1kyFIQ1EUhv//vluVCVq0CGuCIhgEQRCbwWJxjHfvbAti0KwylIHFYrCNcXlj2BSDCIaJwWJScHFhaDNsxZXtHRmIDHnCm2y3XTj/x3fOvYcY0OGAOBg+qFKp6Hq9nlJKzYlIUyl16ft+9a8OIo1yuZxOJpN3IrLSE+yQ3DDGXEfBIkGlUmktDMMbAC8isup5XvceAHi21s7HBjnnNklekCwZY4xzborkG4CatTYZG1QsFhNKqVeSoyKSJ7kEYB3AvrU2HxvULXTO7ZA86wnVtNaL6XT6IzYoCIJlEakAqIZhuKuUWiB5IiIP1treB/hhRg47CIJTEdlTSm37vn/+bfhOclJrPRFlFQlyzh2QPAJw1Wg0UolEYhbAIwBptVpj2Wz283d7kaByuTzebrefAEwD6ADwukEROcxkMsexZ9QtLBQKI1rrLZIzJJsAbo0x93397P8s8vCXtl+rgRl9AdglexOGgZbVAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list
    .game-hot-item-9 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAUlJREFUOE/NlDFLA0EUhGcuCxEFC8VCtMm1Ymkh+Q0WggY8sntYnWCV1up6sbOykOzmbERBO3+AlaWlJLUYtBMjBvLkIILinVwgAafe+ZhZ3nvEmMQxcTB5kIiw1WrtAFgD8KiUskEQPOU1yEw0hFwD2Phm7JKsaq3bWbBMkHMuAHAG4FYptdnv9w3JIwCXxpitwiBr7SnJXc/zdL1eT+I4Vr7vvwF4N8bMFgY5544B7JOMtNYnqdE59wxgvtfrzURRlEJ/KK/aNoBzAG0RaQBYJ3lAUsrl8lStVvsoBBp+tgWgU4OIdEj6AF6MMQuFq309bDabK6VSaU5EpgHciMhFGIZp2l/KHcg4jr1KpbKc1gJwSHJRRKphGN6NBEqSZHUwGNwPTa8k97TW6UhkKjeRtXaJZIPkg4hcGWO6f+3l5Hdt1Kvw/xJ9AkDbbxNLOHTIAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list-left {
    padding: 0 18px 0 14px;
    border-right: 1px solid #f0f0f0;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .game-hot-wrap
    .game-hot-box
    .game-hot-list-right {
    padding-left: 17px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word .all-hot-wrap {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    width: 338px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word .all-hot-wrap .all-hot-item-box {
    width: 165px;
    height: 204px;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#ffefe5),
      to(hsla(0, 0%, 100%, 0))
    );
    background: -webkit-linear-gradient(top, #ffefe5, hsla(0, 0%, 100%, 0));
    background: -moz-linear-gradient(top, #ffefe5 0, hsla(0, 0%, 100%, 0) 100%);
    background: linear-gradient(180deg, #ffefe5, hsla(0, 0%, 100%, 0));
    border-radius: 4px;
    opacity: 0.86;
    border: 1px solid #ffecdf;
    margin-bottom: 8px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .se-focus-title {
    height: 18px;
    line-height: 18px;
    color: #7f322a;
    padding-left: 38px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAsZJREFUOE91lE1IFGEYx//PzOz6EUuXPHXKYA9hkCAKlWHsHoSCsI/VDd3MXGG7dKiIPETQB0GUUKig4iEE0UOLQh9EglEECmZSIexBukiEZtmm2+rM+8Q778zs+tELwwzzzvOb5z/P/z+EbRbHI2EILQKmKljabggCmOZh0gQEhmn4yevNZZR/g+P1QYC6IVBpF1s2QJ2FBgXUAAuTYCNByd6UW++BuLWhGoQhCAQ8iCx0Ae61BNvXlIaJenrW91bCbJDTyXgOIt8O4OBhHTVHfRgYWkPqq7C7UxB1WFoaEDX0vDelQK0NY2BXjiNBPngu5seRah9WVhnXbmWw9JtVh1Cd2pJpkl51h4hbImGQlszbUG+rrNLRdqEAREr+0xdrGHtvYukPY124EOe7cR1xS7QHTFGHrjZqaw2cOeV3pdug6S8mpj5bKC/TcacvC0t25UhkGiRuPjsDQaXeB66o0JFoK4TTiDfVj7MmVv4yDpX70D+SRfKNqaZqy5wjjjUuwkKBR79xvRCle/Qt9lpOC+wMSJmE+QWB+L2MA5Eys8SNTRtB/Z3FMIwN/toAlR1YgnH86qrtKeW3LHE0NgMBJU1u9HQUo6hQgT6lTOwPGh5IQuRa+CXQdDuT57E54kisB6xHPY9civtRecBnF9zsyuBycyECxWTLcNfIuzV0jq7n+WmQ+GQsDM1Iejd3lRDuXilCYAeh/XEG5ft0nA7JCar1/afAxUcZLK/mTQ11ypB1LWNgTeVLHiUlhKYTfnz7ITDwch3t5wtQtlfHxKyFrtE1LKY5l0NtkqYehBxQPAgL47AokAuo417p4s3R8AKtpWFyDc08VBGxuzrWWg3LcELrxsBJf36+VMYkPA3W6unD/VxoPVgoHoRmdMOSMv/XiT3ySVickJ24tdv6hWsSYbAegdCqYFHuxyZoAiYP03THlh/bP4iAXpqdN/fpAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-x: 14px;
    margin: 14px 0 20px;
    font-weight: 700;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item {
    width: 137px;
    height: 18px;
    line-height: 18px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 24px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #333;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 auto 12px;
    cursor: pointer;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item
    .hot-word-mes {
    width: 106px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item
    .left-arrow {
    height: 13px;
    width: 13px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAALJJREFUKFNjZCADMOLSc+zouTsMjAzLrKyM6tDV4NR0/PiF6Qz//2cw/GOotrQxbEPWiFNTQ0MDk4d7wML///9H/2dgKLSyMpwI04hTE0jB/v37WTjY+VcyMDAGMjAypFlaGs4BiePVBFKwatVVNlmZXxsYGBjc/jMwxFlZGS4jqAmk8dixY0KMDJwPGBgY/ltaGfIT1ESyTch++vf/X7q1tfFsvH4iK/TIiieyUgS+JAkAgaZMDt+yRtcAAAAASUVORK5CYII=)
      no-repeat;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item-1 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAbBJREFUOE+tlL1rVEEUR8+dO7PPsEVgCdE0IgRErOwsLC0EqyBokdIka5V0i1XA0kILy91GbOxsBP8AS9OkEYkkIKlEUTFKzGb3zbsyk43xI8as7JTD3DO/Oe/eJ4xoyYg4HBtkbQIwLbdYO+zyI0G52LgcHdeBGQcvXJOrQ4Gsw5UIj4HGfqHAPW3SGgrU73BX4LYIZjZQINz0CzwcCtRrM++ELyJcMmMpFavjosyzMhRo/3DZ5gnCNcBUGZc5vv4XqN/htcBZgU1tcuZv7ZK/mt3B0SCwi6dA+YSnhjJGPdbZSK/CeK5bxQKlKQ4lonlXe++kxXsxEBapUeCZwFPh6eWe8XGCC1LwNMuOPNLP4UHaJ1oA71E8mKe7uyY5zUcCp9OBX0HVJDfMcz+LLllmKzw7AOFRvwcqY3kAOiRRdYplczQzqMss2yF19Z+JwB0JosG5qJxMPrQbXhIxYnq2+QxMiSoLuOrDnuw0CuvUfneUvVF4Skuj4gkDwM+OXPzGWH/1x6xlV+cRXiFMIbxFaCC8wTE+6Ow6QoVjB+EEglJKi+0U5tjT/6/fzchA3wH3Ro2iNB9aSQAAAABJRU5ErkJggg==)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item-2 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAidJREFUOE+91L9rk0EYB/Dv9+7eN0lFaWxCFScr2kEzlCoGHBTq0klBSrO4OOii2OI/oNC51kXETWyldlNBRAdBNDQuFX9A2kFwEH/E/jLa5E3eu0eSNlKkwQjFm+7gns/dPXfPEZvUuEkO/gqNTgUpWnSLuEK++C5789zB6kaLN4XG7vzopPInBK6vESiC947ov5SJzv2JNYcmy88BHCEoAimTjIoIBbg3nImebAkam6wcIiVXDxROLWv/dLtUvkMkQnDuYibS3RJ0bTI44MSdUlDOaT6gDSOgmq4Hk/eHBiMnWoLWTxq9tbKLvnpGoguAFbqjw4NtL/4JujpR7qLGYwB7AAigzg9l/OvNb+2yqP55eDYCs/wJWkVhjvWG+zvj9i6InSJwS0WOPMr64wrQyoMOBVopCBW+ZG/wKwFh/wX4dglmPgajyzDH0zad3G7HCWkHaBeK6sr0G/OwFlwJQFuFpoKBgwFhgiryRGM3a9DeJLalU0EeQNtGR5j9YM68yuvZ9RAUwlUoB88mYFwMJt0T9iTi9mmT0pEnLyN9C4sIGpAljCLUb+hjAsaLwRzeHSQTHUxVHbRYaGdhxFGHhBYH5ma8t9AwDUgAz2l8q7/s3rPidZTgN3IkCp4yMAxhqGGE8Gr9OlCDa+O1HFmNlfkYZtaViKiBAbBQAIv7wNIiWNkBJj9DVeKrxV0tgVs9qDAAwy1gtYTw9W3+rL/T//aNtLrQL0hQ2+b3mniSAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item-3 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAiRJREFUOE+t0jFME1Ecx/Hv/9072lIQiAQcXNCCgyFKGFgcWDuYuJC4GAYSaeKkMRJkcTEGGRyFuLk4aOLk4mZMxEjQSAzU6IAoUbFRgUJb7u49cteComAk6Vtuuf/n/X//9xeqdKRKDv+ELAijg92IbQNnifXcpFy7v7Hb5XtC9sZACqUfgJzYLrT2E1qdkcu3p//E9oZGMy+BrnKBXUOkFhslmJGh8V94RdwVsmOZFox9hhWLss9Zn+gnMTgNchIwMjTu/HdHUR9j55JQdxQ/OIbIXUTiwAsZGu/ZJ5Q5i+Eegq3EeovY03Jl4t3+oJuZ61iuhs0RviDM4Sa65dKtwq6QBUU65dJcqym6ei1Zn0ga5eAXNS6aI+0DxBPDYbFZWb6gsrNP8BwHCWfofZWHM0sS7Uo6VUNQq2lwNW3t7RxsnIpu9INHpcmpi7GerhFqYv1hRPP957CZyz7VVjSOaMKvTzaEFOm0S7BYhuKxGMc7XyNyqBzJ5kHqy1tgcryZ7fNX8xu/Q75Y/2/IdzSdHb0k6+4ATREQDtuY+eDL5xFn4eN7P8DdARmrKlDK3Y4WQiXrcripkdaWU6AOUCwssvAhS8EoT+GK9fUW5BtcLeSihbTnu13mvZoo2hYUVxpT0hilcXAxlXloX+/oSFinsPJqe7OjWfUhfOsVOlaFHwUhvyHUFRXF1vJ/jZ7klkuq2QsEr0FQni+PZ9bK6at0qgZtAvQk1FkMT12oAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item-4 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAP9JREFUOE/N07FKxEAQgOF/dsX2wNIHUKwUO7G/ys5KloUggg8gliJccT6CYCGb3UKI11la6QvYXadi5SMkTRixkxC4JB7i1DMfszM7wpJCluTwt1Ce5yciMrLWzpxzH22vWNhRSulQVWffxSIy9t4/9oaKohiVZTkXkfVfQTHGa+AYeAc2B3UUQtg3xjwDU2AHOOgNFUWxWlXVC7BS1/W2tfZ+EJRSulDVCXAJPAFXwJ6InAF33vvP5sBbtxZjnANbrdsROfXe33SCQghjY8zaj+RzYFdVp6p6m2XZayeomRRjfBg0oyaUUjoCNowxyTn31vtD9jnohSfSFft/0BdnwlMTbIno8AAAAABJRU5ErkJggg==)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item-5 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAUdJREFUOE/NlD9Lw1AUxc9JWsoTXB1cigoiDuLm5J/NSScpSJvXxI/gJ8hHcA2IyWu2LjoLgkPB0UEcRETs3EUQEsTkSsGClFZSaME73/PjnHvfu8SUilPiYPYgY8wRyepvxyTfHcc5H5VirCNjzD3JzSHRq9Z6eSJQq9XqiUgK4GAgFJFP13UfC4OCIJhTSn2Q7DiOs+v7vu37/tdfixkZzRizSvIJQI9kOc/zecuyOlmWnbiu+1LYURiGa7Ztx30ByUsR2QGwD6Cjtd4uDBpubLfbdpIkXZKLIlJtNpvd4Z6R0aIoWiG5VCqVnuv1+ltfNNiiZVkbjUbjoRAojmNPRC5E5CZN00Ol1DqAO5JppVJZqNVqSSFQEARlpdQ1gD0AGQAbgAA41VqfTTSjn7kcA9jqw/I8v/I873bcE5j9X5v0Kvw/R9/RxW8TgfBRQwAAAABJRU5ErkJggg==)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item-6 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAVJJREFUOE+906FLQ0EAgPHv3oMZFlwVk0GbwSBoFGFWg0U271hx2sSiaBNBwSAMUTRt917zHzBZhqAWZdjEIBhEEOPh9O7kiRZ5g03GLl24+/HdHSfo0hBdcugdFMfxqHMu771/V0odtDpBy6JKpdKXy+VOgAX4Lr+SUk50DGmtj4FFoB6G4Za1tiGlfOkI0loPAffAQ7PZnMxkMv3GmKdyufzREVStVpeDIDgEboAEzQHPQRDMFYvFizQs9Y5qtdquEGINeBNCVJxzI0KIeeDRGDOcVpYKaa33gRVgVUqZzImiqOG9Hw3DcKxQKNz+rWoFbQLbwIaUcifZpLU+A2aAaSnleVtQHMfjzrlr4M4YM5XNZgestZdACAwqpV7bgn4KjoAl770TQiTl3nu/rpTaa/uyfxdGUTTrvc8Dn9ba01KpVO/o+f/zkXv3adut61rRF72qfBNM9wWNAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item-7 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAQdJREFUOE+10zFKxEAUBuB/XkIsthQrYZG0C7Kd4AFsrWPCiwFrT7BILPYAHkDIe6J30M5qwcZGtLCysfAENpkRCxtJsuMQp52Zb/4Z/jEYaZiRHPwvpKrHADZ70l4x88fvuc5EqvoEYNYFEdGsKIpnL0hEptbajZ/FcRxvOefuAbww827XAV5vpKrnAM4AnDDzZRCkqhMAbwBs27bTqqo+Q6FTABcAlsy86KvL4NXquo7TNH11zm0nSbKTZdl7EKSqRwCuAdwwcz5U3sFEIvJojJlHUbSX5/lDENQ0zQER3QJYMfP+uq/Um0hEDolobq29K8tyFQyt2+jV7L8i3+u9mu0DjwZ9AWtQRxPStBDVAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item-8 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAWdJREFUOE+1kyFIQ1EUhv//vluVCVq0CGuCIhgEQRCbwWJxjHfvbAti0KwylIHFYrCNcXlj2BSDCIaJwWJScHFhaDNsxZXtHRmIDHnCm2y3XTj/x3fOvYcY0OGAOBg+qFKp6Hq9nlJKzYlIUyl16ft+9a8OIo1yuZxOJpN3IrLSE+yQ3DDGXEfBIkGlUmktDMMbAC8isup5XvceAHi21s7HBjnnNklekCwZY4xzborkG4CatTYZG1QsFhNKqVeSoyKSJ7kEYB3AvrU2HxvULXTO7ZA86wnVtNaL6XT6IzYoCIJlEakAqIZhuKuUWiB5IiIP1treB/hhRg47CIJTEdlTSm37vn/+bfhOclJrPRFlFQlyzh2QPAJw1Wg0UolEYhbAIwBptVpj2Wz283d7kaByuTzebrefAEwD6ADwukEROcxkMsexZ9QtLBQKI1rrLZIzJJsAbo0x93397P8s8vCXtl+rgRl9AdglexOGgZbVAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top
    .zhw-form
    .se-focus-toggle2
    .hot-word
    .all-hot-wrap
    .all-hot-item-box
    .game-hot-box
    .game-hot-item-9 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAUlJREFUOE/NlDFLA0EUhGcuCxEFC8VCtMm1Ymkh+Q0WggY8sntYnWCV1up6sbOykOzmbERBO3+AlaWlJLUYtBMjBvLkIILinVwgAafe+ZhZ3nvEmMQxcTB5kIiw1WrtAFgD8KiUskEQPOU1yEw0hFwD2Phm7JKsaq3bWbBMkHMuAHAG4FYptdnv9w3JIwCXxpitwiBr7SnJXc/zdL1eT+I4Vr7vvwF4N8bMFgY5544B7JOMtNYnqdE59wxgvtfrzURRlEJ/KK/aNoBzAG0RaQBYJ3lAUsrl8lStVvsoBBp+tgWgU4OIdEj6AF6MMQuFq309bDabK6VSaU5EpgHciMhFGIZp2l/KHcg4jr1KpbKc1gJwSHJRRKphGN6NBEqSZHUwGNwPTa8k97TW6UhkKjeRtXaJZIPkg4hcGWO6f+3l5Hdt1Kvw/xJ9AkDbbxNLOHTIAAAAAElFTkSuQmCC)
      no-repeat;
    background-position-y: 1px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word .hot-item-box {
    margin-left: 20px;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word .hot-item {
    display: block;
    float: none;
    line-height: 25px;
    margin-top: 5px;
    margin-right: 32px;
    cursor: pointer;
    display: inline-block;
  }
  
  .zhw-top .zhw-form .se-focus-toggle2 .hot-word .hot-item i {
    margin-right: 0;
    margin-left: 8px;
  }
  
  .zhw-top .zhw-form .se-focus-title {
    line-height: 32px;
    margin-top: 0;
    padding: 0 10px 0 0;
  }
  
  .zhw-top .zhw-form .history-item-box {
    padding-top: 5px;
    padding-left: 0;
    color: #a8a8a8;
  }
  
  .zhw-top .zhw-form .history-item {
    margin-right: 0;
    margin-top: 4px;
    display: block;
    float: none;
    line-height: 25px;
    padding: 0 10px;
    position: relative;
    height: 25px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  
  .zhw-top .zhw-form .history-item.current {
    background: #f1f1f1;
    font-weight: 700;
    color: #656565;
  }
  
  .zhw-top .zhw-form .history-item:hover {
    background: #f1f1f1;
    font-weight: 700;
  }
  
  .zhw-top .zhw-form .history-item:hover i {
    display: block;
  }
  
  .zhw-top .zhw-form .history-item i {
    display: none;
    top: 4px;
  }
  
  .zhw-top .zhw-form .history-item b {
    font-weight: 700;
    color: #fc3737;
  }
  
  .zhw-top .zhw-form .history-item .history-del-icon {
    right: 0;
  }
  
  .zhw-top .zhw-form .history-item:hover {
    background: initial;
  }
  
  .zhw-top .zhw-form .history-del-icon {
    right: 13px;
    top: 9px;
  }
  
  .zhw-top .index-search {
    float: left;
    width: 328px;
    height: 42px;
    border: 2px solid #fc3737;
    position: relative;
  }
  
  .zhw-top .index-search-btn {
    float: left;
  }
  
  .zhw-top .se-lease {
    font-size: 14px;
    font-weight: 600;
    color: #fc3737;
    line-height: 42px;
    width: 112px;
    border-right: 2px solid #fc3737;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  
  .zhw-top .se-lease-toggle {
    width: 112px;
    position: absolute;
    top: 42px;
    z-index: 99;
  }
  
  .zhw-top .se-election-game,
  .zhw-top .se-election-region,
  .zhw-top .se-election-server {
    color: #aaa;
    margin-left: 24px;
    line-height: 42px;
    cursor: pointer;
    overflow: hidden;
  }
  
  .zhw-top .se-election-region,
  .zhw-top .se-election-server {
    float: left;
    max-width: 106px;
    text-align: right;
    margin-left: 32px;
  }
  
  .zhw-top .se-election .game_text.game_text_onsel span {
    color: #ff5b5b;
  }
  
  .zhw-top .zhw-search-server {
    max-width: 92px;
    margin-left: 0;
  }
  
  .zhw-top .zhw-search-game {
    float: left;
    max-width: 156px;
    text-align: right;
  }
  
  .zhw-top .zhw-search-region {
    float: left;
    max-width: 92px;
    text-align: right;
  }
  
  .zhw-top .fr.act_color .zhw-search-game,
  .zhw-top .fr.act_color .zhw-search-region,
  .zhw-top .fr.act_color .zhw-search-server {
    color: #606060;
  }
  
  .zhw-top .zhw-se-val::-webkit-input-placeholder {
    color: #aaa;
  }
  
  .zhw-top .zhw-se-val {
    border: none;
    margin: 5px 14px;
    width: 300px;
    display: block;
    height: 32px;
    padding-left: 4px;
    font-size: 12px;
    font-weight: 400;
  }
  
  .zhw-top .input-placeholder,
  .zhw-top .zhw-se-val {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .zhw-top .input-placeholder {
    width: 159px;
    height: 42px;
    line-height: 40px;
    overflow: hidden;
    position: absolute;
    right: 0;
    padding-left: 12px;
    padding-right: 12px;
    background-color: #fff;
    display: none;
  }
  
  .zhw-top .input-placeholder-other {
    position: absolute;
    left: 0;
    top: 0;
    width: 328px;
    padding-left: 18px;
  }
  
  .zhw-top .placeholder-box {
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-transform: translateY(0);
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
  
  .zhw-top .placeholder-item {
    color: #aaa;
    height: 42px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
  }
  
  .zhw-top .zhw-se-btn {
    width: 102px;
    height: 46px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    line-height: 17px;
    background-color: #fc3737;
    border: none;
    cursor: pointer;
    letter-spacing: 4px;
  }
  
  .zhw-top .se-focus-flex {
    width: 50%;
  }
  
  .zhw-top .se-focus-title {
    padding: 20px 20px 0;
    font-size: 14px;
    font-weight: 700;
    position: relative;
    color: grey;
  }
  
  .zhw-top .history-item-box,
  .zhw-top .hot-item-box {
    padding-left: 20px;
  }
  
  .zhw-top .hot-item {
    color: #fc9191;
    color: #ed9694;
    font-size: 12px;
    margin-top: 24px;
    margin-right: 32px;
    float: left;
  }
  
  .zhw-top .hot-item:hover {
    color: #fc3737;
    font-weight: 700;
    color: #e84a42;
  }
  
  .zhw-top .history-item {
    margin-top: 24px;
    margin-right: 32px;
    font-size: 12px;
    float: left;
    color: #a8a8a8;
    cursor: pointer;
  }
  
  .zhw-top .history-item:hover {
    color: #656565;
  }
  
  .zhw-top .history-del-icon:hover {
    background-position: -94px -49px;
  }
  
  .zhw-top .se-flex-line {
    width: 1px;
    height: 160px;
    background: #f0f0f0;
    position: absolute;
    left: 50%;
    top: 42px;
  }
  
  .zhw-top .se-election-box {
    position: absolute;
    top: 50px;
    left: -2px;
    width: 690px;
    display: none;
    min-height: 224px;
    overflow: hidden;
    white-space: nowrap;
    z-index: 100;
  }
  
  .zhw-top .se-election-drawer {
    border: 1px solid #df3234;
    padding-bottom: 32px;
    min-height: 224px;
    background-color: #fff;
  }
  
  .zhw-top .se-election-letter {
    padding: 10px 0;
  }
  
  .zhw-top .se-election-letter ul li {
    float: left;
    font-size: 12px;
    margin: 0 3px;
    width: 17px;
    height: 17px;
    cursor: pointer;
    text-align: center;
    line-height: 17px;
    color: #8f8f8f;
    border-radius: 2px;
  }
  
  .zhw-top .se-election-letter ul .se-election-hot {
    width: 25px;
    border-right: 1px solid #dbdbdb;
    padding: 0 15px;
    margin: 0 13px 0 8px;
    color: #8f8f8f;
  }
  
  .zhw-top .se-election-letter ul li:hover {
    color: #fc3737;
    background-color: #ffe5e5;
  }
  
  .zhw-top .se-election-letter ul .active {
    background: #fc3737;
    border-radius: 2px;
    color: #fff;
  }
  
  .zhw-top .se-election-letter ul .se-election-hot.active {
    background: none;
    color: #fc3737;
  }
  
  .zhw-top .se-election-letter ul .active:hover {
    background: #fc3737;
    border-radius: 2px;
    color: #fff;
  }
  
  .zhw-top .se-election-letter ul .se-election-hot:hover {
    color: #fc3737;
    background-color: #fff;
  }
  
  .zhw-top .lastaccount:hover {
    color: #fc3737;
  }
  
  .zhw-top .election-drawer-data {
    margin-left: 16px;
    margin-top: 16px;
  }
  
  .zhw-top .election-drawer-data ul li {
    width: 134px;
    float: left;
    font-size: 12px;
    margin-bottom: 19px;
    color: #656565;
    cursor: pointer;
    line-height: 16px;
    text-align: left;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-right: 18px;
  }
  
  .zhw-top .election-drawer-data ul .election-drawer-hot,
  .zhw-top .election-drawer-data ul li:hover {
    color: #fc3737;
  }
  
  .zhw-top .drawer-new-icon {
    background: url(data:image/gif;base64,R0lGODlhFQANAPQAAP///1a3AGa8AHTIAE6lAGvAAHDFAGm+AHLGAG7CAFGqAFSxAFa1AFeuAIC+SEyhAFWzAFOvAFKsAE2jAE+oAILKQlWrAGO6AEufAP///wAAAAAAAAAAAAAAAAAAAAAAACH5BAUyABkAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAFQANAAAFZmAmjmRpVkGqruxaMUMsz/TMQAiA7Drg+7mgDrIw+AzGJBIJSDYXkQRASv35qtSIpAAocLtdrxfMLUgUB8Bhrbaq0/CDgiKo2+/4O8VB6DcuDX2Cg4MOJBMWEyaLJQ8PjJAiGJEmIQAh+QQJFAAZACwAAAkAFQAEAAAFDGAmjmRpnmiqrqwZAgAh+QQJFAAZACwAAAAAFQANAAAFZWAVjGRplhUzrGzrtgyEAEhNAzg+7zS0GDgDcCgUAobHRSQBYDpzuKczIikACtbrFYvVWgsSxQFwKJOh5LH6oKAI3vC4PE5xEO6NS+PO7/cdGYEZExYTgoeIiQ8PiY2JGI6RkpIhACH5BAkUABkALAAAAAAVAA0AAAVmYCaOZGlWQaqu7FoxQyzP9MxACIDsOuD7uaAOsjD4DMYkEglINheRBEBK/fmq1IikAChwu12vF8wtSBQHwGGttqrT8IOCIqjb7/g7xUHoNy4NfYKDgw4kExYTJoslDw+MkCIYkSYhACH5BAUUABkALAAAAAAVAA0AAAVlYBWMZGmWFTOsbOu2DIQASE0DOD7vNLQYOANwKBQChsdFJAFgOnO4pzMiKQAK1usVi9VaCxLFAXAok6HksfqgoAje8Lg8TnEQ7o1L487v9x0ZgRkTFhOCh4iJDw+JjYkYjpGSkiEAOw==)
      no-repeat 0 0;
    display: inline-block;
    width: 21px;
    height: 13px;
  }
  
  .zhw-top .lastaccount {
    font-size: 12px;
    font-family: SimSun;
    font-weight: 400;
    color: #bfbfbf;
    line-height: 18px;
    display: inline-block;
    text-align: center;
    margin-top: 12px;
  }
  
  .zhw-top .hot-type-select {
    padding: 20px 0 20px 22px;
  }
  
  .zhw-top .hot-type-select .a-text {
    font-size: 14px;
    color: #6f6e6e;
    line-height: 31px;
  }
  
  .zhw-top .empty-data {
    width: 100% !important;
    text-align: center !important;
    pointer-events: none;
    cursor: default !important;
  }
  
  .zhw-top .zhw-menu {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  
  .zhw-top .zhw-nav li {
    float: left;
    margin: 0 20px;
    position: relative;
  }
  
  .zhw-top .zhw-nav li:after {
    content: "";
    width: 0;
    height: 2px;
    position: absolute;
    bottom: 4px;
    background-color: #fff;
    left: 50%;
    margin-left: -14px;
    -webkit-transition: width 0.3s ease-out, background-color 0.3s ease-out;
    -moz-transition: width 0.3s ease-out, background-color 0.3s ease-out;
    transition: width 0.3s ease-out, background-color 0.3s ease-out;
  }
  
  .zhw-top .zhw-nav li.current:after,
  .zhw-top .zhw-nav li:hover:after {
    content: "";
    width: 28px;
    background-color: #fc3737;
  }
  
  .zhw-top .zhw-nav li a {
    color: #636262;
    font-size: 14px;
    padding: 8px 0 4px;
    margin-bottom: 4px;
    display: block;
    border-bottom: 2px solid #fff;
  }
  
  .zhw-top .zhw-nav li.current a,
  .zhw-top .zhw-nav li:hover a {
    font-weight: 700;
    color: #000;
  }
  
  .zhw-top .home-nav-box {
    overflow: hidden;
    margin-left: 210px;
    padding-left: 5px;
  }
  
  .zhw-top .home-download-btn {
    font-size: 14px;
    font-weight: 700;
    color: #fc3737;
    position: absolute;
    right: 0;
    top: 8px;
  }
  
  .zhw-top .s-head-icon {
    -webkit-animation: hot_icon 1s linear infinite alternate;
    -moz-animation: hot_icon 1s linear infinite alternate;
    animation: hot_icon 1s linear infinite alternate;
  }
  
  .zhw-top .s-hot-icon {
    width: 27px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAOCAYAAADez2d9AAACl0lEQVQ4T5WUTUgVURiGn7lSaKBpiF4TU0PTiqBs0VLsRwmMFhZu2t8gi34giH6IKCMi0tyEC0sDJcIIitBFpItWLYKUsDBFi+5VggjBq3fmnBNnzp3rzPWnGhhmzpnhPOf9vve8Fr5L3c8vIss6jaARKSuxnUxEApxFcCTYgOO79VjfIvnU37x/9Jwe66cgRoiI5bFU59YmMhJdOIs57k9SLx4HocBOgBB/h/k3YyABoAtT3SXNCHoRIoS0DUDYYCff02F+NWspC8Kw1JPtRcj5MaSTg6MhCgPUML27VcqosmFh7l/L6Kq0VE9xKzJ0CSVxYbsvQ3QMpnrBmYfsBqg+CG9bIFQBjQ8gvwp+zUBBGfSdg9GncHIY8gqguBy+T0J0Gu40+MuolW35iFC7UrA912BmHCYegWNDbgNU1hrY4X6YnYKh82aRrJ1wZhDuHoCfn81cWwwi4fR+ecpK40iZidQllFBzFWJfg7CKWhhqgVMxuBdeMoouc90ts6nX1818+wow13BuGcsV0iEAqzxmHKgvKwSf+mG4FZpfQVdNsE97L8CmQnh+cXVlBrZgqZ5S5drc65lXxvHHxiR59UtljHyDtpKls6aV7L8JiwkYuLEc5rlRwxQjBqa064SvjBMw0QW2A7n1sC3Zs+Nv4P0LGOkwC2dshrPvoP0IzI6urczi9nJlumfRLzDZY2Ab66Aq6cYN+6Cp0zjx9w/YcQieXYEP2kzJA+wZRPrSRTBHnKokzMLtmzZI6lDr5NBzK5yzddWwvhBiw8H+pSeIiSuJ4oQ1QJ+lusuiKMIpmHeoXZB2aCIYV+k56I29nPQUmriawyaiQa7XVHfZURQPkU7YVbYS7H+CWLBAgnEEL4nTYQ0S9fL3D+ic3o/Vq3E0AAAAAElFTkSuQmCC)
      no-repeat;
  }
  
  .zhw-top .s-hot-icon,
  .zhw-top .s-new-icon {
    position: absolute;
    height: 14px;
    top: -2px;
    right: -28px;
    z-index: 1;
  }
  
  .zhw-top .s-new-icon {
    width: 28px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAOCAYAAAA8E3wEAAAAAXNSR0IArs4c6QAAAx5JREFUOE+NlVtsTFEUhr+jMRQNaVwqEbcoZdwiLg+lo6YSinry0ER5QBDq+iARSasXM1JC4h6VugsaERKhrUszNFpBm1TjgaDiFm3Qdtqqnr3ZZ5+ZTifTxHk5Z6+z1vr2Wmev/xiEXTLH60SItQixECFHImQMQoIpsO7Ws30XykaEdyLEp7u/EeDJ7GwHjj4HMeVGTBmFShZMHBJk2XqCh/uFbMzOZQE1rO8dhHRHrqSnCv/THtIVDfTsP4KQmxk7BoYNg0eP7dYJGDoE4uLgWTUkxEP8WJDy3y6BymqIGaB9X9bpyqOjYZkbLt6CTrsTacngewFfGzGk1+tEUmO1MWkezJ4Jd0rgebVuacJ4mDoJLhTDIrcG1KjkEuo/w4jh4E6E/ae0bc50WJ8Oew7Dm3pwOOB0DqzaDe0dFvAQptxmObuSoFcUTJoAJ4vgVzNMnABTbOBiN7S0Qpmv6/A4ekPBbtiWC62/YUM69O8HdW/hRhlMT4BUF2Qds2IM6fHWYkpnEOj3w59OGD0KLhXDRFWhE84XQ6ob+kXDi1oNfPNeQ3asgbs+qHkNBbvg+BVYsQiyjkJGGjT8hJsPVUyzIfd5mzCFPvrzk3QFFVWwJgPKK/S3muaEc9c1MH4MfPyi7bfK4EcTpCRC7CCoeAlpC+BAERzPgk15kLcFDp6DD1/UCL0yZL5HBo9/sg18/BRiY2F1OpSWQ8I4OHsNUlPA3woldksDczhkMGRmQGWN3kDJE9i6Cp7VQvoSWJtlj5g4bMhcjwzOVbJLV6iAKplrLsyYCp++auCSFGjxQ6mva0YDs6pa2d4BBWfgWyO4ZsGyZHj9Do5cVv4mHeY0Q+bu66pwgQL6waeAqmcGbFkH3xqg6CosXQiJs6CtTetFeRXcfqB9Vy6HyeNhu1evB8ZAYQ54CuFJtbIdNe6dzDRkjgLaEhWuLoF1qOKEy1y41AV8u8WI+9Q3php11zsMuTe/q8JgsD2w3aQtgs3S1p51EyFNTE7w4ftOBVNNMWR2XgRgQBMjaWaInHWvwv6uNCNEPUKWAoXG7WOvQv8PfwEyU1yUop4c4wAAAABJRU5ErkJggg==)
      no-repeat;
  }
  
  .zhw-top .s-free-icon {
    position: absolute;
    width: 51px;
    height: 18px;
    top: -2px;
    right: -52px;
    z-index: 1;
    background: url(data:image/png;base64,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)
      no-repeat;
    -webkit-animation-delay: 0.2s;
    -moz-animation-delay: 0.2s;
    animation-delay: 0.2s;
  }
  
  @-webkit-keyframes hot_icon {
    0%,
    to {
      top: 0;
    }
  
    50% {
      top: 10%;
    }
  }
  
  @-moz-keyframes hot_icon {
    0%,
    to {
      top: 0;
    }
  
    50% {
      top: 10%;
    }
  }
  
  @keyframes hot_icon {
    0%,
    to {
      top: 0;
    }
  
    50% {
      top: 10%;
    }
  }
  
  .vipcard-modal {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: none;
  }
  
  .vipcard-modal iframe {
    margin-top: -50px;
    left: 50%;
    position: absolute;
    margin-left: -544px;
  }
  
  .vipcard-modal .vipcard-modal-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  
  .zhw-game-sidebar {
    width: 200px;
    height: 40px;
    margin-right: 10px;
    background-color: #fff;
    position: absolute;
    left: 0;
    top: -3px;
    z-index: 100;
    overflow: hidden;
    border: 1px solid #f0f0f0;
    border-top: none;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .zhw-game-sidebar.show {
    height: 433px;
    overflow: visible;
    border: none;
  }
  
  .zhw-game-sidebar.show .side-hot-text {
    text-indent: 0;
  }
  
  .zhw-game-sidebar .side-hot-text {
    line-height: 40px;
    font-size: 16px;
    color: #fff;
    font-weight: 700;
    float: left;
    text-indent: 20px;
  }
  
  .zhw-game-sidebar .side-hot-title {
    cursor: pointer;
    height: 40px;
    background-color: #fc3737;
    position: relative;
  }
  
  .zhw-game-sidebar .side-hot-title .side-hot-toggle {
    top: 0;
  }
  
  .zhw-game-sidebar .side-hot-title.cur .side-hot-toggle {
    display: block;
  }
  
  .zhw-game-sidebar .side-hot-toggle {
    position: absolute;
    left: 200px;
    z-index: 100;
    top: 40px;
    display: none;
    cursor: default;
    padding-left: 10px;
  }
  
  .zhw-game-sidebar .side-list {
    display: none;
  }
  
  .zhw-game-sidebar .side-hot-box {
    height: 434px;
  }
  
  .zhw-game-sidebar .pre-drawer-box,
  .zhw-game-sidebar .side-hot-box {
    width: 720px;
    background-color: #fff;
    border: 1px solid #ebebeb;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .zhw-game-sidebar .pre-drawer-box {
    height: 380px;
    margin-top: 13px;
    padding-bottom: 15px;
    overflow: hidden;
    cursor: default;
  }
  
  .zhw-game-sidebar .side-hot-name {
    padding: 24px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    color: #303030;
  }
  
  .zhw-game-sidebar .side-hot-toggle .home-to-more {
    padding: 17px 24px;
    margin: 0;
  }
  
  .zhw-game-sidebar .hot-game-item-box {
    margin: 0 24px;
  }
  
  .zhw-game-sidebar .hot-game-item {
    display: block;
    float: left;
    width: 151px;
    margin-right: 12px;
    line-height: 14px;
    padding-right: 3px;
    margin-top: 20px;
    color: #515151;
    position: relative;
  }
  
  .zhw-game-sidebar .hot-game-item:nth-child(-n + 4) {
    margin-top: 0;
  }
  
  .zhw-game-sidebar .no_img:nth-child(-n + 4) {
    margin-top: 20px;
  }
  
  .zhw-game-sidebar .hot-inst-item {
    display: block;
    float: left;
    width: 166px;
    margin-bottom: 20px;
    color: #515151;
    cursor: default;
  }
  
  .zhw-game-sidebar .hot-game-item a,
  .zhw-game-sidebar .hot-inst-item a {
    color: #515151;
  }
  
  .zhw-game-sidebar .hot-game-item a:hover,
  .zhw-game-sidebar .hot-inst-item a:hover {
    color: #fc3737;
  }
  
  .zhw-game-sidebar .instantly-hot-title {
    padding: 16px 24px 26px;
    font-size: 16px;
    font-weight: 700;
    color: #303030;
  }
  
  .zhw-game-sidebar .hot-game-item i {
    width: 40px;
    height: 40px;
    float: left;
    margin-right: 12px;
  }
  
  .zhw-game-sidebar .hot-game-text {
    float: left;
    font-size: 14px;
    color: #515151;
    line-height: 40px;
    width: 110px;
    position: relative;
  }
  
  .zhw-game-sidebar .side-hot-flex {
    display: inline-block;
    width: 50%;
    padding-bottom: 12px;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .zhw-game-sidebar .side-hot-flex.cur .side-hot-toggle {
    display: block;
  }
  
  .zhw-game-sidebar .side-hot-flex.cur .side-hot-type {
    border: 2px solid #fc3737;
    color: #fc3737;
  }
  
  .zhw-game-sidebar .side-hot-flex .side-hot-type {
    position: relative;
    width: 74px;
    text-align: center;
    border: 1px solid #5c5c5c;
    font-size: 12px;
    color: #636363;
    cursor: pointer;
    display: block;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: unset;
    -moz-transition: unset;
    transition: unset;
    height: 27px;
  }
  
  .zhw-game-sidebar .side-hot-flex .side-hot-type:hover {
    border: 2px solid #fc3737;
    color: #fc3737;
  }
  
  .zhw-game-sidebar .side-hot-flex .side-hot-type span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60px;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .zhw-game-sidebar .hot-type-item {
    font-size: 12px;
    color: #ff4e4e;
    margin-right: 16px;
    padding: 5px 16px;
    background-color: #ffe9e9;
    border-radius: 2px;
    cursor: pointer;
    margin-top: 3px;
  }
  
  .zhw-game-sidebar .hot-type-select {
    padding: 20px 0 20px 22px;
  }
  
  .zhw-game-sidebar .hot-type-select .a-text {
    font-size: 14px;
    color: #6f6e6e;
    line-height: 31px;
  }
  
  .zhw-game-sidebar .dist-area-box {
    margin-left: 22px;
    margin-top: 11px;
  }
  
  .zhw-game-sidebar .dist-area-tab {
    height: 28px;
  }
  
  .zhw-game-sidebar .dist-area-top h3 {
    font-size: 16px;
    color: #303030;
    font-weight: 700;
    margin: 0 33px 0 0;
  }
  
  .zhw-game-sidebar .dist-area-tab span {
    line-height: 22px;
    margin-right: 20px;
    cursor: pointer;
    font-size: 12px;
    color: #303030;
    font-weight: 700;
    position: relative;
  }
  
  .zhw-game-sidebar .dist-area-tab span i {
    width: 0;
    height: 2px;
    background-color: #fff;
    position: absolute;
    bottom: -6px;
    left: 50%;
    margin-left: -14px;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
  }
  
  .zhw-game-sidebar .dist-area-tab-on .dist-area-border {
    width: 28px;
    background-color: #fc3737;
  }
  
  .zhw-game-sidebar .dist-area-item {
    font-size: 14px;
    color: #515151;
    width: 145px;
    float: left;
    margin-top: 24px;
  }
  
  .zhw-game-sidebar .dist-area-item a {
    cursor: pointer;
    color: #515151;
  }
  
  .zhw-game-sidebar .w116 {
    width: 116px;
  }
  
  .zhw-game-sidebar .side-hot-msg {
    overflow: hidden;
    font-size: 0;
    margin-bottom: 4px;
  }
  
  .zhw-game-sidebar .side-game-item {
    width: 100%;
    height: 46px;
    cursor: pointer;
    color: #777;
    display: block;
  }
  
  .zhw-game-sidebar .side-item-title {
    height: 100%;
    -webkit-transition: background-color 0.2s;
    -moz-transition: background-color 0.2s;
    transition: background-color 0.2s;
  }
  
  .zhw-game-sidebar .side-game-item em {
    display: none;
    width: 17px;
    height: 100%;
    height: 18px;
    margin: 16px 20px 0 22px;
  }
  
  .zhw-game-sidebar .first_child em {
    margin-top: 14px;
  }
  
  .zhw-game-sidebar .side-game-item .hover_none {
    display: block;
  }
  
  .zhw-game-sidebar .side-item-box {
    height: 48px;
  }
  
  .zhw-game-sidebar .side-item-box.cur .side-item-title {
    color: #fff;
    background-color: #fc3737;
  }
  
  .zhw-game-sidebar .side-item-box.cur .hover_none {
    display: none;
  }
  
  .zhw-game-sidebar .side-item-box.cur .hover_block,
  .zhw-game-sidebar .side-item-box.cur .side-hot-toggle {
    display: block;
  }
  
  .zhw-game-sidebar .side-game-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 46px;
  }
  
  .zhw-game-sidebar .hot-game-item:hover .hot-game-text,
  .zhw-game-sidebar .hot-game-item span:hover,
  .zhw-game-sidebar .hot-inst-item span:hover {
    color: #fc3737;
  }
  
  .zhw-game-sidebar .hot-type-item:hover {
    color: #fff;
    background-color: #fc3737;
  }
  
  .zhw-game-sidebar .dist-area-item a:hover {
    color: #fc3737;
  }
  
  .zhw-game-sidebar .zhw-view-move {
    float: right;
    line-height: 30px;
    padding-right: 15px;
    position: relative;
  }
  
  .zhw-game-sidebar .zhw-view-move a {
    font-size: 12px;
    color: #909090;
  }
  
  .zhw-game-sidebar .zhw-view-move a:hover {
    color: #4d4d4d;
  }
  
  .zhw-game-sidebar .zhw-view-move a.sprite-ico:hover i {
    background-position: -256px -4px;
  }
  
  .zhw-game-sidebar .ml23 {
    margin-left: 23px;
  }
  
  .zhw-game-sidebar .ml25 {
    margin-left: 25px;
  }
  
  .zhw-game-sidebar .ml19 {
    margin-left: 19px;
  }
  
  .zhw-game-sidebar .ml24 {
    margin-left: 24px;
  }
  
  .zhw-game-sidebar .ml20 {
    margin-left: 20px;
  }
  
  .zhw-game-sidebar .mr18 {
    margin-right: 16px;
  }
  
  .zhw-game-sidebar .mr6 {
    margin-right: 6px;
  }
  
  .zhw-game-sidebar .ml6 {
    margin-left: 6px;
  }
  
  .zhw-game-sidebar .pt19 {
    padding-top: 19px;
  }
  
  .zhw-game-sidebar .pb8 {
    padding-bottom: 8px;
  }
  
  .zhw-game-sidebar .pb12 {
    padding-bottom: 12px;
  }
  
  .zhw-game-sidebar .side-hot-flex.pt19 .annive-icon {
    top: 9px;
  }
  
  .zhw-game-sidebar .side-hot-flex.pb8 .annive-icon {
    top: -9px;
  }
  
  .zhw-game-sidebar .side-hot-flex:nth-of-type(odd) .annive-icon {
    right: -2px;
  }
  
  .zhw-game-sidebar .side-hot-flex:nth-of-type(2n + 2) .annive-icon {
    right: 10px;
  }
  
  .zhw-game-sidebar .annive-icon {
    position: absolute;
    background: -webkit-gradient(
      linear,
      right top,
      left top,
      from(#fc1d60),
      to(#fd7b61)
    );
    background: -webkit-linear-gradient(right, #fc1d60, #fd7b61);
    background: -moz-linear-gradient(right, #fc1d60 0, #fd7b61 100%);
    background: linear-gradient(270deg, #fc1d60, #fd7b61);
    color: #fff;
    font-size: 0;
    font-weight: 400;
  }
  
  .zhw-game-sidebar .side-hot-flex .annive-icon {
    position: absolute;
    right: 0;
    padding: 0 2px;
    line-height: 14px;
    border-radius: 6px 1px 6px 1px;
    font-size: 10px;
  }
  
  .zhw-game-sidebar .hot-game-item .annive-icon,
  .zhw-game-sidebar .hot-game-text .annive-icon {
    line-height: 16px;
    font-size: 12px;
    top: 12px;
    padding: 0 3px;
    margin-left: 4px;
    border-radius: 6px 1px 6px 1px;
  }
  
  .zhw-footer {
    margin-top: 80px;
    width: 100%;
    min-width: 1200px;
    background-color: #fff;
  }
  
  .zhw-footer .footer-top {
    padding-top: 48px;
  }
  
  .zhw-footer .footer-top .footer-container {
    width: 1200px;
    margin: 0 auto;
  }
  
  .zhw-footer .footer-introduce {
    float: left;
  }
  
  .zhw-footer .footer-logo {
    width: 110px;
    height: 43px;
  }
  
  .zhw-footer .footer-logo .img {
    width: 110px;
    height: 43px;
    display: block;
  }
  
  .zhw-footer .footer-introduce-txt {
    margin-top: 20px;
    width: 231px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #787878;
  }
  
  .zhw-footer .footer-follow {
    margin-top: 13px;
  }
  
  .zhw-footer .footer-wechat {
    float: left;
    position: relative;
    cursor: default;
  }
  
  .zhw-footer .footer-wechat-logo {
    width: 18px;
    height: 15px;
    float: left;
    vertical-align: middle;
  }
  
  .zhw-footer .footer-wechat-txt {
    font-size: 12px;
    font-weight: 400;
    color: #9b9a9a;
    float: left;
    line-height: 15px;
    margin-left: 8px;
  }
  
  .zhw-footer .footer-wechat-code {
    width: 104px;
    height: 102px;
    display: none;
    position: absolute;
    bottom: 14px;
    -webkit-animation: fadeWaggle 0.3s;
    -moz-animation: fadeWaggle 0.3s;
    animation: fadeWaggle 0.3s;
    left: 0;
  }
  
  .zhw-footer .footer-wechat:hover .footer-wechat-code {
    display: block;
  }
  
  .zhw-footer .footer-weibo {
    margin-left: 32px;
    float: left;
    position: relative;
  }
  
  .zhw-footer .footer-weibo-logo {
    width: 18px;
    height: 15px;
    float: left;
    vertical-align: middle;
  }
  
  .zhw-footer .footer-weibo-txt {
    font-size: 12px;
    font-weight: 400;
    color: #9b9a9a;
    float: left;
    line-height: 15px;
    padding-left: 8px;
    cursor: pointer;
  }
  
  .zhw-footer .footer-weibo-code {
    width: 104px;
    height: 102px;
    display: none;
    position: absolute;
    bottom: 14px;
    -webkit-animation: fadeWaggle 0.3s;
    -moz-animation: fadeWaggle 0.3s;
    animation: fadeWaggle 0.3s;
    left: 0;
  }
  
  .zhw-footer .footer-weibo:hover .footer-weibo-code {
    display: block;
  }
  
  .zhw-footer .footer-menu {
    float: right;
  }
  
  .zhw-footer .footer-line {
    float: left;
    width: 1px;
    height: 130px;
    background-color: #f5f5f5;
    position: relative;
    top: 12px;
  }
  
  .zhw-footer .footer-ul {
    float: left;
    text-align: right;
  }
  
  .zhw-footer .footer-help {
    margin-left: 152px;
  }
  
  .zhw-footer .footer-safe {
    margin-left: 122px;
  }
  
  .zhw-footer .footer-service {
    margin-left: 125px;
  }
  
  .zhw-footer .footer-about {
    margin-left: 90px;
  }
  
  .zhw-footer .footer-about .footer-ul-li:nth-child(3) {
    display: none;
  }
  
  .zhw-footer .footer-ul-title {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: #6a6a6a;
    text-decoration: none;
    line-height: 1;
    margin-bottom: 32px;
  }
  
  .zhw-footer .footer-ul-li {
    display: block;
    font-size: 12px;
    font-weight: 400;
    color: #888;
    text-decoration: none;
    line-height: 1;
    margin-bottom: 16px;
  }
  
  .zhw-footer .footer-bottom {
    margin-top: 72px;
    background-color: #f6f6f6;
  }
  
  .zhw-footer .footer-bottom .footer-container {
    width: 1200px;
    margin: 0 auto;
    height: 60px;
    line-height: 60px;
  }
  
  .zhw-footer .footer-bottom .footer-new-container {
    width: 1200px;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #787878;
    text-align: center;
  }
  
  .zhw-footer .footer-bottom .footer-new-container .copy-writing + .copy-writing {
    padding-top: 2px;
  }
  
  .zhw-footer .footer-bottom .footer-new-container .copy-writing-img {
    padding-top: 10px;
    line-height: 40px;
  }
  
  .zhw-footer .footer-bottom .footer-new-container .copy-writing-img .cyxyv-url {
    margin-left: 30px;
  }
  
  .zhw-footer .footer-bottom .footer-new-container a {
    font-size: 12px;
    font-weight: 400;
    color: #787878;
    text-decoration: none;
  }
  
  .zhw-footer .footer-bottom-verify {
    float: left;
  }
  
  .zhw-footer .footer-bottom-verify img {
    width: 61px;
    height: 22px;
    vertical-align: middle;
  }
  
  .zhw-footer .footer-bottom-txt {
    margin-left: 0;
    float: left;
  }
  
  .zhw-footer .footer-bottom-txt a {
    font-size: 12px;
    font-weight: 400;
    color: #787878;
    text-decoration: none;
  }
  
  .zhw-footer .footer-bottom-txt .cyxyv-url img {
    margin-left: 0;
    width: 88px;
    position: relative;
    top: -2px;
    vertical-align: middle;
  }
  
  .zhw-footer .footer-bottom-phone {
    float: right;
  }
  
  .zhw-footer .footer-bottom-phone-icon {
    float: left;
  }
  
  .zhw-footer .footer-bottom-phone-icon img {
    width: 11px;
    height: 11px;
    vertical-align: middle;
  }
  
  .zhw-footer .footer-bottom-phone-txt {
    margin-left: 2px;
    font-size: 12px;
    font-weight: 400;
    color: #9b9a9a;
    float: left;
  }
  
  #think_page_trace_open,
  .zhw-analytics {
    display: none;
  }
  
  .zhw-crumbs {
    font-size: 12px;
  }
  
  .zhw-crumbs i {
    width: 9px;
    margin: 0 6px;
    font-style: normal;
    color: #929292;
  }
  
  .zhw-crumbs a {
    color: #666;
  }
  
  .zhw-crumbs a:hover {
    color: #fc3737;
  }
  
  .zhw-sidebar {
    width: 80px;
    height: auto;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 6px;
    position: fixed;
    right: -80px;
    bottom: 40px;
    background-color: #fff;
    border-radius: 2px;
    -webkit-transition: right 0.5s 0.2s;
    -moz-transition: right 0.5s 0.2s;
    transition: right 0.5s 0.2s;
    z-index: 199;
  }
  
  .zhw-sidebar.show {
    right: 25px;
  }
  
  .zhw-sidebar.zhw-sidebar-sm {
    right: 3px;
  }
  
  .zhw-sidebar > ul {
    height: auto;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: height 1s ease 0.2s;
    -moz-transition: height 1s 0.2s ease;
    transition: height 1s ease 0.2s;
  }
  
  .zhw-sidebar > ul > li {
    width: 76px;
    cursor: pointer;
    text-align: center;
    margin-bottom: 12px;
    position: relative;
  }
  
  .sidebar-down-app .down-app-qr-code {
    position: absolute;
    left: -155px;
    top: -22px;
    visibility: hidden;
  }
  
  .zhw-sidebar > ul > li > a > strong {
    font-size: 12px;
    color: #aaa;
    -webkit-transition: all 0.6s;
    -moz-transition: all 0.6s;
    transition: all 0.6s;
    font-weight: 500;
  }
  
  .zhw-sidebar > ul > li > a > span {
    display: block;
    width: 76px;
    height: 35px;
    text-align: center;
    line-height: 35px;
  }
  
  .zhw-sidebar > ul > li > strong {
    font-size: 12px;
    color: #aaa;
    -webkit-transition: all 0.6s;
    -moz-transition: all 0.6s;
    transition: all 0.6s;
    font-weight: 500;
  }
  
  .zhw-sidebar > ul > li > span {
    display: block;
    width: 76px;
    height: 35px;
    text-align: center;
    line-height: 35px;
  }
  
  .zhw-sidebar > ul > li > a {
    font-size: 12px;
    color: #aaa;
  }
  
  .sidebar-kf span i {
    width: 23px;
    height: 20px;
    background-position: 0 -2px;
  }
  
  .sidebar-help span i {
    width: 26px;
    height: 22px;
    background-position: -213px -148px;
  }
  
  .sidebar-issue span i {
    width: 24px;
    height: 24px;
    background-position: -54px 0;
  }
  
  .sidebar-down-shq span i {
    width: 22px;
    height: 19px;
    background-position: -44px -28px;
  }
  
  .sidebar-collect-hb span i {
    width: 26px;
    height: 25px;
    background: url(data:image/png;base64,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)
      no-repeat;
  }
  
  .sidebar-collect-zj span i {
    width: 24px;
    height: 24px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo4NzdlMTkxNi1iYmEzLWQwNDYtYTNjNi1jMzY0Y2JkM2QzZmYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MUVDNzMwQjhBQzY4MTFFOUExMENBMkQ3NEFFOTJGQUMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MUVDNzMwQjdBQzY4MTFFOUExMENBMkQ3NEFFOTJGQUMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ZDhiNmJlNGItZWQxZi1mMDQzLWJlNWUtNjA2ZTBiZTExYTc2IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjg3N2UxOTE2LWJiYTMtZDA0Ni1hM2M2LWMzNjRjYmQzZDNmZiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhtAajIAAAH+SURBVHjatJbLLwNRFManQ9iIlQohSszGIzb8A026FEE8WrEVSyxaIl02aBNt7C0Rb/4CtZMQOxILjypCsOzKq74j30iNaTupcZJf7tzOPd+Ze++559bh8XiUHFYHhoAbNAMneAW34BrsgzVwlU3AkSWACM+BAVCk5LYPBpkCSeNL1cShC5wAH3gHm2AYNIBSUA6a+Ju8e+PYU7Y/rNjQHwNRBt4FfnBuGPMCzsgy0EAE9LBfBWJmMxjkizSYpMO5kt9kTC99ZLnmqfVjBrLmi7InYJpf9GWhUOiXYjAYNAsUof8ctQ5kT/QZzIIysJ0pXoCFwRa1wvoSuYCXazuewzlN8tkEtSQDXSrFVWbEjfJ3E40NanpVHiKFWWOX6VpuCdDKzqGNAY7YtkoWVbDzYNXbmFkmWXXP1pl5DkqUfzAJ8Mznaos+aQNmpms9qawhYm02fngH2xMJsMdOdx4nRxbMrIdtXMp1PR4uWBU1G85CLfUkgRplBgmwzk2O2rA8MWqJZkLPIqmEKdAHAn8QD1AjRc3vci030QizYqbAIAH6pqmVNN4HqyxUjoyqqFkQ1jg2TD0/tUxvtAVe4Eu8RDpZuHbAMbjjuBrQzmzp55rLsoyCFauXfpglV7Vw6a9zzZP57mQlY098dNL/trSASr5/5AGNU/wyW/RPAQYAaV14PodIpYkAAAAASUVORK5CYII=)
      no-repeat;
  }
  
  .sidebar-down-app span i {
    width: 19px;
    height: 23px;
    background-position: 0 -26px;
  }
  
  .sidebar-suit span i {
    width: 21px;
    height: 21px;
    background-position: -188px -2px;
  }
  
  .sidebar-contact span i {
    width: 21px;
    height: 21px;
    background-position: -152px -148px;
  }
  
  .sidebar-top span i {
    width: 12px;
    height: 19px;
    background-position: -110px -2px;
  }
  
  .zhw-sidebar > ul > li:hover span {
    -moz-animation: barJump ease 1.5s 1;
    animation: barJump 1.5s ease 1;
    -webkit-animation: barJump 1.5s ease 1;
  }
  
  .sidebar-kf:hover span i {
    background-position: -27px -2px;
  }
  
  .sidebar-help:hover span i {
    background-position: -244px -148px;
  }
  
  .sidebar-issue:hover span i {
    background-position: -82px 0;
  }
  
  .sidebar-down-shq:hover span i {
    background-position: -72px -28px;
  }
  
  .sidebar-collect-hb:hover span i {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAADs0lEQVRIS62WT2hcVRTGv29mJCaS2oBdqqkGsWLTLqRpEpMmc28SRougQhFEi6A7BRG0iIuKiAT/IEVwUReKYi2mUoubktz78gzaNMjU2tIsRKyKWQjKqFgXmffeJ7dkwjROOhPo3b37zjm/d879zrmP2OAyxtwFoNd7f3QjrtyIcbC11s4A2CFpm/f+j1b9NwSy1j4E4LOV4B865/Zfc1B/f397R0fHIsluSVoBTHjvQ4ZNV8sZWWsPAngZwFlJn5J8DcCPlUple7lc/rcZqSVQsVi8NZfLLUpqJzmcJMnpQqHwDYCdkt7w3r9wTUDW2mMAHgZwxDn3aAg6NjZ2j6TTAEIZdznnvr0abN2MhoaGtrS1tY1KmiD5hKRLku6MomipFtAY8xbJ5wD8JskBOEVyvqur69zU1FRaD14FDQ4Odra3tw8DMJKKJLcDyNUZv+icm6x3Hh8fvyHLsnMAbqvfl/QPgFDaeZKnkiRZ4IqaTgAYIXldnUM44K+yLIvy+byfmZk5AyBrUJ6cMeZuSQMkd5MckNRD8nISKwrdd/nBWns/gM8BFAB8TfKlpaWl+cXFxeVmh9zovbV2t6S58OGSXvHeH1wtnbX2aQDvAFiWtLfV/lgL6uvr29TZ2RlEsk3Sce99EJGuEIO19nUAzwP4O03T4dnZ2e/qAyV9fbVGXd0uLCzUxwhlPEFyL4DzSZIMxHEczgtrVUdjzBGSjwAI6hpwzv1Si9oMZIyZJHlA0u/VanXX3NzcxZrv/+Td09PT1t3dfTKIQ9KFNE3vjeP4z2ZnZa3dJ+koySqACedc3FDe9ZsjIyObC4VCUNnWLMseiKLoixZAbwN4FsCbzrlQ/ivWug1rjPkyjJssy/ZEUTTXDFQsFg/kcrnJ9UbS1UBnSe5I03TnWlE0ghpj9pP8AMBHzrnHN5LRxXAlJEmyNY7jn2qO1tobSe4h6aenpy/V9kdHRyfy+fxJSTPe+/GWQdbaCoDNSZJ0BTEYY+4g+Yyk8OWdAP4C8EmWZe9FUXTGGNNLMrTDeedcb6sgWmurksKsu49kaOZSmH1hpJD8AUBPrT0klUkeB/BqkLb3fktLoFKptKlarYYvrl9h9n2cpumh2dnZC+EnRdKTJB8jeVOdYVapVK4vl8tB5quroRistbcA+DlYSfoVwLsADjf6GSmVSm3Ly8sPAniK5EjIOkmSm+M4Dn5NQeGKOCzpUJqmx+I4TprJO7wvFou3AwhZvu+9/74paOUeanQltMJraPMfw4ynGm3SIukAAAAASUVORK5CYII=)
      no-repeat;
  }
  
  .sidebar-collect-zj:hover span i {
    background: url(data:image/png;base64,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)
      no-repeat;
  }
  
  .sidebar-down-app:hover span i {
    background-position: -22px -26px;
  }
  
  .sidebar-down-app:hover .down-app-qr-code {
    left: -135px;
    visibility: visible;
    -webkit-transition: all 0.6s;
    -moz-transition: all 0.6s;
    transition: all 0.6s;
  }
  
  .sidebar-suit:hover span i {
    background-position: -213px -2px;
  }
  
  .sidebar-contact:hover span i {
    background-position: -178px -148px;
  }
  
  .sidebar-top:hover span i {
    background-position: -126px -2px;
  }
  
  .zhw-sidebar > ul > li:hover strong {
    color: #3c3c3c;
  }
  
  .zhw-sidebar > ul > li:hover .unReadNum {
    color: #fff;
  }
  
  .unReadNum {
    display: none;
    position: absolute;
    top: 0;
    right: 6px;
    min-width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    color: #fff !important;
    background-color: #fc3737;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 400;
  }
  
  .zl-scrollContentDiv {
    position: relative !important;
    width: 100% !important;
    height: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0;
    left: 0;
  }
  
  .backflow {
    position: absolute;
    right: 122px;
    top: 2px;
    width: 78px;
    height: 28px;
    cursor: pointer;
    background-size: 78px 28px;
    background-image: url(https://zuhaowan.zuhaowan.com/static/www/huodong/backflow/img/backflow-icon.png);
    background-repeat: no-repeat;
    z-index: 95;
    display: none;
  }
  
  .backflow:hover .backflow-box {
    display: block;
  }
  
  .backflow .backflow-box {
    width: 304px;
    position: absolute;
    left: -198px;
    top: 40px;
    z-index: 25;
    padding: 44px 12px 12px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 8px;
    display: none;
    -webkit-box-shadow: 0 12px 24px 0 hsla(0, 0%, 84.7%, 0.5);
    box-shadow: 0 12px 24px 0 hsla(0, 0%, 84.7%, 0.5);
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#fd3636),
      to(#fff2d4)
    );
    background: -webkit-linear-gradient(top, #fd3636, #fff2d4);
    background: -moz-linear-gradient(top, #fd3636 0, #fff2d4 100%);
    background: linear-gradient(180deg, #fd3636, #fff2d4);
  }
  
  .backflow .backflow-box:before {
    content: "";
    position: absolute;
    top: -14px;
    left: 0;
    right: 0;
    height: 22px;
    z-index: 100;
  }
  
  .backflow .backflow-box:after {
    content: "";
    position: absolute;
    top: -7px;
    left: 205px;
    width: 39px;
    height: 8px;
    background: url(https://zuhaowan.zuhaowan.com/static/www/huodong/backflow/img/arrow.png)
      no-repeat;
    background-size: 100% auto;
  }
  
  .backflow .backflow-box .backflow-bg {
    position: absolute;
    width: 304px;
    left: 0;
    top: 0;
  }
  
  .backflow .backflow-title {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffeee1;
    line-height: 17px;
    margin: 0 0 7px 9px;
  }
  
  .backflow .backflow-hd,
  .backflow .backflow-prize {
    position: relative;
    z-index: 10;
  }
  
  .backflow .backflow-prize + .backflow-hd {
    margin-top: 8px;
  }
  
  .backflow .prize-list {
    background: #fff;
    border-radius: 8px;
    cursor: default;
  }
  
  .backflow .prize-list .item {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    height: 56px;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 0 20px 0 16px;
  }
  
  .backflow .prize-list .txt {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 0;
    overflow: hidden;
  }
  
  .backflow .prize-list .btn {
    min-width: 54px;
    height: 22px;
    background: #fd3636;
    border-radius: 11px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 6px;
    font-size: 10px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    line-height: 22px;
    text-align: center;
    cursor: pointer;
  }
  
  .backflow .prize-list .btn-exp {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .backflow .prize-list .prize-img {
    width: 41px;
    height: 41px;
    margin-right: 3px;
  }
  
  .backflow .prize-list .prize-tit {
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 700;
    color: #75111e;
    line-height: 17px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .backflow .prize-list .prize-desc {
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #864e55;
    line-height: 14px;
    opacity: 0.6;
  }
  
  .nsr-countdown {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999999;
    background: rgba(0, 0, 0, 0.7);
    display: none;
  }
  
  .nsr-countdown span {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  
  .nsr-countdown span i {
    font-size: 120px;
    color: #fff;
    font-family: arial;
    font-style: italic;
    font-weight: 700;
    -webkit-animation: showPolo 0.3s;
    -moz-animation: showPolo 0.3s;
    animation: showPolo 0.3s;
  }
  
  .nsr-replay-input {
    padding: 10px 20px 0;
  }
  
  .nsr-replay-input input {
    padding: 5px;
    float: left;
    margin-right: 20px;
    width: 150px;
  }
  
  .nsr-replay-input textarea {
    float: left;
    width: 700px;
    padding: 10px;
    resize: none;
  }
  
  .nsr-replay-input textarea,
  .unlockHbBox {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .unlockHbBox {
    position: fixed;
    width: 104px;
    height: 118px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/unlockHb/newhbHov.7ac18e4.png)
      no-repeat;
    background-size: 100%;
    bottom: 20px;
    right: 210px;
    z-index: 100;
    padding-top: 72px;
    display: none;
    cursor: pointer;
  }
  
  .unlockHbBoxClose {
    position: absolute;
    height: 32px;
    width: 32px;
    background: url(data:image/png;base64,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)
      no-repeat;
    background-size: 100%;
    top: -2px;
    right: -2px;
  }
  
  .unlockHbBoxBtn {
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    padding-right: 5px;
  }
  
  .HbtaskBox {
    position: fixed;
    width: 104px;
    height: 118px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/unlockHb/HbtaskBox.aa89bbf.png)
      no-repeat;
    background-size: 100%;
    bottom: 20px;
    right: 210px;
    z-index: 999;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 10px;
    cursor: pointer;
    display: none;
  }
  
  .HbtaskBoxClose {
    position: absolute;
    height: 32px;
    width: 32px;
    background: url(data:image/png;base64,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)
      no-repeat;
    background-size: 100%;
    top: -2px;
    right: -2px;
  }
  
  .HbtaskMoney {
    font-size: 12px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: 700;
    color: #fa5c93;
    text-align: center;
    margin-left: 28px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 48px;
    height: 30px;
    line-height: 30px;
  }
  
  .HbtaskMoney span {
    font-size: 20px;
  }
  
  .HbtaskTime {
    font-size: 14px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: 700;
    color: #fff;
    margin-top: 30px;
    text-align: center;
    margin-left: 10px;
    width: 80px;
    height: 26px;
    line-height: 26px;
  }
  
  .getTaskShade {
    background: transparent !important;
    -webkit-box-shadow: 0 0 0 0;
    box-shadow: 0 0 0 0;
  }
  
  .getTaskShade .layui-layer-setwin {
    top: 410px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  
  .getTaskShade .layui-layer-setwin .layui-layer-close {
    right: 47px;
    width: 32px;
    height: 32px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAh1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9qkf8RAAAALHRSTlMAAQUGBwkQFBUZGhscMThAQkpMTk9Ua3t9gISSqLy/xcvQ293o6evt8fj6/lH4P/wAAAEhSURBVDjLjVPbdoMgEIRYbU1NSWxjRNN4iZqq8//fVxCCxNpDeFgPzMjOLLuEPL82cV60fd8WebxZgQPewayOB0v82ABVykLPC1laAc3xAabZiHI/7/clxoxa+BlDQh/+SAac55MMN7bMyW7ITP5xYH9Vs2HUOoIGyZrtBI3ywlHSNQItwaf6dFD63/lWIbuTr7ygkxWLURF9Ux3J78cPPtVJhVjEHKnabuuJIfDvF3WSIhexwN1CJBkS9+9GUIjYIiQz42rhJEQrYg/PCI+uwMXgxEO/IIj7tVKLYKUQ+KW2GCrFLHLSF1kMJdLY3Cl9kvFq2zSFOmn9gnGwC2VK7X/p+rwdqF1q52O5n9vZMO6Wczets+3dg/PE6LmH97/1C1YYKM/F2S5PAAAAAElFTkSuQmCC);
  }
  
  .getTask {
    height: 426px;
    width: 260px;
    display: none;
  }
  
  .getTaskBg {
    width: 260px;
    height: 338px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/unlockHb/newHbDialog1.10a187f.png)
      no-repeat;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 113px;
  }
  
  .taskBox {
    color: #fff;
    font-size: 12px;
    text-align: center;
  }
  
  .taskBoxMoney {
    color: #ffe75d;
  }
  
  .taskMoney {
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    color: #fff;
    margin-top: 84px;
  }
  
  .taskMoney span {
    font-size: 26px;
  }
  
  .getTaskBtn {
    width: 251px;
    height: 98px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/unlockHb/dialogBtn.ab6c8cd.png)
      no-repeat;
    background-size: 100%;
    position: absolute;
    top: 281px;
    left: 7px;
    cursor: pointer;
  }
  
  .Unlock {
    width: 268px;
    height: 323px;
    background: url(//zuhaowan.zuhaowan.com/static/www3.0/dubhe/common/img/unlockHb/newHbDialog2.3140df6.png);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 88px;
    display: none;
  }
  
  .UnlockBox {
    background: transparent !important;
    -webkit-box-shadow: 0 0 0 0 !important;
    box-shadow: 0 0 0 0 !important;
  }
  
  .UnlockBox .layui-layer-close {
    right: 106px;
    top: 347px;
    width: 32px;
    height: 32px;
  }
  
  .UnlockBox .layui-layer-close,
  .UnlockBox .layui-layer-close:hover {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAh1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9qkf8RAAAALHRSTlMAAQUGBwkQFBUZGhscMThAQkpMTk9Ua3t9gISSqLy/xcvQ293o6evt8fj6/lH4P/wAAAEhSURBVDjLjVPbdoMgEIRYbU1NSWxjRNN4iZqq8//fVxCCxNpDeFgPzMjOLLuEPL82cV60fd8WebxZgQPewayOB0v82ABVykLPC1laAc3xAabZiHI/7/clxoxa+BlDQh/+SAac55MMN7bMyW7ITP5xYH9Vs2HUOoIGyZrtBI3ywlHSNQItwaf6dFD63/lWIbuTr7ygkxWLURF9Ux3J78cPPtVJhVjEHKnabuuJIfDvF3WSIhexwN1CJBkS9+9GUIjYIiQz42rhJEQrYg/PCI+uwMXgxEO/IIj7tVKLYKUQ+KW2GCrFLHLSF1kMJdLY3Cl9kvFq2zSFOmn9gnGwC2VK7X/p+rwdqF1q52O5n9vZMO6Wczets+3dg/PE6LmH97/1C1YYKM/F2S5PAAAAAElFTkSuQmCC)
      no-repeat;
  }
  
  .countDownTips {
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #333;
    text-align: center;
  }
  
  .countDownBox {
    text-align: center;
    color: #f63397;
    margin-top: 11px;
  }
  
  .countDownBox span {
    height: 32px;
    width: 24px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAgBAMAAAD6cKULAAAAMFBMVEUAAACGAEP4NpqIAEX2NJiHAEX2MpeHAEWYCFH3M5eHAEWXCFHSI3zuL5HwMJL2M5dQMS4AAAAACnRSTlMAJiatre7u8fHx7PN8KgAAAEhJREFUGNNjYPL8DwVTFBjU/sNBEoM/gvOFYT6C85PhPxIY5aBz3iPY/xjOIzh/GHoRnBsM1udg7DebGURXwUEgA6M5jF0sAAA2JGv48N53xgAAAABJRU5ErkJggg==)
      no-repeat;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  
  .countDownBox em,
  .countDownBox span {
    display: inline-block;
    line-height: 32px;
    margin-right: 6px;
  }
  
  .countDownBox em {
    font-style: normal;
    font-weight: 700;
  }
  
  .Unlock .taskBox {
    color: #333;
    font-size: 12px;
    margin-top: 16px;
  }
  
  .taskBoxMoney {
    color: #f63397;
    font-weight: 700;
  }
  
  .taskGetHbList {
    width: 230px;
    height: 80px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOYAAABQCAMAAAA6J/nhAAABBVBMVEUAAAD/VVX/kpL/gID/jIz/kIv/jI//io3/jY3/jon/jYr/iYz/i47/jIr/jor/iY7/iY3/i4v/jYr/iI//h47/iY7/h5D/iI7/ioz/jIv/hpD/h5D/h4//i4v/hJL/hZL/h5D/iI7/baT/baX/bqP/bqT/b6H/b6L/b6P/cKH/cKL/cKf/caD/caH/cp//cqD/c53/c5//dJ3/dJ7/dZ3/dpz/dp7/d5v/d5z/eJv/eZn/eZr/epj/epn/eqz/e5j/e5n/fJf/fJj/fZb/fZf/f5X/gJP/gZP/gpL/g5L/hJD/hY//hZD/ho7/ho//h4//i4r/i4v/pMT/0t7/1eD/5+r/7u7mXWKHAAAAInRSTlMAAwcIWVxdXl5hYpWVmZmtr7Cx4eLi4+Pl5fX19vf+/v7+Hk056wAAAcFJREFUeNrt3FdWwlAUheFNs/eO3XsuhKKJ0aBijEHBgkZUSuY/FB906Qh8Oex/Bt86z/sAAJCbWSnufXwq62OvuDKTw2+F4ttj5yaKrlUVRTedx7di4QeZWThqX7lVR2FV96p9tJABAMwnoWeNEYUZY70wmQeAwmGzphP5Da01DwtAbis+MSL1/mCUKms06NdFzEm8lcN099SK3A5TlQ1vRexpdxrLd1UjdaXKNB3WxVTvlrF5aUX6qdr6IvZyE7sNKzLQyxyI2MYuXgMrMtLLHInY4BXJmRVJFSdizxIkgX5mQCaZZJJJJplkkkkmmWSSSSaZZJJJJplkkkkmmWSSSSaZZJJJJplkkkkmmWSSSSaZZJJJJplkkkkmmWSS+Z/Ml3FgvozLNcdkPLXdqBjdUzhTaWxjvVk2uoeNptxcx9K9Z43mmaqx3v0Spp6CWknz6LhUC56mkN2IfadktE7ITcnx440skN8PfUfv3wPHD/fzADD3HAXH5YpVWKV8HETPc9/POmYP2uHFue+6nqpc1z+/CNsHs5mfryT5te5DJ25FLVVFrbjz0F3L/72YyU4uru703nuqeu/trC5OZAEAX/QnZIBDsZomAAAAAElFTkSuQmCC)
      no-repeat;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 16px;
    margin: 12px auto 0;
    text-align: center;
  }
  
  .taskGetHbItem {
    display: inline-block;
    width: 44px;
    height: 52px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAA0CAYAAADxAdr3AAAEPklEQVRoQ9VaS4sUSRD+osfDnhb8E4MnZZdFRAQVFRFZFhREREREFNGDV3+BP0CYFsF/oILXxauPEUXxINo24/uBr3moXd3tVIZUd1V2dVZmRWbVqDN1ajoj4vsyMh6ZVUlYwofPNbegwVcZ+DMxy4ZtcmFlghYBAhYAXAOvOkOnjrW0CE/fnwTFZ8G8HSlgyFx4dhbcbgPKpAnAJGKIUDrOFtWMAxFmiVZtGIgOyCK+BfDqEJKZLH/8BG7PAGWIIYazCRqebxCuDAnfvnsZzHtCbGrZd+/BM8+WjGsZByIspB6+M18pDF6+BT97WWmeVZUywiXRYzfNT1+BX7ypiltZL5wwM9ST5+DX76VcKpAyQ1MnlIO+zYthhBOyD2fA7z5V9lBdRX/CSkE9aIM/zNXFrKXvR3gxhrr3BPw5qeG/95EJ9xeh7rTA81+rMy3pZAOj0ngOuZQw976Dpx+Bv0RDFVctMTqZFkt/ZJ1M4zoImn3HpuckzJ0e1M3H4E7XTTRl4Mp+XUYy4ql8YY+RtWbXGuYUrIQTj6obj8FR32pCKk/BRd054yJ8gTDPfYO63kISDsvxGSPMH78gvt4CvsfLkeuAkybMb+cQ32gDsVq2ZDVhdel/jm/OAGp5kx0QXjzdPKLAF50lq8TfVZMvIMcK6NQ/1VQgHq+kRv0Mzvq6QVWCT/2TU7+cT535UP9ECWHPzuZsrd6nUMcUbMfD/vEpdh5vXYASEWnc5BeAQ/2jASHhyBadAUYLNltz6DyKGQdQ70iRcJ0sLotPndnCsb4Mn3qHAzxcJ1uWSJd6h1Ya4YMrjfCBlUZ4/4iw1EGEV2RmUdBRK7XwTNAHn7r7poy+LB4wbNWm9AQl5ZvkiLw+dfdOccE1Lgvm/74NwFfOdRjN/U/dPblOZxZK1xYutANI8gWi7kpM3f8SDwuV3PRQaGeR1jwAn7r/elQJJ2AocymaHeM5fIp2j5KuuHLVCEl2/Pc6RXyKdnl4uKJjfoYaRTtDCIvBmHKUKmrVqRAo2pEQlohUBfDV88enaFuIh6uWi2q5YJsuRVubLH9RG19iqay6/erqPJLF0ThFm3Mhkb4+1MOpfX2ozsq10VAoDSnzrJX9P9orpJaNU7EOSQ986myyhIS5gvq95zigbjjZBHTHMgyYncw8U0mRlsOnzsZ80hlLY76g1cMOOde4mNSOGLfgU2eDrUq4NnzSRlGaiGRX3iVRZ32SdCE70rxR/5411PJPLnviEujbP0lrtmdv8YXFuBmXnlR9peQsJGnOIHX+bi7BJ+1yz40CaVxuVF2kKY7GKfqrOa+YB/cbskc2JC1tvVh14TeSj+OdtecvM8wv+b6E/D0TJmnHJ9AV6q67MBnHyV0JVLorEUaklvTsxMTE8IJHd82FSTWhznJyG4WH118Gj3SGk/BdZzSXnt2xC0R0rRE3zvzx6FjrB5Uk607LSyDpAAAAAElFTkSuQmCC)
      no-repeat;
    background-size: 100% 100%;
    text-align: center;
    color: #fff;
    line-height: 52px;
    position: relative;
    font-size: 12px;
    margin-right: 21px;
  }
  
  .taskGetHbItem:last-child {
    margin-right: 0;
  }
  
  .taskGetHbItem span {
    font-size: 22px;
  }
  
  .taskGetHbItemNum {
    position: absolute;
    top: -4px;
    left: 27px;
    background: #ff0e64;
    line-height: 0.678rem;
    padding: 2px 7px;
    border-radius: 7px;
  }
  
  .taskGetHbTip {
    color: #333;
    font-size: 12px;
    text-align: center;
    margin-top: 10px;
  }
  
  .cate_expand {
    height: 100% !important;
  }
  
  .product_yuanjia {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0 4px;
    height: 100%;
    background: linear-gradient(139deg, #ffeae0, #ffe1d3);
    border-radius: 4px 0 0 4px;
    font-size: 12px;
    font-weight: 400;
    color: #8e301d;
  }
  </style>
  